export default {
    "en": {
        "achievement": {
            "achievement": "Achievement",
            "achievements": "Achievements",
            "overview_description": "List of all the available achievements",
            "select_campaign": "Select Campaign",
            "go_to_achievements": "Go to achievements",
            "properties": {
                "name": "Name",
                "once": "Once",
                "score": "Score",
                "award": "Award",
                "is_secret": "Secret",
                "image": "Image",
                "image_select": "Select image"
            },
            "time": {
                "today": "today",
                "yesterday": "yesterday",
                "two_days_ago": "two days ago",
                "this_week": "this week",
                "last_week": "last week",
                "two_weeks_ago": "two weeks ago",
                "three_weeks_ago": "three weeks ago",
                "four_weeks_ago": "four weeks ago",
                "five_weeks_ago": "five weeks ago"
            },
            "status": {
                "status": "Status",
                "playing": "Playing",
                "completed": "Completed",
                "not_completed": "Collect all achievements!",
                "last_achievement": "Last achievement",
                "no_last_achievement": "You have not yet achieved any achievement"
            },
            "actions": {
                "grant": {
                    "failed": "Unable to grant the achievement"
                },
                "enable": {
                    "button": "Enable"
                },
                "disable": {
                    "button": "Disable",
                    "action": "Disable achievement",
                    "confirm": "Are you sure you want to disable this achievement? This will remove all customisations made to this achievement."
                }
            },
            "validations": {
                "not_found": "Achievement not found"
            },
            "organisation_enabled": {
                "label": "Enabled achievements",
                "description": "These achievements are enabled by default when creating campaigns for this organisation."
            },
            "organisation_available": {
                "label": "Available achievements",
                "description": "Choose the achievements you want to enable by default for this organisation."
            },
            "game_enabled": {
                "label": "Enabled achievements",
                "description": "These achievements are enabled for this campaign."
            },
            "game_available": {
                "label": "Available achievements",
                "description": "Choose the achievements you want to enable for this campaign."
            },
            "configurations": {
                "global": {
                    "label": "Global configuration",
                    "description": "These configurations are applied to the entire application."
                },
                "general": {
                    "label": "General configuration",
                    "description": "General configuration for the achievement"
                },
                "custom": {
                    "label": "Custom properties",
                    "description": "Properties specific to this achievement that will alter when it is awarded."
                },
                "is_secret": {
                    "label": "Secret achievement",
                    "help": "The achievement will not be shown unless awarded."
                },
                "once": {
                    "label": "Can only be awarded once"
                },
                "score": {
                    "label": "Bonus score to be awarded"
                },
                "name": {
                    "label": "Name"
                },
                "description": {
                    "label": "Description",
                    "help": "Use the identifiers next to the custom properties to replace them in the description."
                }
            }
        },
        "answer": {
            "answer": "Answer",
            "answers": "Answers",
            "properties": {
                "correct": "Correct",
                "correct_answer": "Correct answer",
                "correct_answers": "Correct answers",
                "correct_answer_description": "This is the correct answer of to the question",
                "possible_answers": "Possible answers",
                "provided_answer": "Provided answer"
            },
            "actions": {
                "create": {
                    "action": "Add answer",
                    "success": "Answer created",
                    "failed": "Unable to save the answer"
                },
                "update": {
                    "action": "Edit answer",
                    "success": "Answer updated",
                    "failed": "Unable to update the answer"
                },
                "delete": {
                    "action": "Remove answer",
                    "confirm": "Remove the answer to the question. The answer will be removed immediately. Are you sure you want to continue?",
                    "success": "Answer removed",
                    "failed": "Unable to remove the answer"
                },
                "restore": {
                    "action": "Restore answer",
                    "confirm": "When restoring the answer, the answer will be visible immediately. Are you sure you want to continue?",
                    "success": "Answer restored",
                    "failed": "Unable to restore the answer"
                }
            },
            "validations": {
                "invalid_answer_provided": "Invalid answer provided"
            }
        },
        "api_token": {
            "api_tokens": "API tokens",
            "api_token": "API token",
            "overview_description": "Manage the API tokens of connected apps",
            "not_expiring": "No expiration date",
            "none_assigned": "There are no assigned API tokens.",
            "properties": {
                "name": "Name",
                "expires_at": "Expires at",
                "created_by": "Created by",
                "is_global": "Global token",
                "is_global_description": "A global token can be used to access the resources of all organisations.",
                "organisations": "Organisations"
            },
            "actions": {
                "create": {
                    "success": "API token created",
                    "failed": "Unable to create the API token"
                },
                "update": {
                    "action": "Edit API token",
                    "success": "API token updated",
                    "failed": "Unable to update the API token"
                },
                "delete": {
                    "action": "Remove API token",
                    "confirm": "When removing the API token, the application with this API token loses access immediately. Are you sure you want to remove this API token?",
                    "success": "API token removed",
                    "failed": "Unable to remove the API token"
                },
                "show": {
                    "failed": "Unable to show the API token"
                },
                "generate": {
                    "failed": "Unable to generate the API token"
                },
                "sync": {
                    "action": "Update organisations",
                    "success": "Organisations of the API tokens are updated",
                    "is_global": "Organisations of a global API token cannot be updated"
                }
            },
            "validations": {
                "organisation_not_accessible": "The organisation is not accessible",
                "user_not_accessible": "The user is not accessible",
                "module_session_not_accessible": "The module session is not accessible",
                "take_away_session_not_accessible": "The Take Away session is not accessible"
            }
        },
        "app_score": {
            "actions": {
                "create": {
                    "failed": "Unable to update the app score"
                }
            },
            "scores_filled_in": "Both scores are already filled in",
            "finished": {
                "start_again": "Start again",
                "finish_workout": "Finish workout",
                "score_achieved": "Score achieved",
                "text": "Outstanding Effort! Ready for the next workout or aiming to beat your score?"
            }
        },
        "auth": {
            "email": "E-mail address",
            "password_field": "Password",
            "password_label": "Enter Your Password",
            "register": {
                "register": "Register",
                "description": "Create an account for :app. By creating an account your progress will be tracked and available everywhere you log in.",
                "no_account": "No account?",
                "no_account_description": "When you haven't got an account, you can <a href=\":link\">here<\/a>.",
                "already_has_account": "Do you already have an account?",
                "not_allowed": "Registration not allowed",
                "not_allowed_description": "Sorry, but this organisation has disabled registration. Ask you instructor for an invite.",
                "register_not_allowed": "Registration not allowed",
                "register_not_allowed_description": "Sorry, but this organisation has turned off registration. Please ask your instructor for an invitation."
            },
            "reseller": {
                "not_allowed": "Organisation isn't a reseller",
                "not_allowed_description": "Sorry, but this organisation has no reseller permissions. Contact your accountmanager for reseller permissions."
            },
            "demo": {
                "play": "Play without logging in",
                "description": "If you play without logging in, your score will not be saved. You can register as a player and your score will be saved.",
                "description_no_registration": "Get to know a selection of games in the app. If you play without logging in, your scores will not be saved."
            },
            "login": {
                "login": "Login",
                "remember_me": "Remember me",
                "required": "You need to be logged in to perform this action",
                "no_access": "You have no access to this organisation"
            },
            "logout": {
                "logout": "Logout"
            },
            "forgotten": {
                "password_instructions": "Enter the data to change your password.",
                "change_password": "Change password",
                "reset_link_sent": "When your e-mail address is found, the instructions are sent. Check your e-mail and click the link in the e-mail to reset your password.",
                "reset_link_not_sent": "Unfortunately we're unable to send the e-mail with the instructions. Contact your instructor for help.",
                "send_instructions": "Send instructions",
                "confirm_password": "Confirm password",
                "confirm_password_description": "Confirm your password to continue.",
                "forgot_password": "Forgot password",
                "forgot_password_description": "In the case you forgot your password, fill in your e-mail address. After that you will receive an e-mail with instructions how to reset your password.",
                "forgot_your_password": "Forgot your password?",
                "check_spam_folder": "If you do not see the email in a few minutes, check your \u201cjunk mail\u201d folder or \u201cspam\u201d folder.",
                "mail": {
                    "explanation": "You are receiving this email because we received a password reset request for your account.",
                    "reset_password": "Reset Password",
                    "reset_password_link": "Reset your password by following this link: :link",
                    "link_expires": "This password reset link will expire in :count minutes.",
                    "not_requested": "If you did not request a password reset, no further action is required."
                }
            },
            "verify": {
                "verify": "Verify your e-mail address",
                "click_below": "Please click the button below to verify your email address.",
                "check_email": "A verification link has been sent to your email address with a link to complete your registration.",
                "resent": "A fresh verification link has been sent to your email address.",
                "before": "Before proceeding, please check your email for a verification link.",
                "not_received": "If you did not receive the email",
                "request": "Click here to request another",
                "not_requested": "If you did not create an account, no further action is required.",
                "expires_in": "The link expires in :minutes minutes.",
                "not_valid": "The verification link is no longer valid. Request a new link."
            },
            "account_exists": {
                "exists": "You tried to register but you already have an account.",
                "forgot_password": "If you have forgotten your password, you can reset it via \"Forgot your password\"."
            },
            "universal": {
                "organisations": {
                    "select": "Select organisation",
                    "none": "This account is not a member of any organisation. Ask your instructor to add you to an organisation."
                }
            },
            "delete": {
                "verify": "Verify account deletion",
                "click_below": "Please click the button below to verify you want to delete your account.",
                "not_requested": "If you did not ask for account deletion, no further action is required.",
                "mail_sent": "If this email address exists, you will receive an email, click on the link in the email to confirm that you want to delete your account.",
                "confirm": "I know the consequences, and I'm sure that I want to delete my account"
            },
            "sso": {
                "generic": "Sorry, something went wrong logging you in using single sign-on. Please try again.",
                "no_id": ":configuration: no unique identifier provided by provider.",
                "no_email": ":configuration: no email address provided by provider.",
                "prohibited": "Login via SSO is prohibited for this user.",
                "not_a_member": "You must be invited to this organisation before you can sign in.",
                "user_data_request_error": ":configuration: provider responded with error code :code. Please try again and contact support if the error persists."
            },
            "failed": "These credentials do not match our records.",
            "password": "The provided password is incorrect.",
            "throttle": "Too many login attempts. Please try again in :seconds seconds.",
            "pending_invitation": "Please accept your invitation before signing in.",
            "get_mobile_app": {
                "title": "Install the mobile app",
                "description": "Please install our mobile app for a better experience.",
                "download_app_store": "Download on the App Store",
                "download_play_store": "Get it on Google Play"
            },
            "no_access_logged_out": "You do not have access to this organisation. Log in again with an account that does have access."
        },
        "battle": {
            "battle": "Battle",
            "battles": "Battles",
            "completed_battles": "Completed battles",
            "battle_leaderboard": "Battle scoreboard",
            "battle_arena": "Battle Arena",
            "view_battle": "View battle",
            "view_leaderboard": "View leaderboard",
            "view_my_achievements": "My achievements",
            "dashboard_tile": {
                "starts_soon": "Battle starts soon!",
                "ended": "Battle ended",
                "ended_subtext": "This battle has ended and can no longer be played"
            },
            "properties": {
                "name": "Name",
                "description": "Description",
                "win_score": "Win bonus",
                "lose_factor": "Percentage of the win bonus that the loser will receive",
                "score_factor": "Score factor for winning against a higher ranked player",
                "response_time": "Response time",
                "daily_limit": "Daily limit",
                "available": "Available",
                "available_from": "Available from",
                "available_till": "Available till",
                "no_limit": "no limit",
                "hours": "hours",
                "simultaneous_open_sessions": "Simultaneous open sessions",
                "simultaneous_open_sessions_unlimited": "Unlimited",
                "image": "Image",
                "image_select": "Select image"
            },
            "insights": {
                "wins": "Wins",
                "count_completed_sessions": "# completed sessions",
                "count_unaccepted_sessions": "# unaccepted sessions",
                "average_score": "Average score",
                "count_unique_initiators": "# unique initiators",
                "count_unique_opponents": "# unique opponents",
                "percentage_of_sessions_where_opponent_wins": "% of completed sessions where opponent won",
                "average_time_to_complete_micro_game": "Average time to complete micro game",
                "average_time_to_accept_invitation": "Average time an invitation is open",
                "average_time_to_complete_session": "Average time for session to be completed"
            },
            "actions": {
                "create": {
                    "action": "Create battle",
                    "success": "Battle created",
                    "failed": "Unable to create the battle"
                },
                "update": {
                    "action": "Edit battle",
                    "success": "Battle updated",
                    "failed": "Unable to update the battle"
                },
                "delete": {
                    "action": "Remove battle",
                    "confirm": "When removing a battle, the battle is directly removed for all players. Are you sure you want to continue?",
                    "success": "Battle removed",
                    "failed": "Unable to remove the battle"
                },
                "stop": {
                    "action": "Stop battle",
                    "confirm": "When stopping a battle, the battle is directly removed for all players. Are you sure you want to continue?",
                    "success": "Battle stopped",
                    "failed": "Unable to stop the battle"
                }
            },
            "filter": {
                "no_campaign": "No campaign",
                "select_campaign": "Select campaign"
            },
            "validations": {
                "not_owned": "The battle doesn't belong to your organisation",
                "already_played": "This battle has already been played by some users.",
                "overlaps": "Battle cannot overlap with other battles.",
                "no_micro_games": "This campaign has no micro game modules.",
                "outside_tournament": "This value is outside the times of the tournament.",
                "micro_games_required": "You must choose a micro game when no campaign is selected."
            },
            "session": {
                "sessions": "Sessions",
                "date": "Date",
                "initiator": "Initiator",
                "opponent": "Opponent",
                "bonus": "Bonus",
                "not_found": "Battle session not found"
            },
            "picked_randomly": "picked randomly",
            "pick_random_microgame": "Pick random micro game from campaign",
            "expired": "Battle is expired",
            "not_found": "Battle not found",
            "no_active": "There is no active battle right now.",
            "not_allowed": "You are not allowed to start another battle today try again tomorrow",
            "did_not_lose": "You cannot revenge a battle that you did not lose.",
            "already_completed": "You have already completed this battle.",
            "win": "{1} win|[0,2,*] wins",
            "wins": "{1} :count win|[0,2,*] :count wins",
            "challenge": "Challenge",
            "invite": "Invite",
            "revanche": "Revanche",
            "challenges_you": ":name challenges you",
            "start": "Start battle",
            "battle_masters": "Battle masters",
            "battle_masters_popup": "Choose an opponent",
            "search_opponent": "Search Opponent",
            "challengers": "Challengers",
            "yourself": "You cannot challenge yourself",
            "wait_for_initiator": "Wait for a score to be placed by the challenger",
            "no_invitations": "You have not yet been challenged by a fellow player.",
            "no_history": "You haven't played any battles yet.",
            "too_many": "You already have too many active battles.",
            "campaign_is_tournament": "This campaign is in tournament mode, and can only be played between :dates. The battle must also be within that timeframe.",
            "game_anonymous": "Campaign is only accessible to anonymous users",
            "summary": {
                "header": {
                    "winner": "Winner",
                    "loser": "Loser",
                    "tied": "Tied"
                },
                "battle_score": "Battle score",
                "score": {
                    "win": "Battle win",
                    "lost": "Battle lost",
                    "tied": "Battle tied"
                },
                "earned": "Earned"
            }
        },
        "campaign": {
            "campaign": "Campaign",
            "campaigns": "Campaigns",
            "new_campaign": "New campaign",
            "view_campaign": "View campaign",
            "management": {
                "description": "A campaign contains a collection of challenges and could be compared to a book where the challenges are chapters."
            },
            "insights": "Insights",
            "to_campaign": "To campaign",
            "already_played": "This campaign is already played by :amount players. Editing this campaign will result in changing their progress.",
            "transfer_requests": "Transfer requests",
            "copy_title": "Copy campaign",
            "copy": "Copy campaign to another organisation",
            "copy_button": "Send copy request",
            "copy_description": "The receiving organisation will get a request to copy the campaign. When they have accepted the request, the campaign will be copied.",
            "copyable_campaigns": "Campaigns that can be copied",
            "copy_howto": "To copy a campaign, open the campaigns page and click the copy button next to it.",
            "copy_accept": "Copy the campaign",
            "copy_accept_confirmation": "Copy the campaign to your organisation. After that you are able to change the campaign to your requirements. Are you sure you want to copy the campaign?",
            "copy_deny": "Remove request",
            "copy_deny_confirmation": "Deny the request to copy the campaign to your organisation. After that you will no longer be able to copy the campaign to your organisation. Are you sure you want to continue?",
            "copy_bulk_accept": "Copy the campaigns",
            "copy_bulk_accept_confirmation": "Copy the selected campaigns to your organisation? After, you are able to change the campaigns to your requirements. Are you sure you want to copy the campaigns?",
            "copy_bulk_deny": "Remove requests",
            "copy_bulk_deny_confirmation": "Deny the selected requests to copy the campaigns to your organisation? After, you will no longer be able to copy the campaigns to your organisation. Are you sure you want to continue?",
            "duplicate": "Duplicate campaign within own organisation",
            "duplicate_button": "Duplicate campaign",
            "duplicate_description": "The campaign along with all its challenges and modules will be duplicated within your organisation.",
            "outgoing_requests": "Campaigns that could be copied",
            "copy_revoke": "Revoke permission to copy",
            "copy_revoke_description": "When revoking the permission to copy the campaign, the receiving organisation is no longer allowed to copy the game. Are you sure you want to continue?",
            "copy_to_subdomain_description": "Enter the subdomain of the organisation you would like to copy the game to.",
            "leaderboard": "Leaderboard",
            "no_player": "No player",
            "completed": "Completed!",
            "percentage_completed": "of campaign completed",
            "progress": "Progress",
            "available_modules": "Available",
            "completed_modules": "Completed",
            "stars": "Stars",
            "achievement_xp": "Battle :xp",
            "battle_xp": "Battle :xp",
            "total_xp": "Total :xp",
            "tournament_starts_soon": "Tournament starts soon!",
            "from": "From",
            "status": {
                "scheduled": "Scheduled",
                "in_progress": "In progress",
                "done": "Done",
                "archived": "Archived"
            },
            "properties": {
                "name": "Name",
                "title": "Title",
                "finished_by": "Finished by",
                "finish_date": "Finish date",
                "run_time": "Run time",
                "description": "Description",
                "image": "Image",
                "image_select": "Select image",
                "icon": "Icon",
                "icon_select": "Select icon",
                "score": "Score",
                "bonus": "Bonus",
                "modules_completed": "modules completed",
                "owned_by": "Owned by",
                "shared_with": "Shared with",
                "play_in_order": "Challenges must be played in order",
                "hide_leaderboard": "Hide leaderboard",
                "access": "Access",
                "access_tags": "Only users with a tag",
                "access_tags_placeholder": "All registered users",
                "tournament": "Tournament",
                "enable_tournament": "Enable tournament mode",
                "tournament_start_at": "Tournament starts at",
                "tournament_duration": "Tournament duration",
                "tournament_status": "Tournament status",
                "tournament_end_at": "Tournament ends at",
                "tournament_ended": "Tournament ended",
                "show_points": "Show points",
                "show_stars": "Show stars",
                "awards_certificate": "awards certificate",
                "leagues": "Leagues",
                "leagues_description": "When leagues are enabled, the leaderboard will be based on poules with promotion and relegation.",
                "league_enabled": "Enable leagues",
                "league_ideal_poule_size": "Ideal poule size",
                "league_switch_day": "Promotion \/ relegation every:",
                "league_switch_time": "At:",
                "achievements_description": "Select all the achievements you want to enable for users."
            },
            "access_options": {
                "all": "Everyone",
                "anonymous": "Anonymous users",
                "registered": "Registered users"
            },
            "actions": {
                "create": {
                    "action": "Create campaign",
                    "success": "Campaign created",
                    "failed": "Unable to create the campaign"
                },
                "update": {
                    "action": "Edit campaign",
                    "success": "Campaign updated",
                    "failed": "Unable to update the campaign"
                },
                "delete": {
                    "action": "Remove campaign",
                    "confirm": "When removing a campaign, the campaign is directly removed for all players. Are you sure you want to continue?",
                    "success": "Campaign removed",
                    "failed": "Unable to remove the campaign"
                },
                "restore": {
                    "action": "Restore campaign",
                    "confirm": "When restoring a campaign, the campaign is directly accessible. Are you sure you want to continue?",
                    "success": "Campaign restored",
                    "failed": "Unable to restore the campaign"
                },
                "order": {
                    "action": "Order campaigns",
                    "success": "Updated the order of the campaigns",
                    "error": "Could not update the order of the campaigns"
                },
                "transfer_request_create": {
                    "create": "Create transfer",
                    "success": "Transfer request sent",
                    "failed": "Unable to send the transfer request"
                },
                "transfer_request_delete": {
                    "success": "Transfer request removed",
                    "failed": "Unable to remove the transfer request"
                },
                "transfer": {
                    "success": "Transfer request processed",
                    "failed": "Unable to process the transfer request",
                    "skip_missing_microgames": "Skip inaccessible micro games"
                },
                "duplicate": {
                    "success": "Campaign duplicated"
                },
                "bulk_transfer": {
                    "success": "Transfer requests processed",
                    "failed": "The following games could not be transferred: :games",
                    "transfer_no_access": "The organisation has no rights to process the request"
                },
                "bulk_transfer_request_delete": {
                    "success": "Transfer requests removed",
                    "failed": "The following transfer requests could not be removed: :games",
                    "no_access": "The organisation has no rights to delete the request"
                }
            },
            "validations": {
                "not_owned": "The campaign doesn't belong to your organisation",
                "no_access": "The organisation has no access to the campaign",
                "no_longer_available": "The campaign or requested part of the campaign is no longer available",
                "not_accessible": "You do not have access to this campaign",
                "transfer_already_sent": "Transfer request already sent to the organisation",
                "transfer_no_access": "The organisation has no rights to process the request",
                "no_access_to_microgames": "The organisation does not have access to one or more micro games. Contact your account manager for access. The campaign can still be copied but the module(s) with the following micro game(s) will be skipped:",
                "tournament_has_not_started": "Please come back on :date at :time to start playing!",
                "tournament_has_not_started_dashboard": "Starting :date: game on!",
                "tournament_has_ended": "This campaign's tournament has ended and can no longer be played",
                "battle_outside_tournament": "This campaign has battles that fall entirely outside the tournament. Please delete these before configuring the tournament mode.",
                "challenges_must_be_played_in_order": "This campaign's challenges must be played in order. Complete the preceding challenges to unlock this one."
            },
            "tournament": {
                "warn_existing_battles": "This campaign has active or upcoming battles. In case a battle only partially overlaps with the tournament, its times will be adjusted."
            },
            "leagues": {
                "week": "Week",
                "week_number": "Week :number",
                "poules": ":count poules",
                "number_of_poules": "Number of poules"
            }
        },
        "certificate": {
            "certificate": "Certificate",
            "certificates": "Certificates",
            "awarding": "Awarding",
            "new_games_default_certificate_awarding_description": "New campaigns award certificates by default.",
            "award_default": "Award default",
            "for": "For",
            "awarded_on": "Awarded on",
            "presented_to": "The certificate is proudly presented to",
            "demonstrated_expertise": "The player mentioned above has demonstrated their expertise in :name and successfully passed the :name campaign.",
            "date": "Date",
            "signed_by": "Signed by",
            "you_made_it": "You made it!",
            "mail": {
                "subject": "Certificate PDF for :name",
                "body": "You receive the certificate for :name as an attachment to this email."
            },
            "mail_sent": "The certificate has been sent by email.",
            "mail_sent_description": "The certificate is being generated and will be sent to you by email, this may take a while.",
            "well_done": "Well done!",
            "certificate_obtained": "Certificate obtained",
            "not_found": "Certificate not found"
        },
        "challenge": {
            "challenge": "Challenge",
            "challenges": "Challenges",
            "challenge_description": "A challenge contains a collection of modules and can be compared to a chapter of a book.",
            "challenge_completed_at": "Challenge completed at",
            "challenge_play": "Play the challenge and achieve the high score",
            "challenge_not_playable": "The challenge can't be played",
            "challenge_not_playable_no_modules": "The challenge has 0 modules and therefor can't be played. Contact your instructor.",
            "challenge_completed": "Challenge completed",
            "challenge_completed_name": "Completed challenge :challenge",
            "challenge_completed_description": "Great work! You've completed the challenge!",
            "challenge_not_completed": "Challenge not completed",
            "challenge_not_completed_description": "Unfortunately the challenge is not completed. But... no problem! Just try it again!",
            "try_again": "Try again",
            "back_to_campaign": "Back to campaign",
            "back_to_overview": "Back to overview",
            "next_challenge": "Next challenge",
            "play_again": "Play again",
            "improve_score": "Improve score",
            "progress": "Progress",
            "start": "Start",
            "summary": "Summary screen",
            "summary_description": "The summary screen of the challenge. You can add separate texts and images here for passed and failed challenges.",
            "continue_program": "Continue the program",
            "properties": {
                "name": "Name",
                "description": "Description",
                "image": "Image",
                "image_select": "Select image",
                "summary_passed_text": "Text passed challenge",
                "summary_passed_image": "Image passed challenge",
                "summary_failed_text": "Text failed challenge",
                "summary_failed_image": "Image failed challenge"
            },
            "actions": {
                "create": {
                    "action": "Add challenge",
                    "success": "Challenge created",
                    "failed": "Unable to create the challenge"
                },
                "update": {
                    "action": "Edit challenge",
                    "success": "Challenge updated",
                    "failed": "Unable to update the challenge"
                },
                "delete": {
                    "action": "Remove challenge",
                    "confirm": "The challenge will be removed from the campaign. This will result in players not being able to play or view this challenge. Are you sure you want to continue?",
                    "success": "Challenge removed",
                    "failed": "Unable to remove the challenge"
                },
                "restore": {
                    "action": "Restore challenge",
                    "confirm": "When restoring a challenge, the challenge is directly accessible. Are you sure you want to continue?",
                    "success": "Challenge restored",
                    "failed": "Unable to restore the challenge"
                },
                "order": {
                    "success": "Updated the order of the challenges",
                    "error": "Unable to update the order of the challenges"
                }
            },
            "validations": {
                "not_owned": "The challenge doesn't belong to your organisation",
                "must_be_part_of_organisation": "The challenge must belong to the organisation",
                "no_modules": "The challenge has 0 modules so it can't be played."
            }
        },
        "challenge_session": {
            "actions": {
                "update": {
                    "failed": "Unable to update the module session"
                }
            },
            "validations": {
                "must_be_part_of_organisation": "The challenge session must belong to a challenge of the organisation",
                "not_owned": "This challenge session isn't yours. Start the challenge from your own account",
                "too_old": "This challenge session is older then 8 hours. Please start the challenge again"
            }
        },
        "daily_challenge": {
            "daily_challenge": "Daily challenge",
            "daily_challenges": "Daily challenges",
            "improve_score": "Improve your score",
            "starts_soon": "Starts soon",
            "start": "Start the Daily Challenge",
            "properties": {
                "name": "Name",
                "description": "Description",
                "image": "Image",
                "image_select": "Select image",
                "type": "Type",
                "available_at": "Available at"
            },
            "actions": {
                "create": {
                    "action": "Create daily challenge",
                    "success": "Daily challenge created",
                    "failed": "Unable to create the daily challenge"
                },
                "update": {
                    "action": "Update daily challenge",
                    "success": "Daily challenge updated",
                    "failed": "Unable to update the daily challenge"
                },
                "delete": {
                    "action": "Remove daily challenge",
                    "confirm": "When removing a daily challenge, it is directly removed for all players. Are you sure you want to continue?",
                    "success": "Daily challenge removed",
                    "failed": "Unable to remove the daily challenge"
                }
            },
            "validations": {
                "not_owned": "The daily challenge doesn't belong to your organisation"
            }
        },
        "dashboard": {
            "switch_account": "Switch account",
            "current_program": "current program",
            "personal-progress": "Personal Progress",
            "to-receive-certificate": "To receive Certificate",
            "highscores": "Highscores",
            "retry_last_performance": "Retry last performance",
            "no_last_performance": "You haven't participate in any campaigns",
            "battle_mode": "Battle Mode",
            "programs": "Programs",
            "exergames": "Exergames",
            "interactive_workouts": "Interactive Workouts",
            "fitness_video": "Fitness Video's",
            "leaderboard": "Leaderboard",
            "community": "Community",
            "support": "Support",
            "interactive_challenges": "Challenges",
            "videos": "Videos",
            "privacy_policy": "Privacy Policy",
            "terms_and_conditions": "Terms and Conditions"
        },
        "dashboard_tile": {
            "dashboard": "Dashboard layout",
            "dashboard_tile": "Dashboard tile",
            "choose_type": "Choose a type",
            "choose_model": "Choose a :type",
            "properties": {
                "name": "Name",
                "access": "Access",
                "status": "Status",
                "type": "Type"
            },
            "add_as_dashboard_tile": "Add as dashboard tile",
            "status": {
                "available": "Available",
                "scheduled": "Scheduled",
                "done": "Done"
            },
            "actions": {
                "order": {
                    "success": "The order of the dashboard tiles has been updated",
                    "failed": "The order of the dashboard tiles could not be updated"
                },
                "create": {
                    "action": "Create dashboard tile",
                    "success": "Dashboard tile created",
                    "failed": "Unable to create the dashboard tile"
                },
                "update": {
                    "action": "Update dashboard tile",
                    "success": "Dashboard tile updated",
                    "failed": "Unable to update the dashboard tile"
                },
                "delete": {
                    "action": "Remove dashboard tile",
                    "confirm": "When removing a dashboard tile, it is directly removed for all players. Are you sure you want to continue?",
                    "success": "Dashboard tile removed",
                    "failed": "Unable to remove the dashboard tile"
                }
            }
        },
        "direct_play_micro_game": {
            "micro_game": "Direct-play micro game",
            "micro_games": "Direct-play micro games",
            "explanation": "The campaigns shown here are only for context, as they may differ for each user depending on the campaigns they have access to. The micro games will always be shown at the position in this list.",
            "properties": {
                "name": "Name",
                "description": "Description",
                "image": "Image",
                "image_select": "Select image",
                "type": "Type",
                "hide_high_score": "Hide high score"
            },
            "actions": {
                "create": {
                    "action": "Create direct-play micro game",
                    "success": "Direct-play micro game created",
                    "failed": "Unable to create the direct-play micro game"
                },
                "update": {
                    "action": "Update direct-play micro game",
                    "success": "Direct-play micro game updated",
                    "failed": "Unable to update the direct-play micro game"
                },
                "order": {
                    "success": "Updated the order of the direct-play micro games"
                },
                "delete": {
                    "action": "Remove direct-play micro game",
                    "confirm": "When removing a direct-play micro game, it is directly removed for all players. Are you sure you want to continue?",
                    "success": "Direct-play micro game removed",
                    "failed": "Unable to remove the direct-play micro game"
                }
            },
            "validations": {
                "not_owned": "The direct-play micro game doesn't belong to your organisation"
            }
        },
        "domains": {
            "domains": "Domains",
            "domain": "Domain",
            "no_domains": "No domains added yet",
            "properties": {
                "domain": "Domain"
            },
            "actions": {
                "create": {
                    "action": "Add domain",
                    "success": "Domain created",
                    "failed": "Unable to create the domain"
                },
                "update": {
                    "action": "Edit domain",
                    "success": "Domain updated",
                    "failed": "Unable to update the domain"
                },
                "delete": {
                    "action": "Remove domain",
                    "confirm": "Are you sure you want to continue?",
                    "success": "Domain removed",
                    "failed": "Unable to remove the domain"
                }
            }
        },
        "exception": {
            "one_time_login_token_invalid": "Invalid one-time login token",
            "one_time_login_token_expired": "One-time login token is expired",
            "one_time_login_token_not_yet_valid": "One-time login token not yet valid",
            "one_time_login_token_consumed": "One-time login token already used",
            "one_time_login_token_not_for_organisation": "One-time login token not valid for this organisation",
            "route_not_found": "No route found for this request"
        },
        "gamified_video": {
            "gamified_video": "Gamified video",
            "gamified_videos": "Gamified videos",
            "overview_description": "Overview of all imported Gamified videos",
            "description": "A gamified video is an interactive video from HiHaHo. The available videos will be automatically retrieved from HiHaHo.",
            "select_available_video": "Select an available video",
            "preview": "preview",
            "properties": {
                "name": "Name",
                "folder": "Folder",
                "link": "Link",
                "external_id": "External ID",
                "embed_url": "Embed URL",
                "total": "Total",
                "created": "Created",
                "existing": "Existing"
            },
            "actions": {
                "play": {
                    "action": "Play the video below and then proceed."
                },
                "import": {
                    "action": "Import Gamified videos",
                    "description": "This will import the available Gamified videos from HiHaHo. This may take some time and should be run when some videos are missing. Are you sure you want to continue?",
                    "results": "Import results"
                }
            },
            "play_first": "Play the video first",
            "play_first_description": "Play the video before to proceed",
            "unable_to_retrieve_progress": "Unable to store the video progress, that means we're unable to store the progress. The developers are notified!"
        },
        "gamified_video_folder": {
            "gamified_video_folders": "Gamified video folders",
            "overview_description": "Overview of all the folders of the Gamified videos",
            "select_placeholder": "Select gamified video folder(s)",
            "none_assigned": "There are no assigned gamified video folders.",
            "properties": {
                "name": "Name",
                "external_id": "External ID"
            },
            "actions": {
                "update": {
                    "success": "Access to the gamified video folders is updated"
                }
            },
            "filter": {
                "folder": "Folder",
                "all_folders": "All folders"
            }
        },
        "general": {
            "start": "Start playing",
            "start_workout": "Start workout",
            "play_now": "Quick play",
            "quit": "Quit",
            "data": "Data",
            "data_tools": "Data & Tools",
            "dashboard": "Dashboard",
            "home": "Home",
            "welcome": "Welcome",
            "welcome_description": "Start playing by logging in",
            "required": "Required",
            "toggle_navigation": "Toggle navigation",
            "insights": "Insights",
            "back_to_dashboard": "Back to dashboard",
            "back_to_campaigns": "Back to campaigns",
            "back_to_exergames": "Back to exergames",
            "back_to_interactive_workouts": "Back to interactive workouts",
            "back_to_leaderboards": "Back to leaderboards",
            "control_panel": "Control panel",
            "no_avatar": "No avatar",
            "search": "Search",
            "search_placeholder": "Search...",
            "status": "Status",
            "active": "Active",
            "inactive": "Inactive",
            "archived": "Archived",
            "clear_filter": "Clear filter",
            "filter_results": "<strong>:start<\/strong> to <strong>:end<\/strong> of <strong>:total<\/strong> results",
            "results": "results",
            "access_denied": "Access denied",
            "access_denied_description": "Sorry, but you haven't got the proper permissions to access this functionality.",
            "unable_to_store_file": "Unable to store the file",
            "unable_to_process_file": "Unable to process the file",
            "upload_error": "Something went wrong during the upload",
            "invalid_file": "Invalid file provided",
            "file_too_large": "The file size of the selected file should ba a maximum of :size Mb. Reduce the file size to use this file",
            "import": "Import",
            "add": "Add",
            "create": "Create",
            "edit": "Edit",
            "filter": "Filter",
            "update": "Update",
            "manage": "Manage",
            "delete": "Delete",
            "restore": "Restore",
            "remove": "Remove",
            "assign": "Assign",
            "revoke": "Revoke",
            "failed": "Failed",
            "order": "Order",
            "save": "Save",
            "save_order": "Save order",
            "properties": "Properties",
            "export": "Export",
            "oops": "Oops...",
            "text": "Text",
            "header": "Header",
            "confirm": "Confirm",
            "send": "Send",
            "cancel": "Cancel",
            "day": "day",
            "days": "days",
            "days_abbr": "d",
            "hour": "hour",
            "hours": "hours",
            "hours_abbr": "h",
            "minute": "minute",
            "minutes": "minutes",
            "minutes_abbr": "m",
            "minutes_short": "mins",
            "back": "Back",
            "finish": "Finish",
            "next": "Next",
            "previous": "Previous",
            "summary": "Summary",
            "play_again": "Play again",
            "qr_code": "QR code",
            "qr_code_description": "Use this QR code to let player immediately start playing.",
            "qr_code_start": "Play immediately",
            "download": "Download",
            "download_svg": "Download SVG",
            "download_png": "Download PNG",
            "download_result": "Download result",
            "or_go_to": "or go to",
            "logout": "Logout",
            "profile": "Profile",
            "add_field": "Add field",
            "select_file": "Select file",
            "choose_file_upload": "Select a file to upload",
            "settings": "Settings",
            "no_results": "No results found",
            "loading": "Loading...",
            "close": "Close",
            "optional": "Optional",
            "is": "is",
            "seconds": "seconds",
            "selected": "selected",
            "language_unavailable_in_organisation": "not available for :organisation",
            "points": "Points",
            "score": "Score",
            "read_more": "Read more",
            "high_score": "High score",
            "everything": "Everything",
            "this_field": "This field",
            "reset": "Reset",
            "tournament": "TOURNAMENT",
            "score_not_set": "Score not set",
            "image_cannot_be_loaded": "The image cannot be loaded",
            "not_applicable": "not applicable",
            "publish": "Publish",
            "email_as_pdf": "Email as PDF",
            "pdf_will_be_send_to_your_email": "PDF will be sent to your email",
            "pdf_cannot_be_downloaded": "PDF cannot be downloaded",
            "pdf_cannot_be_emailed": "PDF cannot be emailed",
            "preview": "Preview",
            "set_as_default": "Set as default",
            "hello": "Hi",
            "regards": "Regards",
            "copy_link": "Should you have a problem with the button, copy the following link into a browser :link",
            "show": "Show",
            "accept": "Accept",
            "visible": "Visible",
            "hidden": "Hidden",
            "app_update_required": {
                "title": "Update required",
                "description": "Please update your app to the latest version. Continue your playful learning journey with joy and inspiration.",
                "your_version": "Your version",
                "minimum_version": "Minimum version"
            }
        },
        "handouts": {
            "handout": "Handout",
            "handouts": "Handouts",
            "handout_category": "Handout category",
            "handout_categories": "Handout categories",
            "no_handouts_found": "No handouts found.",
            "handouts_profile_section_disabled": "The \"handouts\" profile section is disabled for this organisation. Only after you enable it will the users be able to view handouts on their profile.",
            "navigate_to_profile_settings": "To profile settings",
            "properties": {
                "name": "Name",
                "description": "Description",
                "is_visible": "Visible",
                "file": "File",
                "file_description": "Allowed: pdf, doc, docx, xls, xlsx, ppt, pptx",
                "created_at": "Created"
            },
            "actions": {
                "create_category": {
                    "action": "Add category",
                    "success": "Category successfully added.",
                    "failed": "Failed to add category."
                },
                "update_category": {
                    "action": "Edit category",
                    "success": "Category successfully updated.",
                    "failed": "Failed to update category."
                },
                "delete_category": {
                    "action": "Delete category",
                    "confirm": "Are you sure you want to delete this category? The handouts in this category will be deleted as well.",
                    "success": "Category successfully deleted.",
                    "failed": "Failed to delete category."
                },
                "order_categories": {
                    "failed": "Failed to change order."
                },
                "create_handout": {
                    "action": "Add handout",
                    "success": "Handout successfully added.",
                    "failed": "Failed to add handout."
                },
                "update_handout": {
                    "action": "Edit handout",
                    "success": "Handout successfully updated.",
                    "failed": "Failed to update handout."
                },
                "delete_handout": {
                    "action": "Delete handout",
                    "confirm": "Are you sure you want to delete this handout?",
                    "success": "Handout successfully deleted.",
                    "failed": "Failed to delete handout."
                },
                "order_handouts": {
                    "failed": "Failed to change order."
                }
            },
            "mail": {
                "subject": "Handout: :name",
                "body": "In the attachment you will find the handout: :name",
                "sent": "The handout has been sent to your email address."
            }
        },
        "integration": {
            "integrations": "Integrations",
            "no_integrations": "No integrations added yet",
            "access_denied_to_portal": "You cannot access the full application as a user coming from an integration. Please login as a regular user.",
            "properties": {
                "name": "Administrative name",
                "type": "Type"
            },
            "sections": {
                "general": {
                    "title": "General"
                },
                "configuration": {
                    "title": "Configuration"
                }
            },
            "providers": {
                "learnworlds": {
                    "type": "Learnworlds",
                    "properties": {
                        "client_id": "Client ID",
                        "client_secret": "Client secret",
                        "base_url": "Base URL"
                    }
                }
            },
            "actions": {
                "create": {
                    "action": "Add integration",
                    "success": "Integration created",
                    "failed": "Unable to create integration"
                },
                "update": {
                    "action": "Edit integration",
                    "success": "Integration updated",
                    "failed": "Unable to update integration"
                },
                "delete": {
                    "action": "Remove integration",
                    "confirm": "When removing an integration, it cannot be used anymore with immediate effect. Are you sure you want to continue?",
                    "success": "Integration removed",
                    "failed": "Unable to remove integration"
                }
            }
        },
        "interactive_workouts": {
            "no_available_interactive_workouts_in_category": "No available interactive Workouts in this category"
        },
        "knowledge_category": {
            "actions": {
                "create": {
                    "failed": "Unable to create the Knowledge Category"
                }
            }
        },
        "knowledge_category_activity": {
            "actions": {
                "create": {
                    "failed": "Unable to create the Knowledge Category Activity"
                }
            }
        },
        "leaderboard": {
            "leaderboard": "Leaderboard",
            "properties": {
                "rank": "Rank",
                "total": "Total",
                "player": "Player",
                "players": "Players",
                "score": "Score",
                "bonus": "Bonus"
            },
            "league": {
                "admin": {
                    "title": "Why don't I see a leaderboard?",
                    "description": "You are not a member of this organisation, hence you are not automatically added to the leagues. The only reason you can view this page is because you're an administrator."
                },
                "levels": {
                    "bronze": "Bronze league",
                    "silver": "Silver league",
                    "gold": "Gold league"
                },
                "poule": "Poule",
                "poule_settings": "Poule settings",
                "league_settings": "League settings",
                "advanced_settings": "Advanced settings",
                "promotion_zone": "Promotion zone",
                "relegation_zone": "Relegation zone",
                "user_promotion_zone": "You are in the promotion zone",
                "user_relegation_zone": "You are in the relegation zone",
                "xp_ahead": ":value :xp ahead to go to the next league",
                "xp_to_maintain": ":value :xp needed to be safe",
                "explanation": "Explanation"
            }
        },
        "micro_game": {
            "micro_game": "Micro game",
            "micro_games": "Micro games",
            "your_latest_highscore": "Your Latest Highscore",
            "play": {
                "message": "When the corresponding app is installed on your device, it will open automatically. If you're playing this challenge on a desktop, you should play it on the device with the app on it."
            },
            "management": {
                "title": "Micro games",
                "description": "Manage the available micro games.",
                "groups": {
                    "group": "Micro game group",
                    "groups": "Micro game groups",
                    "overview": "Manage the available micro game groups."
                }
            },
            "properties": {
                "name": "Name",
                "identifier": "Identifier",
                "description": "Description",
                "image": "Image",
                "image_select": "Select image",
                "group": "Group",
                "is_global": "Global Micro Game",
                "is_global_description": "A global micro game can be used by all organisations.",
                "organisations": "Organisations",
                "points": "Points",
                "stars": "Stars",
                "stars_threshold": "Stars threshold",
                "custom_data": "Custom data",
                "key": "Key",
                "value": "Value",
                "webgl_location": "WebGL location",
                "build": "Build"
            },
            "actions": {
                "bulk": {
                    "update": {
                        "success": "Micro games updated",
                        "failed": "Unable to update the micro games"
                    }
                },
                "create": {
                    "action": "Add micro game",
                    "success": "Micro game added",
                    "failed": "Unable to add the micro game"
                },
                "update": {
                    "action": "Edit micro game",
                    "success": "Micro game updated",
                    "failed": "Unable to update the micro game"
                },
                "delete": {
                    "action": "Remove micro game",
                    "confirm": "When removing the micro game, the players won't be able to play this anymore. Are you sure you want to continue?",
                    "success": "Micro game removed",
                    "failed": "Unable to remove the micro game"
                },
                "sync": {
                    "action": "Update organisations",
                    "success": "Organisations of the micro game are updated",
                    "is_global": "Organisations of a global micro game cannot be updated"
                }
            },
            "filter": {
                "all_groups": "All groups",
                "select_micro_game": "Select micro game",
                "select_micro_game_of_group": "Select :group",
                "select_micro_game_group": "Select group"
            },
            "validations": {
                "organisation_must_have_access": "The organisation does not have access to this micro game."
            },
            "done_with_playing": "Done with playing"
        },
        "micro_game_group": {
            "group": "Micro game group",
            "groups": "Micro game groups",
            "management": {
                "title": "Micro game groups",
                "description": "Manage the available micro game groups."
            },
            "properties": {
                "name": "Name",
                "identifier": "Identifier",
                "image": "Image",
                "image_select": "Select image",
                "build": "Build",
                "custom_data": "Custom data",
                "webgl_location": "WebGL location",
                "type": "Type",
                "categories": "Categories"
            },
            "types": {
                "micro_game": "Micro game"
            },
            "filter": {
                "all_types": "All types",
                "select_type": "Select type",
                "select_category": "Select Category"
            },
            "actions": {
                "create": {
                    "action": "Add micro game group",
                    "success": "Micro game group added",
                    "failed": "Unable to add the micro game group"
                },
                "update": {
                    "action": "Edit micro game group",
                    "success": "Micro game group updated",
                    "failed": "Unable to update the micro game group"
                },
                "delete": {
                    "action": "Remove micro game group",
                    "confirm": "Are you sure you want to continue?",
                    "success": "Micro game group removed",
                    "failed": "Unable to remove the micro game group",
                    "prohibited": "Not allowed to remove a micro game group with micro games assigned to it"
                }
            }
        },
        "module": {
            "module": "Module",
            "module_type": "Type",
            "module_skills": "Skills",
            "modules": "Modules",
            "modules_completed": "Modules completed",
            "parts_completed": "Parts completed",
            "module_completed_at": "Module completed at",
            "module_play": "Play the module and achieve the high score",
            "proceed_with_challenge": "Click next to proceed with the challenge.",
            "next": "Next",
            "properties": {
                "name": "Name",
                "description": "Description",
                "threshold": "Threshold",
                "threshold_description": "The threshold determines if the participant succeeded or failed.",
                "threshold_description_value": "The threshold is a percentage of the amount of correct answered questions. For example when the threshold is 75 and there are 4 questions, the participant needs to at least answqers 3 questions correctly.",
                "reading_time": "Read time",
                "viewed_video": "I have watched the video or watched it before.",
                "factor": "Factor",
                "factor_description": "The factor determines how many points are awarded. By default the player gains :default_score points for completing a module. By adjusting the factor you are able to increase or decrease the score.",
                "image": "Image",
                "image_select": "Select image",
                "content": "Content",
                "video": "Video",
                "video_url": "Video URL",
                "video_description": "Use the link to the video (from the address bar of your browser). This doesn't have to be a special link, the app will take care of that for you.",
                "text": "Text",
                "text_description": "A text module contains a short explanation or introduction and an image that accompanies the text when you play the module.",
                "question_time": "Time per question",
                "question_time_description": "The maximum amount of time available per question.",
                "total_questions_used": "Number of questions to display",
                "total_questions_used_description": "The number of questions shown to the players (empty = all questions). A random selection is used there are more questions than the provided number.",
                "next_button_label": "\"Next\" button label",
                "is_replayable": "Replayable"
            },
            "actions": {
                "create": {
                    "title": "New :type module",
                    "success": "Module created",
                    "failed": "Unable to create the module"
                },
                "update": {
                    "title": "Edit :type module",
                    "success": "Module updated",
                    "failed": "Unable to update the module"
                },
                "delete": {
                    "action": "Remove module",
                    "confirm": "Remove the module from the challenge will result in nobody being able to play the module. Are you sure you want to continue?",
                    "success": "Module removed",
                    "failed": "Unable to remove the module",
                    "failed_battle": "Unable to remove the module because there is a battle that randomly picks a micro game from this campaign, and this is the last micro game in this campaign."
                },
                "restore": {
                    "action": "Restore module",
                    "confirm": "When restoring a module, the module is directly accessible. Are you sure you want to continue?",
                    "success": "Module restored",
                    "failed": "Unable to restore the module"
                },
                "order": {
                    "success": "Updated the order of the modules",
                    "failed": "Unable to update the order of the modules"
                }
            },
            "filter": {
                "all_types": "All types"
            },
            "validations": {
                "must_be_part_of_organisation": "The module must belong to the organisation",
                "invalid_properties": "The module type requires a configuration that's missing, for example when a related object is removed. Please edit or delete this module."
            },
            "already_played": "You have already finished this module. Click on 'Next' to continue with the challenge.",
            "not_replayable": "This module is already finished. Click on 'Next' to continue with the challenge."
        },
        "module_session": {
            "actions": {
                "create": {
                    "failed": "Unable to update the module session"
                },
                "update": {
                    "failed": "Unable to update the module session"
                }
            },
            "validations": {
                "must_be_part_of_organisation": "The module session must belong to a module of the organisation",
                "not_owned": "Only edit your own module sessions"
            }
        },
        "onboarding": {
            "onboarding": "Onboarding",
            "answer": "Answer",
            "assigned_tag": "Assigned tag",
            "select_tag": "Select tag",
            "not_answered": "Not answered",
            "intro_title": "Welcome to the personalisation process",
            "intro_description": "Please answer the following questions to personalise the application.",
            "question": "Question",
            "choose_answer": "Choose answer",
            "actions": {
                "create": {
                    "action": "Create question",
                    "success": "Question created",
                    "failed": "Unable to create the question"
                },
                "update": {
                    "action": "Edit question",
                    "success": "Question updated",
                    "failed": "Unable to update the question"
                },
                "delete": {
                    "action": "Remove question",
                    "confirm": "Lorsque vous supprimez une question, les libell\u00e9s attribu\u00e9s automatiquement seront d\u00e9tach\u00e9s des utilisateurs. \u00cates-vous s\u00fbr de vouloir continuer ?",
                    "success": "Question removed",
                    "failed": "Unable to remove the question"
                },
                "order": {
                    "action": "Order questions",
                    "success": "Updated the order of the questions",
                    "error": "Could not update the order of the questions"
                }
            }
        },
        "organisation": {
            "organisation": "Organisation",
            "organisations": "Organisations",
            "organisation_description": "Changes to the subdomain will update all URLs.",
            "crud_description": "A subdomain must be unique and should consist of letters (a-z), numbers (0-9) and a dash (-)",
            "subdomain_description": "A subdomain cannot be changed.",
            "logo": "Logo",
            "select_placeholder": "Select organisation(s)",
            "current": "Current organisation",
            "validations": {
                "not_found": "Organisation not found",
                "not_a_member": "No access to the organisation"
            },
            "state": {
                "removed": "Organisation is removed"
            },
            "properties": {
                "customer": "Customer",
                "name": "Name",
                "subdomain": "Subdomain",
                "url": "Url",
                "view_organisation": "View organisation",
                "languages": "Language settings",
                "default": "Default",
                "default_language": "Default language",
                "default_language_description": "Choose the default language for your organisation.",
                "available_languages": "Supported languages",
                "alternate_languages": "Alternate languages",
                "alternate_languages_description": "Choose the languages you want to support for your organisation.",
                "available_languages_warning": "When removing a supported language, you will lose data for the removed language when editing an item.",
                "manage_translations": "Manage custom translations",
                "reseller": "Reseller",
                "gamified_video_folders": "Gamified video folders",
                "gamified_video_folders_description": "Select the gamified video folders that can be used by the organisation.",
                "social": "Social",
                "meta_details": "Meta details",
                "social_description": "Add an <a href=\"https:\/\/www.freecodecamp.org\/news\/what-is-open-graph-and-how-can-i-use-it-for-my-website\" target=\"_blank\">open graph<\/a> image and description.",
                "customization": "Customization",
                "customization_description": "The application can be customized for the organisation to have a matching look and feel",
                "logo": "Logo",
                "logo_requirements": "Max 4Mb",
                "logo_select": "Select logo",
                "open_graph_image": "Open graph image",
                "open_graph_image_requirements": "At least 640\u00d7320px, max 4Mb",
                "open_graph_image_select": "Select image",
                "open_graph_description": "Open graph description",
                "brand_colors": "Brand colors",
                "brand_colors_description": "Select your brand colors to customize the appearance of your platform.",
                "display": "Display",
                "display_description": "Select the display where you want to show your application.",
                "display_select": "Select display",
                "theme_colors": "Theme colors",
                "theme_setup": "Theme setup",
                "theme_look_and_feel": "Look and feel",
                "theme_select": "Select theme",
                "manage_theme": "Manage custom theme",
                "background": "Background",
                "background_mobile": "Mobile",
                "background_laptop": "Laptop",
                "background_tablet": "Tablet",
                "background_desktop": "Desktop",
                "background_requirements": "Max 4Mb",
                "background_select": "Select background",
                "primary_color": "Primary color",
                "secondary_color": "Secondary color",
                "accent_color": "Accent color",
                "background_color": "Background color",
                "card_background_color": "Card background color",
                "module_shadow_color": "Module shadow color",
                "daily_tile_background_color": "Daily tile background color",
                "text": "Text",
                "font_headings": "Headings",
                "font_headings_color": "Headings color",
                "font_body": "Paragraphs",
                "font_body_color": "Paragraphs color",
                "primary_font_color": "Primary font color",
                "secondary_font_color": "Secondary font color",
                "primary_font_family": "Primary font family",
                "font_family_select": "Select font...",
                "primary_font_family_select": "Select primary font...",
                "secondary_font_family": "Secondary font family",
                "secondary_font_family_select": "Select secondary font...",
                "preview_fonts": "Fonts can be previewed here: :url",
                "card_border_radius": "Card border radius",
                "card_settings": "Card settings",
                "introduction_title": "Title",
                "introduction_text": "Content",
                "welcome_text": "Welcome text",
                "welcome_text_description": "Defines the text shown on the login screen.",
                "configuration": "Configuration",
                "configuration_description": "Determine which features are enabled for this organisation",
                "registration_allowed": "Registration allowed",
                "registration_allowed_header": "Registration allowed",
                "registration_description": "Allow users to register without invitation",
                "demo_user_allowed": "Playing as demo user allowed",
                "demo_user_allowed_header": "Demo users allowed",
                "demo_user_description": "Allow users to play without an account. Be aware, <strong>no progress<\/strong> is being tracked",
                "allow_upgrade_to_registered_user": "Allow upgrade to registered user",
                "allow_upgrade_to_registered_user_description": "Allow demo users to upgrade to a registered user by adding and confirming their email address.",
                "reseller_allowed": "Organisation is reseller",
                "reseller_allowed_header": "Organisation reseller",
                "reseller_description": "A reseller is able to create additional organisations as their customers",
                "webhook": "Webhook",
                "webhook_url": "Webhook URL",
                "webhook_url_description": "There is the option to let the Gamification Player call a <a href=\":url\" target=\"_blank\">webhook<\/a> in certain events. The gamification player will <code>POST<\/code> several events to the webhook.",
                "webhook_secret": "Webhook secret",
                "webhook_secret_description": "As the gamification player is hosted on a cluster, there's no fixed IP-address available. You need to provide a <a href=\":url\" target=\"_blank\">secret\/token<\/a> in addition to the webhook URL to ensure its safety. The secret\/token can be everything you want and is provided in the <code>X-Webhook-Token<\/code> header.",
                "webhook_events": "Webhook events",
                "webhook_events_description": "Select all webhook events you want to receive to prevent receiving unnecessary webhook events.",
                "webhook_events_select": "Receive all events",
                "register_apps": "Register app",
                "ios_example_url": "https:\/\/apps.apple.com\/nl\/app\/example\/id123456789",
                "android_example_url": "https:\/\/play.google.com\/store\/apps\/details?id=com.example",
                "branch_example_url": "https:\/\/example.app.link",
                "ios_app_store": "App store (iOS)",
                "android_play_store": "Play store (Android)",
                "branchio_link": "Branch.io link",
                "ios_app_url": "iOS app URL",
                "android_app_url": "Android app URL",
                "branchio_url": "Branch.io URL",
                "branchio_url_in_mail": "Use Branch.io URL in mail",
                "sso_configurations": ":count configuration|:count configurations",
                "domains": ":count domain|:count domains",
                "organisation_settings": "Organisation settings",
                "advanced_settings": "Advanced settings",
                "permissions": "Permissions",
                "timezone": "Time zone",
                "introduction": "Introduction",
                "default_avatar": "Default profile photo",
                "default_avatar_select": "Select default profile photo",
                "default_avatar_requirements": "Max 4Mb",
                "achievements_description": "Select all the achievements you want to enable for users.",
                "hide_score_elements": "Hide score elements",
                "hide_score_elements_description": "Hide all score elements",
                "profile_settings": "Profile settings",
                "profile_sections": "Profile sections",
                "profile_section_name": "Name",
                "profile_section_description": "Description",
                "enforce_integration_only": "Enforce only integration",
                "enforce_integration_only_description": "With this option enabled, the login form will be hidden. Users can only log in via the integration.",
                "take_away_sections": "Take away sections",
                "take_away_section_name": "Name",
                "take_away_section_description": "Description",
                "dashboard_tiles": "Dashboard tiles",
                "dashboard_tiles_description": "Automatically add dashboard tiles when creating new games.",
                "add_tile_new_game_description": "Automatically add new campaigns to the dashboard.",
                "add_tile_new_battle_description": "Automatically add new battles to the dashboard.",
                "add_tile_new_direct_play_micro_game_description": "Automatically add new direct-play micro games to the dashboard."
            },
            "actions": {
                "create": {
                    "success": "Organisation created",
                    "failed": "Unable to create the organisation"
                },
                "update": {
                    "action": "Edit organisation",
                    "success": "Organisation updated",
                    "failed": "Unable to update the organisation"
                },
                "delete": {
                    "action": "Remove organisation",
                    "confirm": "When removing an organisation, the organisation loses access immediately. Are you sure you want to remove the organisation?",
                    "success": "Organisation removed",
                    "failed": "Unable to remove the organisation"
                },
                "restore": {
                    "action": "Restore organisation",
                    "confirm": "When restoring an organisation, the organisation gets access immediately. Are you sure you want to restore the organisation?",
                    "success": "Organisation restored",
                    "failed": "Unable to restore the organisation"
                }
            },
            "customer_of": "Customer of :organisation",
            "embed_code": "Embed code",
            "embed_width": "Width",
            "embed_height": "Height",
            "embed_portal": "Embed portal",
            "profile_sections_title": "Visibility profile",
            "profile_sections_description": "Select the profile sections that are available for the organisation.",
            "add_profile_section": "Add profile section",
            "edit_profile_section": "Edit profile section",
            "profile_sections": {
                "settings": "Settings",
                "take_aways": "Take-aways",
                "profile": "Profile",
                "certificates": "Certificates",
                "handouts": "Handouts"
            },
            "all_organisations": "All organisations",
            "all_profile_sections_selected": "All profile sections are selected",
            "take_away_sections_title": "Take away sections",
            "take_away_sections_description": "Select the take away sections that are available for the organisation.",
            "add_take_away_section": "Add take away section",
            "edit_take_away_section": "Edit take away section",
            "all_take_away_sections_selected": "All take away sections are selected",
            "take_away_sections": {
                "take_aways": "Take-aways",
                "questionnaires": "Questionnaires",
                "surveys": "Surveys"
            }
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "passwords": {
            "reset": "Your password has been reset!",
            "sent": "We have emailed your password reset link!",
            "throttled": "Please wait before retrying.",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that email address."
        },
        "profile": {
            "profile": "Profile",
            "your_profile": "Your profile",
            "back_to_dashboard": "Back to dashboard",
            "update_profile": "Update profile",
            "edit_profile": "Edit profile",
            "delete_profile": "Delete profile",
            "properties": {
                "name": "Name",
                "email": "Email address",
                "password": "Password",
                "password_confirmation": "Confirm password",
                "password_requirements": "Password must contain:",
                "password_minimal_characters": "At least 8 characters",
                "password_minimal_uppercase": "At least 1 uppercase character",
                "password_minimal_lowercase": "At least 1 lowercase character",
                "password_minimal_number": "At least 1 number",
                "password_weak": "Too weak",
                "password_not_bad": "Not bad",
                "password_almost": "Almost there",
                "username": "Username",
                "no_username": "No username",
                "country": "Country",
                "avatar": "Avatar",
                "choose_avatar": "Choose avatar",
                "upload_own_avatar": "Upload own avatar",
                "edit_profile_photo": "Edit profile photo",
                "photo": "Photo",
                "choose_photo": "Choose photo",
                "upload_photo": "Upload photo",
                "choose_language": "Choose language",
                "change_language": "Edit language",
                "change_password": "Change password"
            },
            "demo": {
                "not_allowed": "As a demo user, you are not allowed to edit your profile."
            },
            "actions": {
                "update": {
                    "action": "Save profile",
                    "success": "Profile updated",
                    "failed": "Unable to update the profile"
                },
                "update_password": {
                    "action": "Update password"
                }
            },
            "filter": {
                "select_country": "Select country",
                "select_avatar": "Select Avatar"
            },
            "stats": {
                "my_certificates": "My certificates",
                "no_certificates": "At the moment you don't have any certificates. You can earn certificates by participating campaigns or microgames."
            }
        },
        "question": {
            "question": "Question",
            "questions": "Questions",
            "question_description": "The player will be asked this question while playing.",
            "no_answers": "No answers",
            "template": "Template",
            "type": {
                "single": "Single choice",
                "multiple": "Multiple choice"
            },
            "properties": {
                "type": "Type",
                "feedback_correct": "Feedback correct",
                "feedback_wrong": "Feedback wrong",
                "feedback_correct_answer": "Feedback correct answered",
                "feedback_wrong_answer": "Feedback wrong answered",
                "content": "Content",
                "image": "Image",
                "image_select": "Select image",
                "feedback": "Feedback",
                "feedback_edit": "Edit feedback",
                "feedback_description": "After answering the question, the player could be provided some valuable feedback. Depending on the correct or wrong answer given, the player gets different feedback. Feedback is not required, but is recommended to improve the experience.",
                "excel_file": "Excel file",
                "file_select": "Select file",
                "file": "File"
            },
            "actions": {
                "create": {
                    "import": "Import questions",
                    "action": "Add question",
                    "success": "Question created",
                    "failed": "Unable to create the question"
                },
                "update": {
                    "action": "Edit question",
                    "success": "Question updated",
                    "failed": "Unable to update the question"
                },
                "delete": {
                    "action": "Remove question",
                    "confirm": "When removing the question from the quiz the participants will no longer see the question. Are you sure you want to continue?",
                    "success": "Question removed",
                    "failed": "Unable to remove the question"
                },
                "restore": {
                    "action": "Restore question",
                    "confirm": "When restoring the question, the participants will have to answers this question. Are your sure you want to continue?",
                    "success": "Question restored",
                    "failed": "Unable to restore the question"
                },
                "order": {
                    "success": "Update the order of the questions"
                },
                "template": {
                    "download": "Download template"
                },
                "import": {
                    "success": "Questions created",
                    "warning": "Note! existing questions will not be changed and duplicates will not be checked"
                },
                "export": {
                    "excel": "Export to Excel"
                }
            },
            "validations": {
                "check_answer_first": "Check the answer before proceeding to the next question",
                "unable_check_answer": "Unable to check the answers",
                "provide_at_least_one_answer": "Provide at least one answer",
                "no_correct_answers": "No correct answers or all answers are correct"
            }
        },
        "questionnaire": {
            "questionnaire": "Questionnaire",
            "questionnaires": "Questionnaires",
            "create": "Create new questionnaire",
            "edit": "Edit questionnaire",
            "select_type": "Type of questionnaire",
            "select_type_description": "Choose the questionnaire that applies to you.",
            "type": {
                "hypothesis": "Hypothesis",
                "multiple_choice": "Multiple choice",
                "bat": "Burn-out Assessment Tool test",
                "coping": "Copingstyle test",
                "zeven_domeinen": "Seven Domains test",
                "stress_test": "Stress test"
            },
            "properties": {
                "type": "Type",
                "type_description": "TODO: description",
                "title": "Title",
                "description": "Description",
                "image": "Image",
                "cover_image": "Cover",
                "category": "Category",
                "category_title": "Title",
                "category_image": "Image",
                "category_content": "Content",
                "question": "Question",
                "question_image": "Image",
                "answers": "Answers",
                "answer": "Answer",
                "start_screen_title": "Title",
                "start_screen_description": "Content",
                "results_title": "Title"
            },
            "steps": {
                "general_information": "General information",
                "create_categories": "Create categories",
                "create_questions": "Create questions"
            },
            "override_existing_answers": "Override existing answers when filling in again",
            "create_categories": "Create categories",
            "add_category": "Add category",
            "choose_category": "Choose category",
            "remove_category": "Delete category",
            "create_questions": "Create questions",
            "add_question": "Add question",
            "remove_question": "Delete question",
            "define_score": "Define score",
            "add_answer": "Add answer",
            "delete_question": "Delete question",
            "confirm_delete_question": "Are you sure you want to delete this question?",
            "delete_category": "Delete category",
            "confirm_delete_category": "Are you sure you want to delete this category?",
            "unknown_category_title": "Unnamed category",
            "back_to_campaign": "Back to campaign",
            "email_result": "E-mail result",
            "email_sent": "The PDF will be sent to your email address.",
            "email_sending_error": "An error occurred while sending the email.",
            "download_results": "Download results",
            "show_all_results": "Show all results",
            "results": "Results",
            "your_score": "Your score",
            "loading_questions": "Loading questions",
            "loading_results": "Loading results",
            "what_does_this_say_about_you": "What does this say about you?",
            "start": "Start",
            "start_screen": "Start screen",
            "start_screen_description": "If you leave these empty, they will fall back to the title and description of the questionnaire.",
            "end_screen": "End screen",
            "replay": "Replay",
            "advanced_settings": "Advanced settings",
            "pdf": {
                "completed_on": "Completed on",
                "at": "at",
                "completed_on_date": "Completed on :date at :time",
                "results": "Your result",
                "your_score": "Your result"
            },
            "pdf_mail": {
                "subject": "Questionnaire \":name\" completed",
                "intro": "Questionnaire completed",
                "text": "You have completed the questionnaire :name. View your personal result in the attachment."
            },
            "unused_categories_answers": "The following categories are not used in any answer: :categories",
            "unused_categories_questions": "The following categories are not used in any question: :categories",
            "categories_without_questions": "The following categories are not used in any question:",
            "categories_without_answers": "The following categories are not used in any answer:",
            "validations": {
                "name": "title",
                "description": "description",
                "category_id": "category",
                "points": "points",
                "image": "image",
                "question": "question",
                "answer": "answer",
                "points_threshold": "points threshold",
                "category_name": "title",
                "category_content": "content",
                "start_screen_title": "start screen title",
                "start_screen_description": "start screen content",
                "selected": "selected",
                "divisor": "divisor",
                "results_title": "results title"
            },
            "bat": {
                "configuration": "Configuration",
                "divisor": "Divisor",
                "divisor_description": "Default: total selected questions",
                "selected": "This question counts towards the score"
            },
            "coping": {
                "divisor": "Divisor"
            },
            "actions": {
                "previous": "Previous question",
                "next": "Next question"
            }
        },
        "quiz": {
            "quiz": "Quiz",
            "properties": {
                "title": "Title",
                "description": "Description",
                "image": "Image",
                "question_image": "Image for question",
                "minimum_score": "Minimum score",
                "minimum_score_description": "Enter the minimum pass percentage required to pass the quiz. For example, 75 means the player must answer at least 75% of the questions correctly.",
                "start_screen_title": "Title",
                "start_screen_description": "Content"
            },
            "steps": {
                "settings": "Instellingen",
                "questions": "Vragen"
            },
            "done": "The quiz is fully answered in this session. Play the challenge again to perform the quiz again.",
            "check_answer": "Check",
            "next_question": "Next question",
            "time_left": "Time left",
            "could_not_be_loaded": "The quiz could not be loaded.",
            "start_quiz": "Start quiz",
            "max_answers_reached": "Maximum number of answers reached.",
            "create": "Create quiz",
            "edit": "Edit quiz",
            "add_question": "Add question",
            "add_answer": "Add answer",
            "add_answers": "Add answers",
            "edit_question": "Edit question",
            "delete_question": "Delete question",
            "confirm_delete_question": "Are you sure you want to delete this question?",
            "delete_answer": "Delete answer",
            "confirm_delete_answer": "Are you sure you want to delete this answer?",
            "answers": "Answers",
            "settings": "Settings",
            "advanced_settings": "Advanced settings",
            "introduction": "Introduction",
            "start_screen": "Start screen",
            "start_screen_description": "If you leave these empty, they will fall back to the title and description of the quiz.",
            "passed": {
                "title": "Congratulations",
                "description": "You have successfully completed the quiz!"
            },
            "failed": {
                "title": "Unfortunately!",
                "description": "You need at least :percentage% to pass this quiz."
            },
            "validations": {
                "name": "name",
                "description": "description",
                "image": "image",
                "question": "question",
                "questions": "questions",
                "answer": "answer",
                "min_answers": "Minimum 2 answers are required.",
                "start_screen_title": "start screen title",
                "start_screen_description": "start screen content",
                "questions_required": "You must add at least 1 question.",
                "missing_questions": "This quiz has no questions. Please add at least one question."
            }
        },
        "reseller": {
            "customer": "Customer",
            "customers": "Customers",
            "actions": {
                "create": {
                    "action": "Add customer",
                    "success": "Customer created",
                    "failed": "Unable to create the customer"
                },
                "update": {
                    "action": "Edit customer",
                    "success": "Customer updated",
                    "failed": "Unable to update the customer"
                },
                "delete": {
                    "action": "Remove customer",
                    "confirm": "When removing a customer, the customer loses access immediately. Are you sure you want to continue?",
                    "success": "Customer removed",
                    "failed": "Unable to remove the customer"
                },
                "restore": {
                    "action": "Restore customer",
                    "confirm": "When restoring a customer, the customer has access immediately. Are you sure you want to continue?",
                    "success": "Customer restored",
                    "failed": "Unable to restore the customer"
                }
            },
            "validations": {
                "no_access": "Your organisation isn't the reseller of this customer"
            }
        },
        "skill": {
            "skill": "Skill",
            "skills": "Skills",
            "select_placeholder": "Select skills",
            "management": {
                "description": "A skill can be added to a module."
            },
            "properties": {
                "name": "Name",
                "description": "Description",
                "show_on_graph": "Show on graph"
            },
            "actions": {
                "create": {
                    "action": "Create skill",
                    "success": "Skill created",
                    "failed": "Unable to create the skill"
                },
                "update": {
                    "action": "Edit skill",
                    "success": "Skill updated",
                    "failed": "Unable to update the skill"
                },
                "delete": {
                    "action": "Remove skill",
                    "confirm": "When removing a skill, the skill is directly removed for all players. Are you sure you want to continue?",
                    "success": "Skill removed",
                    "failed": "Unable to remove the skill"
                },
                "restore": {
                    "action": "Restore skill",
                    "confirm": "When restoring a skill, the skill is directly accessible. Are you sure you want to continue?",
                    "success": "Skill restored",
                    "failed": "Unable to restore the skill"
                }
            },
            "user_distribution": "User distribution",
            "validations": {
                "not_owned": "The skill doesn't belong to your organisation",
                "unique": "The skill needs to be unique"
            }
        },
        "sso": {
            "sso": "Single Sign On",
            "no_sso": "No one time login set up yet",
            "one_time_login": "One time login",
            "authentication": "Authentication",
            "properties": {
                "name": "Button label",
                "provider": "Provider",
                "login_url": "Login URL"
            },
            "sections": {
                "appearance": {
                    "title": "Appearance",
                    "description": "Configure how this Single Sign On option is shown to your users on the login page."
                },
                "configuration": {
                    "title": "Configuration"
                }
            },
            "providers": {
                "google": {
                    "driver": "Google Workspace",
                    "properties": {
                        "client_id": "App ID",
                        "client_secret": "Client secret",
                        "domain": "Google Workspace domain"
                    },
                    "placeholders": {
                        "client_id": "*****.apps.googleusercontent.com",
                        "client_secret": "********"
                    }
                },
                "azure": {
                    "driver": "Azure AD",
                    "properties": {
                        "client_id": "Application (client) ID",
                        "client_secret": "Application secret",
                        "tenant": "Directory (tenant) ID"
                    },
                    "placeholders": {
                        "client_id": "00000000-0000-0000-0000-000000000000",
                        "client_secret": "********"
                    }
                },
                "oidc": {
                    "driver": "Generic OIDC",
                    "description": "The <strong>:authorization_endpoint<\/strong>, <strong>:token_endpoint<\/strong> and <strong>:userinfo_endpoint<\/strong> are required if <strong>:discovery_endpoint<\/strong> is not provided. When both are provided, the explicitly defined endpoints take precedence.",
                    "properties": {
                        "client_id": "App ID",
                        "client_secret": "Client secret",
                        "discovery_endpoint": "Configuration discovery URL",
                        "authorization_endpoint": "Authorization endpoint",
                        "token_endpoint": "Token endpoint",
                        "userinfo_endpoint": "User info endpoint",
                        "id_key": "Unique identifier attribute on user object"
                    },
                    "placeholders": {
                        "client_id": "",
                        "client_secret": ""
                    }
                },
                "adfs": {
                    "driver": "Active Directory Federation Services",
                    "description": "The <strong>:authorization_endpoint<\/strong>, <strong>:token_endpoint<\/strong> and <strong>:jwks_uri<\/strong> are required if <strong>:discovery_endpoint<\/strong> is not provided. When both are provided, the explicitly defined endpoints take precedence.",
                    "properties": {
                        "client_id": "Client Identifier",
                        "client_secret": "Shared secret",
                        "discovery_endpoint": "OpenID Connect metadata URI",
                        "authorization_endpoint": "Authorization endpoint",
                        "token_endpoint": "Token endpoint",
                        "jwks_uri": "JSON Web Key Sets (JWKS) URI"
                    },
                    "placeholders": {
                        "client_id": "",
                        "client_secret": ""
                    }
                }
            },
            "actions": {
                "create": {
                    "action": "Add one time login",
                    "success": "One time login created",
                    "failed": "Unable to create one time login"
                },
                "update": {
                    "action": "Edit one time login",
                    "success": "One time login updated",
                    "failed": "Unable to update one time login"
                },
                "delete": {
                    "action": "Remove one time login",
                    "confirm": "When removing one time login, it cannot be used to login anymore with immediate effect. Are you sure you want to continue?",
                    "success": "One time login removed",
                    "failed": "Unable to remove one time login"
                }
            }
        },
        "stats": {
            "status": "Status",
            "playing": "Playing",
            "completed": "Completed",
            "you": "You",
            "average_player": "Average player",
            "hours_play_time": "Hours play time",
            "modules_played": "Modules played",
            "experience": "Experience",
            "xp": "XP",
            "rewards": "Rewards",
            "achievements": "Achievements",
            "badges": "Badges",
            "certificates": "Certificates",
            "campaign_stats": "Campaign stats",
            "personal_stats": "Personal stats",
            "overal_stats": "Overal statistics",
            "average_score": "Average score",
            "not_enough_data": "not enough data",
            "xp_per_month": ":xp per month",
            "xp_per_week": ":xp per week"
        },
        "survey": {
            "survey": "Survey",
            "surveys": "Surveys",
            "view_survey": "View survey",
            "insight_description": "Here you can view the answers per survey entry. Next to that is the count of times an answer is provided. The data can be exported with the button above.",
            "part_of_challenge": "Part of challenge",
            "part_of_campaign": "Part of campaign",
            "sessions": "Sessions",
            "type_descriptive": "Question\/Assignment\/Statement",
            "options": "Options",
            "provide_answer": "Provide your answer or reaction below",
            "order": "Order",
            "type": "Type",
            "question": "Question",
            "provided_answer": "Provided answer",
            "provided_at": "Answered at",
            "provided_amount": "Times provided",
            "no_data": "No data could be found for this survey.",
            "start_screen": "Start screen",
            "start_screen_description": "If you leave these empty, they will fall back to the title and description of the survey.",
            "end_screen": "End screen",
            "end_screen_description": "If you leave these empty, the end screen will show 'Thank you for completing the survey'.",
            "end_screen_title_fallback": "Thank you for completing the survey",
            "properties": {
                "reaction": "Reaction",
                "reactions": "Reactions",
                "totally_disagree": "Totally disagree",
                "disagree": "Disagree",
                "agree": "Agree",
                "totally_agree": "Totally agree",
                "pdf_text": "PDF text",
                "pdf_text_description": "This text will be shown on the PDF export of the survey results.",
                "start_screen_title": "Start screen title",
                "start_screen_description": "Start screen description",
                "end_screen_title": "End screen title",
                "end_screen_description": "End screen description"
            },
            "validations": {
                "ensure_single_choice": "At least one options is required",
                "ensure_multiple_choice": "At least two options are required"
            },
            "pdf_mail": {
                "subject": "Survey \":survey_name\" completed",
                "intro": "Survey completed",
                "text": "You have completed the survey \":survey_name\". See the attachment to review it."
            },
            "export_summary": "Export summary",
            "export_answers": "Export responses"
        },
        "survey_entry": {
            "survey_entry": "Survey entry",
            "survey_entries": "Survey entries",
            "survey_entry_description": "The player will see this survey entry as a part of the survey.",
            "statement": "Statement",
            "question_or_assignment": "Question\/Assignment",
            "reaction_or_answer": "Response\/Answer",
            "specification": "Specification",
            "single_choice_description": "The player can provide a single answer\/response to the question\/assignment. There must be at least 1 option.",
            "multiple_choice_description": "The player can provide a multiple answers\/responses to the question\/assignment. There must be at least 2 options.",
            "slider_description": "For a slider there's a minimum and maximum valuation. The slider always has a step size of 1. The bigger the difference the more precise a user is able to answer.",
            "statement_description": "A player can react to a statement. The minimal valuation means that the player strongly disagrees, the maximum valuation means the player strongly agrees. The bigger the difference the more precise a user is able to answer.",
            "optional_description": "If the question is marked optional, the player can leave the answer empty.",
            "properties": {
                "minimal_valuation": "Minimal valuation",
                "maximal_valuation": "Maximal valuation",
                "min_text": "Min text",
                "max_text": "Max text",
                "image": "Image",
                "image_select": "Select an image"
            },
            "actions": {
                "create": {
                    "action": "Add survey entry",
                    "success": "Survey entry created",
                    "failed": "Unable to create the survey entry"
                },
                "update": {
                    "action": "Edit survey entry",
                    "success": "Survey entry updated",
                    "failed": "Unable to update the survey entry"
                },
                "delete": {
                    "action": "Remove survey entry",
                    "confirm": "When removing a survey entry, it will be removed from the survey immediately. Are you sure you want to continue?",
                    "success": "Survey entry removed",
                    "failed": "Unable to remove the survey entry"
                },
                "restore": {
                    "action": "Restore survey entry",
                    "confirm": "When restoring a survey entry, it will be part of the survey immediately. Are you sure you want to continue?",
                    "success": "Survey entry restored",
                    "failed": "Unable to restore the survey entry"
                },
                "order": {
                    "success": "Updated the order of the survey entries",
                    "failed": "Unable to update the order of the survey entries"
                }
            }
        },
        "tag": {
            "tag": "Tag",
            "tags": "Tags",
            "edit_tags": "Edit tags",
            "select_placeholder": "Select tags",
            "select_all": "All tags",
            "assigned_users": "Assigned users",
            "management": {
                "description": "A tag can be added to a user."
            },
            "properties": {
                "name": "Name",
                "identifier": "Identifier",
                "description": "Description"
            },
            "actions": {
                "create": {
                    "action": "Create tag",
                    "success": "Tag created",
                    "failed": "Unable to create the tag"
                },
                "update": {
                    "action": "Edit tag",
                    "success": "Tag updated",
                    "failed": "Unable to update the tag"
                },
                "delete": {
                    "action": "Remove tag",
                    "confirm": "When removing a tag, the tag is directly removed for all users and campaigns. Are you sure you want to continue?",
                    "success": "Tag removed",
                    "failed": "Unable to remove the tag",
                    "failed_in_use_by_onboarding": "The tag cannot be removed because it is still in use by an onboarding answer."
                },
                "restore": {
                    "action": "Restore tag",
                    "confirm": "When restoring a tag, the tag is directly accessible. Are you sure you want to continue?",
                    "success": "Tag restored",
                    "failed": "Unable to restore the tag"
                },
                "bulk": {
                    "action": "Bulk tag users",
                    "success_assign": "Tag assigned to users.",
                    "success_revoke": "Tag revoked from users."
                }
            },
            "validations": {
                "not_owned": "The tag doesn't belong to your organisation",
                "user_missing_tag": "The tag can't be removed as it isn't assigned to the user",
                "user_missing_organisation": "The tag can't be added to a user that isn't linked to the same organisation"
            },
            "onboarding": {
                "title": "Tags from onboarding",
                "description": "These tags are automatically assigned to the user based on their onboarding answers. These tags cannot be unassigned unless the user changes their answers.",
                "description_secondary": "In case you assign a tags that was already assigned through onboarding, it will be converted to a manually assigned tag. This tag will not be automatically unassigned anymore when the user changes their answers."
            }
        },
        "take_away": {
            "take_away": "Take away",
            "take_aways": "Take aways",
            "policy": {
                "denied": "You are not allowed to manage this Take away"
            },
            "actions": {
                "create": {
                    "failed": "Unable to create the Take away"
                },
                "update": {
                    "failed": "Unable to update the Take away"
                }
            }
        },
        "take_away_session": {
            "policy": {
                "denied": "You are not allowed to manage this Take away session"
            },
            "actions": {
                "create": {
                    "failed": "Unable to create the Take away session"
                },
                "update": {
                    "failed": "Unable to update the Take away session"
                },
                "results": {
                    "failed": "Unable to generate the results of the Take away session"
                }
            },
            "pdf_mail": {
                "subject": "Take Away :name",
                "intro": "Take Away",
                "text": "You requested the :name take away. View the result in the attachment."
            }
        },
        "theme": {
            "theme": "Theme",
            "themes": "Themes",
            "manage": "Manage",
            "manage_organisation_theme": "Manage organisation theme",
            "fonts": "Fonts",
            "font_description": "This will give the theme the client's preferred fonts.",
            "primary_font": "Primary font",
            "secondary_font": "Secondary font",
            "colors": "Colors",
            "color_description": "This will give the theme the client's preferred colors.",
            "primary_color": "Primary color",
            "secondary_color": "Secondary color",
            "accent_color": "Accent color",
            "card_style": "Card style",
            "card_style_description": "This will give the theme the client's preferred cardstyle.",
            "border_radius": "Border Radius",
            "edit_save_button": "Save changes"
        },
        "tournament": {
            "status": {
                "currently_busy": "Currently busy",
                "done": "Ended"
            }
        },
        "translation": {
            "translations": "Translations",
            "translation": "Translation",
            "properties": {
                "key": "System key",
                "message": "Text"
            },
            "filter": {
                "all_locales": "All locales",
                "locale": "Locale"
            },
            "actions": {
                "update": {
                    "success": "Translation updated",
                    "failed": "Unable to update the translations"
                }
            }
        },
        "user": {
            "user": "User",
            "users": "Users",
            "user_count": ":count user|:count users",
            "demo_user": "Guest user",
            "demo_user_not_allowed": "Playing as a demo user isn't enabled",
            "demo_user_not_possible": "Playing as a demo user isn't possible at the moment",
            "demo_user_notice": "You play as a guest user. Please note: your score will not be saved. Ask your manager for an account that can track your progress and score.",
            "demo_user_notice_no_upgrade": "You play as a guest user. Please note: your score will not be saved. Ask your manager for an account that can track your progress and score.",
            "administrator": "Administrator",
            "administrator_description": "An administrator is allowed to manage the whole app. Make sure you only assign this rights when required!",
            "manager": "Manager",
            "manager_description": "A manager is allowed to manage the users of the organisation.",
            "name": "Name",
            "email": "E-mail address",
            "password": "Password",
            "password_create": "Leave the password empty to automatically generate one.",
            "password_edit": "Leave the password empty if you don't want to change it.",
            "password_confirm": "Confirm password",
            "expires_at": "Expires at",
            "language": "Language",
            "language_description": "Add your languages and sort them by preference. Should an organisation you are a member of not support any of these languages, the site will be displayed in the organisation's default language.",
            "add_preferred_language": "Add preferred language",
            "tags": "Tags",
            "permissions": "Permissions",
            "edit_user_roles": "Edit user roles",
            "select_placeholder": "Select users",
            "is_manager": "Is manager",
            "is_administrator": "Is administrator",
            "is_anonymous": "Is demo user",
            "added_at": "Added at",
            "modified_at": "Modified at",
            "user_added": "User added",
            "last_modified": "Last modified",
            "unable_to_create": "Unable to create the user",
            "unable_to_create_is_integration": "Unable to create the user because it already exists as an integration user",
            "unable_to_create_membership": "Unable to create the membership for user to the organisation",
            "invite_sent": "Invite sent",
            "unable_to_sent_invite": "Unable to sent the invite",
            "invite_sent_again": "Invite sent again",
            "invite_accepted": "Invite accepted. Welcome to the :app",
            "invite_removed": "Invite removed",
            "unable_to_remove_invite": "Unable to remove the invite",
            "create": "Create user",
            "created": "User created",
            "created_without_rights": "User created but unable to set the rights",
            "created_without_membership": "User created but unable to join the current organisation",
            "created_with_password": "User created with the password <code>:password<\/code>",
            "updated": "User updated",
            "updated_without_rights": "User updated but unable to update the rights",
            "unable_to_update": "Unable to update the user",
            "remove": "Remove user",
            "remove_confirmation": "The user will be removed from this organisation and will lose access immediately. Are you sure you want to continue?",
            "removed": "User removed",
            "unable_to_remove": "Unable to remove the user",
            "invalid_email_address": "Invalid e-mail address",
            "invalid_password": "Password doesn't match the requirements",
            "invalid_language": "Language is invalid",
            "tag_does_not_exist": "The label \":tag\" cannot be added because it does not exist",
            "email_or_name_required": "At least an e-mail address or name is required",
            "invites": "Invites",
            "invite": "Invite",
            "accept_invite": "Accept invite",
            "accept_invite_description": "To finish your registration, we need some more information.",
            "invalid_invite": "Invalid invite",
            "invalid_invite_description": "Sorry, but the token is invalid or the invitation has expired. Ask your instructor for a new invite.",
            "revoke_invite": "Revoke invite",
            "revoke_invite_description": "By revoking the invite, the recipient is no longer able to accept the invite. Are you sure you want to revoke the invite?",
            "send_invite": "Send invite",
            "invite_description": "The provided e-mail address will receive an invite per mail for this organisation.",
            "invite_email_exists": "The provided e-mail address shouldn't already have an existing user.",
            "import": "Import",
            "import_file": "Source file",
            "import_file_select": "Select source file",
            "import_file_description": "The file must be a CSV or Excel file and its not required to have a specific structure. In the next steps you will be able to determine the columns.",
            "import_file_description_existing_user": "When a user already has an account for the :app, the account will be added to this organisation.",
            "import_users": "Import users",
            "imported_users": "Users imported",
            "import_determine_columns": "Determine columns",
            "import_results": "Results",
            "import_select_file": "Select file",
            "import_existing_user": "Existing user",
            "import_message": "Message",
            "import_column": "Column",
            "import_ignore_column": "Ignore column",
            "import_skip_first_row": "Skip first row",
            "import_skip_first_row_description": "Useful when the first row contains a header.",
            "import_preview_stats": "There are <code>:rows<\/code> rows found and there are <code>:preview<\/code> rows shown as preview.",
            "import_user_not_imported": "User not imported",
            "import_user_imported_with_warnings": "User imported with warnings",
            "import_user_imported": "User imported",
            "import_only_existing_tags": "Only <a href=\":manage_labels\">labels<\/a> that exist will be added to users. Please make sure all the labels you want to import exist before importing.",
            "user_profile": "User profile",
            "add_user": "Add user",
            "edit_user": "Edit user",
            "user_role": "User role",
            "user_roles": "User roles",
            "account_settings": "Account settings",
            "personal_details": "Personal details",
            "validations": {
                "must_be_part_of_organisation": "The user must be a member of the organisation",
                "must_not_be_part_of_organisation": "The user must not be a member of the organisation"
            },
            "invitation": {
                "subject": "Invitation for :app",
                "intro": "Invitation :app",
                "text": "Herewith an invitation to :app on behalf of :organisation. Accept the invitation via the link below to create an account and start playing.",
                "valid_until": "This invitation is valid until :expires_at.",
                "enjoy": "Have fun!",
                "accept": "Accept invitation"
            },
            "actions": {
                "delete": {
                    "action": "Remove profile",
                    "confirm": "When you remove your profile you won't be able to play anymore. In case you logged in with your company account, the next time you log in you won't have any progress anymore. Are you sure you want to continue?",
                    "success": "Profile removed",
                    "failed": "Unable to remove your profile",
                    "warning": "Deleting your account is irreversible"
                }
            },
            "roles": {
                "reseller": {
                    "name": "Reseller",
                    "description": "Gamemasters from partners"
                },
                "manager": {
                    "name": "Manager",
                    "description": "Manager for organisation"
                },
                "user": {
                    "name": "User",
                    "description": "Client\/Employee\/User"
                },
                "administrator": {
                    "name": "Administrator",
                    "description": "Administrator"
                }
            },
            "not_visible_by_demo_user": "Not visible for demo users",
            "cannot_be_admin_because_sso": "This user has connected SSO identities and cannot be an administrator for security reasons.",
            "sso_user": "SSO user",
            "password_change_not_possible": "It is not possible to change the password of this user.",
            "roles_change_not_possible": "It is not possible to change the roles of this user.",
            "integration_user": "Integration user",
            "user_status": "User status",
            "anonymous_users": "Guest users",
            "non_anonymous_users": "Non-guest users"
        },
        "validation": {
            "accepted": "The :attribute must be accepted.",
            "accepted_if": "The :attribute must be accepted when :other is :value.",
            "active_url": "The :attribute is not a valid URL.",
            "after": "The :attribute must be a date after :date.",
            "after_or_equal": "The :attribute must be a date after or equal to :date.",
            "alpha": "The :attribute must only contain letters.",
            "alpha_dash": "The :attribute must only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The :attribute must only contain letters and numbers.",
            "array": "The :attribute must be an array.",
            "ascii": "The :attribute must only contain single-byte alphanumeric characters and symbols.",
            "attached": "The :attribute is already attached.",
            "before": "The :attribute must be a date before :date.",
            "before_or_equal": "The :attribute must be a date before or equal to :date.",
            "between": {
                "array": "The :attribute must have between :min and :max items.",
                "file": "The :attribute must be between :min and :max kilobytes.",
                "numeric": "The :attribute must be between :min and :max.",
                "string": "The :attribute must be between :min and :max characters."
            },
            "boolean": "The :attribute field must be true or false.",
            "can": "The :attribute field contains an unauthorized value.",
            "confirmed": "The :attribute confirmation does not match.",
            "contains": "The :attribute field is missing a required value.",
            "current_password": "The password is incorrect.",
            "date": "The :attribute is not a valid date.",
            "date_equals": "The :attribute must be a date equal to :date.",
            "date_format": "The :attribute does not match the format :format.",
            "decimal": "The :attribute must have :decimal decimal places.",
            "declined": "The :attribute must be declined.",
            "declined_if": "The :attribute must be declined when :other is :value.",
            "different": "The :attribute and :other must be different.",
            "digits": "The :attribute must be :digits digits.",
            "digits_between": "The :attribute must be between :min and :max digits.",
            "dimensions": "The :attribute has invalid image dimensions.",
            "distinct": "The :attribute field has a duplicate value.",
            "doesnt_end_with": "The :attribute may not end with one of the following: :values.",
            "doesnt_start_with": "The :attribute may not start with one of the following: :values.",
            "email": "The :attribute must be a valid email address.",
            "ends_with": "The :attribute must end with one of the following: :values.",
            "enum": "The selected :attribute is invalid.",
            "exists": "The selected :attribute is invalid.",
            "extensions": "The :attribute field must have one of the following extensions: :values.",
            "file": "The :attribute must be a file.",
            "filled": "The :attribute field must have a value.",
            "gt": {
                "array": "The :attribute must have more than :value items.",
                "file": "The :attribute must be greater than :value kilobytes.",
                "numeric": "The :attribute must be greater than :value.",
                "string": "The :attribute must be greater than :value characters."
            },
            "gte": {
                "array": "The :attribute must have :value items or more.",
                "file": "The :attribute must be greater than or equal to :value kilobytes.",
                "numeric": "The :attribute must be greater than or equal to :value.",
                "string": "The :attribute must be greater than or equal to :value characters."
            },
            "hex_color": "The :attribute field must be a valid hexadecimal color.",
            "image": "The :attribute must be an image.",
            "in": "The selected :attribute is invalid.",
            "in_array": "The :attribute field does not exist in :other.",
            "integer": "The :attribute must be an integer.",
            "ip": "The :attribute must be a valid IP address.",
            "ipv4": "The :attribute must be a valid IPv4 address.",
            "ipv6": "The :attribute must be a valid IPv6 address.",
            "json": "The :attribute must be a valid JSON string.",
            "list": "The :attribute field must be a list.",
            "lowercase": "The :attribute must be lowercase.",
            "lt": {
                "array": "The :attribute must have less than :value items.",
                "file": "The :attribute must be less than :value kilobytes.",
                "numeric": "The :attribute must be less than :value.",
                "string": "The :attribute must be less than :value characters."
            },
            "lte": {
                "array": "The :attribute must not have more than :value items.",
                "file": "The :attribute must be less than or equal to :value kilobytes.",
                "numeric": "The :attribute must be less than or equal to :value.",
                "string": "The :attribute must be less than or equal to :value characters."
            },
            "mac_address": "The :attribute must be a valid MAC address.",
            "max": {
                "array": "The :attribute must not have more than :max items.",
                "file": "The :attribute must not be greater than :max kilobytes.",
                "numeric": "The :attribute must not be greater than :max.",
                "string": "The :attribute must not be greater than :max characters."
            },
            "max_digits": "The :attribute must not have more than :max digits.",
            "mimes": "The :attribute must be a file of type: :values.",
            "mimetypes": "The :attribute must be a file of type: :values.",
            "min": {
                "array": "The :attribute must have at least :min items.",
                "file": "The :attribute must be at least :min kilobytes.",
                "numeric": "The :attribute must be at least :min.",
                "string": "The :attribute must be at least :min characters."
            },
            "min_digits": "The :attribute must have at least :min digits.",
            "missing": "The :attribute field must be missing.",
            "missing_if": "The :attribute field must be missing when :other is :value.",
            "missing_unless": "The :attribute field must be missing unless :other is :value.",
            "missing_with": "The :attribute field must be missing when :values is present.",
            "missing_with_all": "The :attribute field must be missing when :values are present.",
            "multiple_of": "The :attribute must be a multiple of :value.",
            "not_in": "The selected :attribute is invalid.",
            "not_regex": "The :attribute format is invalid.",
            "numeric": "The :attribute must be a number.",
            "password": {
                "letters": "The :attribute must contain at least one letter.",
                "mixed": "The :attribute must contain at least one uppercase and one lowercase letter.",
                "numbers": "The :attribute must contain at least one number.",
                "symbols": "The :attribute must contain at least one symbol.",
                "uncompromised": "The given :attribute has appeared in a data leak. Please choose a different :attribute."
            },
            "present": "The :attribute field must be present.",
            "present_if": "The :attribute field must be present when :other is :value.",
            "present_unless": "The :attribute field must be present unless :other is :value.",
            "present_with": "The :attribute field must be present when :values is present.",
            "present_with_all": "The :attribute field must be present when :values are present.",
            "prohibited": "The :attribute field is prohibited.",
            "prohibited_if": "The :attribute field is prohibited when :other is :value.",
            "prohibited_unless": "The :attribute field is prohibited unless :other is in :values.",
            "prohibits": "The :attribute field prohibits :other from being present.",
            "relatable": "This :attribute may not be associated with this resource.",
            "regex": "The :attribute format is invalid.",
            "required": "The :attribute field is required.",
            "required_array_keys": "The :attribute field must contain entries for: :values.",
            "required_field": "This field is required.",
            "required_if": "The :attribute field is required when :other is :value.",
            "required_if_accepted": "The :attribute field is required when :other is accepted.",
            "required_if_declined": "The :attribute field is required when :other is declined.",
            "required_unless": "The :attribute field is required unless :other is in :values.",
            "required_with": "The :attribute field is required when :values is present.",
            "required_with_all": "The :attribute field is required when :values are present.",
            "required_without": "The :attribute field is required when :values is not present.",
            "required_without_all": "The :attribute field is required when none of :values are present.",
            "rgba_color": "The :attribute field must contain a valid Rgba color",
            "rgba_color_white": "The :attribute field may not be white",
            "same": "The :attribute and :other must match.",
            "scalar": "The :attribute must be an number, string, or boolean value.",
            "size": {
                "array": "The :attribute must contain :size items.",
                "file": "The :attribute must be :size kilobytes.",
                "numeric": "The :attribute must be :size.",
                "string": "The :attribute must be :size characters."
            },
            "starts_with": "The :attribute must start with one of the following: :values.",
            "string": "The :attribute must be a string.",
            "timezone": "The :attribute must be a valid timezone.",
            "unique": "The :attribute has already been taken.",
            "unique_archived": ":Attribute already exists in an archived :model",
            "uploaded": "The :attribute failed to upload.",
            "uppercase": "The :attribute must be uppercase.",
            "url": "The :attribute must be a valid URL.",
            "ulid": "The :attribute must be a valid ULID.",
            "uuid": "The :attribute must be a valid UUID.",
            "youtube_video_url": "The :attribute must contains a valid YouTube video URL.",
            "vimeo_video_url": "The :attribute must contains a valid Vimeo video URL.",
            "not_valid_in_values": ":Attribute is no valid value. Use one of the following values :values",
            "custom_field_key_required": "The name is required when a value is provided",
            "custom_field_key_string": "The name must be a string",
            "custom_field_value_required": "The value is required when a key is provided",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "primary_color": "Primary color",
                "secondary_color": "Secondary color",
                "primary_font_color": "Primary font color",
                "secondary_font_color": "Secondary font color",
                "primary_font_family": "Primary font family",
                "secondary_font_family": "Secondary font family",
                "available_languages": "Available languages",
                "is_global": "Is global",
                "organisations": "Organisations",
                "start_date": "Start date",
                "end_date": "End date",
                "confirm": "Confirm",
                "total_questions_used": "Total questions to show",
                "file": "File",
                "size": "Size"
            }
        },
        "webhook": {
            "webhook": "Webhook",
            "webhooks": "Webhooks",
            "description": "Overview from failed webhooks",
            "trigger": "Trigger webhook",
            "events": "Events",
            "response": "Response",
            "select": {
                "organisation": "Select organisation",
                "event": "Select event"
            },
            "properties": {
                "start_date": "Start date",
                "end_date": "End date",
                "url": "URL",
                "event": "Event",
                "status": "Status code",
                "status_message": "Status message",
                "created_at": "Date",
                "payload": "Payload"
            },
            "events_sent_successfully": "Webhook events sent between :startDate and :endDate are sent again",
            "amount_of_calls": "Amount of webhook calls"
        }
    },
    "nl": {
        "achievement": {
            "achievement": "Achievement",
            "achievements": "Achievements",
            "overview_description": "Overzicht van alle beschikbare achievements of all available achievements",
            "select_campaign": "Selecteer campagne",
            "go_to_achievements": "Ga naar achievements",
            "properties": {
                "name": "Naam",
                "once": "Eenmalig",
                "score": "Score",
                "award": "Bonus",
                "is_secret": "Geheim",
                "image": "Afbeelding",
                "image_select": "Selecteer afbeelding"
            },
            "time": {
                "today": "vandaag",
                "yesterday": "gisteren",
                "two_days_ago": "eergisteren",
                "this_week": "deze week",
                "last_week": "vorige week",
                "two_weeks_ago": "twee weken geleden",
                "three_weeks_ago": "drie weken geleden",
                "four_weeks_ago": "vier weken geleden",
                "five_weeks_ago": "vijf weken geleden"
            },
            "status": {
                "status": "Status",
                "playing": "Lopend",
                "completed": "Behaald",
                "not_completed": "Verzamel alle achievements!",
                "last_achievement": "Laatste achievement",
                "no_last_achievement": "U heeft nog geen achievement gehaald"
            },
            "actions": {
                "grant": {
                    "failed": "Het is niet gelukt om de achievement uit te reiken"
                },
                "enable": {
                    "button": "Aanzetten"
                },
                "disable": {
                    "button": "Uitzetten",
                    "action": "Achievement uitzetten",
                    "confirm": "Weet u zeker dat u deze achievement wilt uitschakelen? Dit zal alle aanpassingen aan deze achievement verwijderen."
                }
            },
            "validations": {
                "not_found": "Achievement niet gevonden"
            },
            "organisation_enabled": {
                "label": "Ingeschakelde achievements",
                "description": "Deze achievements zijn standaard ingeschakeld bij het maken van campagnes voor deze organisatie."
            },
            "organisation_available": {
                "label": "Beschikbare achievements",
                "description": "Kies de achievements die u standaard wilt inschakelen voor deze organisatie."
            },
            "game_enabled": {
                "label": "Ingeschakelde achievements",
                "description": "Deze achievements zijn ingeschakeld voor deze campagne."
            },
            "game_available": {
                "label": "Beschikbare achievements",
                "description": "Kies de achievements die u wilt inschakelen voor deze campagne."
            },
            "configurations": {
                "global": {
                    "label": "Globale configuratie",
                    "description": "Deze configuraties zijn van toepassing op de gehele applicatie."
                },
                "general": {
                    "label": "Algemene configuratie",
                    "description": "Algemene eigenschappen van deze achievement."
                },
                "custom": {
                    "label": "Aangepaste eigenschappen",
                    "description": "Eigenschappen die specifiek zijn voor deze achievement en invloed hebben op wanneer deze wordt toegekend."
                },
                "is_secret": {
                    "label": "Geheime achievement",
                    "help": "De achievement wordt niet weergegeven tenzij deze is toegekend."
                },
                "once": {
                    "label": "Kan slechts \u00e9\u00e9n keer worden toegekend"
                },
                "score": {
                    "label": "Bonus score die wordt toegekend"
                },
                "name": {
                    "label": "Naam"
                },
                "description": {
                    "label": "Omschrijving",
                    "help": "Gebruik de identifiers naast de aangepaste eigenschappen om deze in de omschrijving te vervangen."
                }
            }
        },
        "answer": {
            "answer": "Antwoord",
            "answers": "Antwoorden",
            "properties": {
                "correct": "Correct",
                "correct_answer": "Correct antwoord",
                "correct_answers": "Correcte antwoorden",
                "correct_answer_description": "Dit is het correcte antwoord op de vraag",
                "possible_answers": "Mogelijke antwoorden",
                "provided_answer": "Gegeven antwoord"
            },
            "actions": {
                "create": {
                    "action": "Antwoord toevoegen",
                    "success": "Antwoord toegevoegd",
                    "failed": "Kan het antwoord niet toevoegen"
                },
                "update": {
                    "action": "Antwoord wijzigen",
                    "success": "Antwoord gewijzigd",
                    "failed": "Kan het antwoord niet wijzigen"
                },
                "delete": {
                    "action": "Antwoord verwijderen",
                    "confirm": "Wanneer je het antwoord verwijderd, zal deze niet meer worden gegeven bij de vraag. Weet je zeker dat je het antwoord wilt verwijderen?",
                    "success": "Antwoord verwijderd",
                    "failed": "Kan het antwoord niet verwijderen"
                },
                "restore": {
                    "action": "Antwoord herstellen",
                    "confirm": "Wanneer u het antwoord herstelt, zal het antwoord onmiddellijk zichtbaar zijn. Weet u zeker dat u door wilt gaan?",
                    "success": "Antwoord hersteld",
                    "failed": "Kan het antwoord niet herstellen"
                }
            },
            "validations": {
                "invalid_answer_provided": "Ongeldig antwoord gegeven"
            }
        },
        "api_token": {
            "api_tokens": "API tokens",
            "api_token": "API token",
            "overview_description": "Beheer de API tokens van verbonden applicaties",
            "not_expiring": "Geen vervaldatum",
            "none_assigned": "Er zijn geen toegewezen API-tokens.",
            "properties": {
                "name": "Naam",
                "expires_at": "Vervalt op",
                "created_by": "Gemaakt door",
                "is_global": "Globaal token",
                "is_global_description": "Een globaal token kan worden gebruikt om toegang te krijgen tot de data van alle organisaties.",
                "organisations": "Organisaties"
            },
            "actions": {
                "create": {
                    "success": "API token toegevoegd",
                    "failed": "Kan de API token niet toevoegen"
                },
                "update": {
                    "action": "Wijzig API token",
                    "success": "API token gewijzigd",
                    "failed": "Kan de API token niet wijzigen"
                },
                "delete": {
                    "action": "API token verwijderen",
                    "confirm": "Wanneer de API token wordt verwijderd zal de app die deze API token gebruikt direct toegang verliezen. Weet je zeker dat je de API token wilt verwijderen?",
                    "success": "API token verwijderd",
                    "failed": "Kan de API token niet verwijderen"
                },
                "show": {
                    "failed": "Kan de API token niet tonen"
                },
                "generate": {
                    "failed": "Kan de API token niet genereren"
                },
                "sync": {
                    "action": "Wijzig organisaties",
                    "success": "Organisaties van de API token gewijzigd",
                    "is_global": "Organisaties van een globaal API-token kunnen niet worden gewijzigd"
                }
            },
            "validations": {
                "organisation_not_accessible": "De organisatie is niet toegankelijk",
                "user_not_accessible": "De gebruiker is niet toegankelijk",
                "module_session_not_accessible": "De modulesessie is niet toegankelijk",
                "take_away_session_not_accessible": "De Take Away sessie is niet toegankelijk"
            }
        },
        "app_score": {
            "actions": {
                "create": {
                    "failed": "Kan de app score niet bijwerken"
                }
            },
            "scores_filled_in": "beide scores zijn al ingevuld",
            "finished": {
                "start_again": "Opnieuw beginnen",
                "finish_workout": "Finish workout",
                "score_achieved": "Score behaald",
                "text": "Uitmuntende inspanning! Ben je klaar voor de volgende training of wil je je score overtreffen?"
            }
        },
        "auth": {
            "email": "E-mail adres",
            "password_field": "Wachtwoord",
            "password_label": "Vul wachtwoord in",
            "register": {
                "register": "Registreren",
                "description": "Maak een account voor :app. Door het aanmaken van een account zal je voortgang worden bewaard en overal beschikbaar zijn.",
                "no_account": "Geen account?",
                "no_account_description": "Wanneer je nog geen account hebt, klik op deze <a href=\":link\">link<\/a>.",
                "already_has_account": "Heb je al een account?",
                "not_allowed": "Registratie niet toegestaan",
                "not_allowed_description": "Sorry, maar deze organisatie heeft de registratie uitgeschakeld. Vraag je instructeur om een uitnodiging.",
                "register_not_allowed": "Registreren niet toegestaan",
                "register_not_allowed_description": "Sorry, maar deze organisation heeft registreren uitgezet. Vraag je instructeur om een uitnodiging."
            },
            "reseller": {
                "not_allowed": "Organisatie is geen reseller",
                "not_allowed_description": "Sorry, maar deze organisatie is geen reseller. Neem contact op met je accountmanager voor reseller toegang."
            },
            "demo": {
                "play": "Speel zonder in te loggen",
                "description": "Als je speelt zonder in te loggen wordt je score niet bijgehouden. Je kunt je registreren als speler, dan wordt je score opgeslagen.",
                "description_no_registration": "Maak kennis met een selectie van games in de app. Wanneer je speelt zonder in te loggen worden je scores niet opgeslagen."
            },
            "login": {
                "login": "Inloggen",
                "remember_me": "Onthouden",
                "required": "Je moet ingelogd zijn om deze actie te kunnen uitvoeren",
                "no_access": "Je hebt geen toegang tot deze organisatie"
            },
            "logout": {
                "logout": "Uitloggen"
            },
            "forgotten": {
                "password_instructions": "Vul de gegevens in om je wachtwoord te wijzigen.",
                "change_password": "Wijzig wachtwoord",
                "reset_link_sent": "Wanneer je e-mail adres is gevonden zal je hierop instructies ontvangen. Controleer je e-mail en klik op de link in de e-mail om je wachtwoord te wijzigen.",
                "reset_link_not_sent": "Helaas is het niet gelukt om de e-mail met instructies te versturen. Neem contact op met je instructeur voor hulp.",
                "send_instructions": "Stuur instructies",
                "confirm_password": "Bevestig wachtwoord",
                "confirm_password_description": "Bevestig je wachtwoord om door te gaan.",
                "forgot_password": "Wachtwoord vergeten",
                "forgot_password_description": "Wanneer je je wachtwoord bent vergeten, vul dan hier je e-mail adres in. Daarna ontvang je een e-mail met instructies hoe je je wachtwoord kunt veranderen.",
                "forgot_your_password": "Wachtwoord vergeten?",
                "check_spam_folder": "Als je de e-mail niet binnen een paar minuten ziet, controleer dan de map \"ongewenste e-mail\" of \"spam\".",
                "mail": {
                    "explanation": "Je ontvangt deze e-mail omdat we een verzoek hebben ontvangen om je wachtwoord opnieuw in te stellen voor je account.",
                    "reset_password": "Wachtwoord opnieuw instellen",
                    "reset_password_link": "Stel je wachtwoord opnieuw in door op deze link te klikken: :link",
                    "link_expires": "Deze wachtwoord reset link verloopt in :count minuten.",
                    "not_requested": "Als je geen wachtwoord reset hebt aangevraagd, is er geen verdere actie vereist."
                }
            },
            "verify": {
                "verify": "Bevestig je e-mail adres",
                "click_below": "Klik op de onderstaande knop om je e-mailadres te verifi\u00ebren.",
                "check_email": "Er is een verificatielink naar uw e-mailadres gestuurd met een link om uw registratie te voltooien.",
                "resent": "Een nieuwe verificatie link is verstuurd naar je e-mail adres.",
                "before": "Voordat je verder gaat, check je e-mail om je account te bevestigen.",
                "not_received": "Wanneer je geen e-mail hebt ontvangen",
                "request": "klik hier om de e-mail nogmaals te verzenden",
                "not_requested": "Als u geen account heeft aangemaakt, hoeft u verder niets te doen.",
                "expires_in": "De link verloopt in :minutes minuten.",
                "not_valid": "De verificatielink is niet meer geldig. Vraag een nieuwe link aan."
            },
            "account_exists": {
                "exists": "Je hebt je geprobeerd te registeren maar je hebt al een account.",
                "forgot_password": "Als je je wachtwoord bent vergeten, kun je deze opnieuw instellen via \"Wachtwoord vergeten\"."
            },
            "universal": {
                "organisations": {
                    "select": "Selecteer organisatie",
                    "none": "Dit account is geen lid van een organisatie. Vraag je instructeur om je toe te voegen aan de organisatie."
                }
            },
            "delete": {
                "verify": "Bevestig account verwijdering",
                "click_below": "Klik op de onderstaande knop om te bevestigen dat je je account wilt verwijderen.",
                "not_requested": "Als je geen account verwijdering hebt aangevraagd, hoef je verder niets te doen.",
                "mail_sent": "Als dit e-mailadres bestaat, ontvangt u een e-mail. Klik op de link in de e-mail om te bevestigen dat u uw account wilt verwijderen.",
                "confirm": "Ik weet wat de gevolgen zijn, en ik weet zeker dat ik mijn account wil verwijderen"
            },
            "sso": {
                "generic": "Sorry, er is iets misgegaan bij het inloggen met single sign-on. Probeer het opnieuw.",
                "no_id": ":configuration: geen unieke identifier verstrekt door provider.",
                "no_email": ":configuration: geen e-mailadres verstrekt door provider.",
                "prohibited": "Inloggen via SSO is verboden voor deze gebruiker.",
                "not_a_member": "Je moet zijn uitgenodigd voor deze organisatie voordat je kunt inloggen.",
                "user_data_request_error": ":configuration: provider reageerde met foutcode :code. Probeer het opnieuw en neem contact op met support als de fout zich blijft voordoen."
            },
            "failed": "Deze combinatie van e-mailadres en wachtwoord is niet geldig.",
            "password": "Het opgegeven wachtwoord is onjuist.",
            "throttle": "Te veel mislukte aanmeldpogingen. Probeer het over nog eens over :seconds seconden.",
            "pending_invitation": "Accepteer je uitnodiging voordat je inlogt.",
            "get_mobile_app": {
                "title": "Installeer de mobiele app",
                "description": "Installeer onze mobiele app voor een betere ervaring.",
                "download_app_store": "Download in de App Store",
                "download_play_store": "Ontdek het op Google Play"
            },
            "no_access_logged_out": "Je hebt geen toegang tot deze organisatie. Log opnieuw in met een account dat wel toegang heeft."
        },
        "battle": {
            "battle": "Battle",
            "battles": "Battles",
            "completed_battles": "Afgeronde Battles",
            "battle_leaderboard": "Battle scorebord",
            "battle_arena": "Battle Arena",
            "view_battle": "Battle bekijken",
            "view_leaderboard": "Bekijk leaderboard",
            "view_my_achievements": "Mijn achievements",
            "dashboard_tile": {
                "starts_soon": "Battle begint binnenkort!",
                "ended": "Battle afgelopen",
                "ended_subtext": "De battle is afgelopen en kan niet meer worden gespeeld"
            },
            "properties": {
                "name": "Naam",
                "description": "Omschrijving",
                "win_score": "Winst bonus",
                "lose_factor": "Percentage van de winstbonus die de verliezer ontvangt",
                "score_factor": "Score factor bij winst op hoger gerankte speler",
                "response_time": "Reactietijd",
                "daily_limit": "Daglimiet",
                "available": "Beschikbaar",
                "available_from": "Beschikbaar vanaf",
                "available_till": "Beschikbaar tot",
                "no_limit": "Geen limiet",
                "hours": "uur",
                "simultaneous_open_sessions": "Gelijktijdig open sessies",
                "simultaneous_open_sessions_unlimited": "Onbeperkt",
                "image": "Afbeelding",
                "image_select": "Selecteer afbeelding"
            },
            "insights": {
                "wins": "Gewonnen",
                "count_completed_sessions": "# voltooide sessies",
                "count_unaccepted_sessions": "# niet geaccepteerde sessies",
                "average_score": "Gemiddelde score",
                "count_unique_initiators": "# unieke uitdagers",
                "count_unique_opponents": "# unieke tegenstanders",
                "percentage_of_sessions_where_opponent_wins": "% van de voltooide sessies waarin de tegenstander won",
                "average_time_to_complete_micro_game": "Gemiddelde tijd om micro game te voltooien",
                "average_time_to_accept_invitation": "Gemiddelde tijd dat een uitnodiging open staat",
                "average_time_to_complete_session": "Gemiddelde tijd voor een sessie om voltooid te worden"
            },
            "actions": {
                "create": {
                    "action": "Battle toevoegen",
                    "success": "Battle toegevoegd",
                    "failed": "Kan de battle niet toevoegen"
                },
                "update": {
                    "action": "Battle wijzigen",
                    "success": "Battle gewijzigd",
                    "failed": "Kan de battle niet wijzigen"
                },
                "delete": {
                    "action": "Battle verwijderen",
                    "confirm": "Wanneer een battle wordt verwijderd, is deze direct niet meer toegankelijk voor de spelers. Weet je zeker dat je deze battle wilt verwijderen?",
                    "success": "Battle verwijderd",
                    "failed": "Kan de battle niet verwijderen"
                },
                "stop": {
                    "action": "Battle stoppen",
                    "confirm": "Wanneer een battle wordt gestopt, is deze direct niet meer toegankelijk voor de spelers. Weet je zeker dat je deze battle wilt stoppen?",
                    "success": "Battle gestopt",
                    "failed": "Kan de battle niet stoppen"
                }
            },
            "filter": {
                "no_campaign": "Geen campagne",
                "select_campaign": "Selecteer campagne"
            },
            "validations": {
                "not_owned": "De battle is niet van de huidige organisatie",
                "already_played": "Deze battle is al gespeeld door sommige gebruikers.",
                "overlaps": "Battle kan niet overlappen met andere battles.",
                "no_micro_games": "Deze campagne heeft geen micro game modules.",
                "outside_tournament": "Deze waarde ligt buiten de tijden van het toernooi.",
                "micro_games_required": "Je moet een micro game kiezen als er geen campagne is geselecteerd."
            },
            "session": {
                "sessions": "Sessies",
                "date": "Datum",
                "initiator": "Uitdager",
                "opponent": "Tegenstander",
                "bonus": "Bonus",
                "not_found": "Battle sessie niet gevonden"
            },
            "picked_randomly": "willekeurig gekozen",
            "pick_random_microgame": "Kies een willekeurige micro game uit de campagne",
            "expired": "Battle is verlopen",
            "not_found": "Battle niet gevonden",
            "no_active": "Er is op dit moment geen actieve battle.",
            "not_allowed": "Je mag niet nog een battle starten vandaag probeer het morgen nog een keer",
            "did_not_lose": "Je kan geen revanche nemen als je niet hebt verloren.",
            "already_completed": "Je hebt deze battle al gespeeld.",
            "win": "gewonnen",
            "wins": ":count gewonnen",
            "challenge": "Uitdagen",
            "invite": "Uitdagen",
            "revanche": "Revanche",
            "challenges_you": ":name daagt je uit",
            "start": "Start battle",
            "battle_masters": "Battle masters",
            "battle_masters_popup": "Kies een tegenstander",
            "search_opponent": "Tegenstander opzoeken",
            "challengers": "Uitdagers",
            "yourself": "Je kan jezelf niet uitdagen",
            "wait_for_initiator": "Wacht tot er een score is gezet door de uitdager",
            "no_invitations": "Je bent nog niet uitgedaagd door een medespeler.",
            "no_history": "Je hebt nog geen battles gespeeld.",
            "too_many": "Je hebt al te veel actieve battles.",
            "campaign_is_tournament": "Deze campagne is in toernooimodus en kan alleen gespeeld worden tussen :dates. De battle moet ook binnen dat tijdsbestek plaatsvinden.",
            "game_anonymous": "Campagne is alleen toegankelijk voor anonieme gebruikers",
            "summary": {
                "header": {
                    "winner": "Winnaar",
                    "loser": "Verliezer",
                    "tied": "Gelijkspel"
                },
                "battle_score": "Battle score",
                "score": {
                    "win": "Battle gewonnen",
                    "lost": "Battle verloren",
                    "tied": "Battle gelijkspel"
                },
                "earned": "Verdiend"
            }
        },
        "campaign": {
            "campaign": "Campagne",
            "campaigns": "Campagnes",
            "new_campaign": "Nieuwe campagne",
            "view_campaign": "Campagne bekijken",
            "management": {
                "description": "Een campagne bestaat uit een verzameling van challenges en is te vergelijken met een boek waarbij de challenges de hoofdstukken zijn."
            },
            "insights": "Inzichten",
            "to_campaign": "Naar campagne",
            "already_played": "Deze campagne is al gespeeld door :amount spelers. Het wijzigen van deze campagne heeft gevolgen voor de voortgang van de spelers.",
            "transfer_requests": "Kopieerverzoeken",
            "copy_title": "Kopieer campagne",
            "copy": "Kopieer campagne naar andere organisatie",
            "copy_button": "Kopieerverzoek versturen",
            "copy_description": "De ontvangende organisatie zal een verzoek ontvangen om de campagne te kopi\u00ebren. Wanneer deze het verzoek hebben geaccepteerd, zal de campagne worden gekopieerd.",
            "copyable_campaigns": "Kopieerbare campagnes",
            "copy_howto": "Om een campagne te kopi\u00ebren, ga naar het campagne overzicht en klik op het kopieer icoon naast de campagne.",
            "copy_accept": "Kopieer de campagne",
            "copy_accept_confirmation": "Kopieer de campagne naar jouw organisatie. Na het kopi\u00ebren kan je de campagnes aanpassen naar jouw wensen. Weet je zeker dat je de campagne wilt kopi\u00ebren?",
            "copy_deny": "Verwijder verzoek",
            "copy_deny_confirmation": "Verwijder het verzoek om de campagne te kopi\u00ebren. Na het verwijderen van het verzoek is het niet langer mogelijk om de campagne te kopi\u00ebren naar jouw organisatie. Weet je zeker dat je dit verzoek wilt verwijderen?",
            "copy_bulk_accept": "Kopieer de campagnes",
            "copy_bulk_accept_confirmation": "Kopieer de geselecteerde campagnes naar jouw organisatie? Na het kopi\u00ebren kan je de campagnes aanpassen naar jouw wensen. Weet je zeker dat je de campagnes wilt kopi\u00ebren?",
            "copy_bulk_deny": "Verwijder verzoeken",
            "copy_bulk_deny_confirmation": "Verwijder de geselecteerde verzoeken om de campagnes te kopi\u00ebren naar jouw organisatie? Na het verwijderen van de verzoeken is het niet langer mogelijk om de campagnes te kopi\u00ebren naar jouw organisatie. Weet je zeker dat je dit wilt doen?",
            "duplicate": "Dupliceer campagne binnen eigen organisatie",
            "duplicate_button": "Dupliceer campagne",
            "duplicate_description": "De campagne met alle onderliggende challenges en modules zal binnen je eigen organisatie gedupliceerd worden.",
            "outgoing_requests": "Kopieerverzoeken",
            "copy_revoke": "Trek kopieerverzoek in",
            "copy_revoke_description": "Wanneer je het kopieerverzoek intrekt, zal de ontvangende organisatie niet langer in staat zijn om de campagne te kopi\u00ebren. Weet je zeker dat je dit verzoek wilt intrekken?",
            "copy_to_subdomain_description": "Vul het subdomein van de organisatie in waar de campagne naar gekopieerd mag worden.",
            "leaderboard": "Scorebord",
            "no_player": "Geen speler",
            "completed": "Voltooid!",
            "percentage_completed": "van de campagne voltooid",
            "progress": "Voortgang",
            "available_modules": "Beschikbaar",
            "completed_modules": "Voltooid",
            "stars": "Sterren",
            "achievement_xp": "Achievement :xp",
            "battle_xp": "Battle :xp",
            "total_xp": "Totaal :xp",
            "tournament_starts_soon": "Toernooi begint binnenkort!",
            "from": "Vanaf",
            "status": {
                "scheduled": "Gepland",
                "in_progress": "Lopend",
                "done": "Be\u00ebindigd",
                "archived": "Gearchiveerd"
            },
            "properties": {
                "name": "Naam",
                "title": "Titel",
                "finished_by": "Be\u00ebindigd door",
                "finish_date": "Einddatum",
                "run_time": "Looptijd",
                "description": "Omschrijving",
                "image": "Afbeelding",
                "image_select": "Selecteer afbeelding",
                "icon": "Icoon",
                "icon_select": "Selecteer icoon",
                "score": "Score",
                "bonus": "Bonus",
                "modules_completed": "modules voltooid",
                "owned_by": "Eigenaar",
                "shared_with": "Gedeeld met",
                "play_in_order": "Challenges moeten op volgorde gespeeld worden",
                "hide_leaderboard": "Verberg scorebord",
                "access": "Toegang",
                "access_tags": "Enkel gebruikers met een tag",
                "access_tags_placeholder": "Alle geregistreerde gebruikers",
                "tournament": "Toernooi",
                "enable_tournament": "Toernooimodus inschakelen",
                "tournament_start_at": "Toernooi begint op",
                "tournament_duration": "Toernooiduur",
                "tournament_status": "Toernooi status",
                "tournament_end_at": "Toernooi eindigt op",
                "tournament_ended": "Toernooi afgelopen",
                "show_points": "Toon punten",
                "show_stars": "Toon sterren",
                "awards_certificate": "Reikt certificaat uit",
                "leagues": "Leagues",
                "leagues_description": "Wanneer leagues zijn ingeschakeld, zal het leaderboard gebaseerd zijn op poules met promotie en degradatie.",
                "league_enabled": "Leagues aanzetten",
                "league_ideal_poule_size": "Ideale poule grootte",
                "league_switch_day": "Promotie \/ degradatie elke:",
                "league_switch_time": "Om:",
                "achievements_description": "Selecteer alle achievements die je voor gebruikers wilt inschakelen."
            },
            "access_options": {
                "all": "Iedereen",
                "anonymous": "Anonieme gebruikers",
                "registered": "Geregistreerde gebruikers"
            },
            "actions": {
                "create": {
                    "action": "Campagne toevoegen",
                    "success": "Campagne toegevoegd",
                    "failed": "Kan de campagne niet toevoegen"
                },
                "update": {
                    "action": "Campagne wijzigen",
                    "success": "Campagne gewijzigd",
                    "failed": "Kan de campagne niet wijzigen"
                },
                "delete": {
                    "action": "Campagne verwijderen",
                    "confirm": "Wanneer een campagne wordt verwijderd, is deze direct niet meer toegankelijk voor de spelers. Weet je zeker dat je deze campagne wilt verwijderen?",
                    "success": "Campagne verwijderd",
                    "failed": "Kan de campagne niet verwijderen"
                },
                "restore": {
                    "action": "Herstel campagne",
                    "confirm": "Wanneer een campagne wordt hersteld, is deze direct weer toegankelijk. Weet je zeker dat je deze campagne wilt herstellen?",
                    "success": "Campagne hersteld",
                    "failed": "Kan de campagne niet herstellen"
                },
                "order": {
                    "action": "Sorteer campagnes",
                    "success": "Volgorde van campagnes aangepast",
                    "error": "Kan de volgorde van de campagnes niet bijwerken"
                },
                "transfer_request_create": {
                    "create": "Kopieerverzoek aanmaken",
                    "success": "Kopieerverzoek verzonden",
                    "failed": "Kan het kopieerverzoek niet verzenden"
                },
                "transfer_request_delete": {
                    "success": "Kopieerverzoek verwijderd",
                    "failed": "Kan het kopieerverzoek niet verwijderen"
                },
                "transfer": {
                    "success": "Kopieerverzoek verwerkt",
                    "failed": "Kan het kopieerverzoek niet verwerken",
                    "skip_missing_microgames": "Micro games zonder toegang overslaan"
                },
                "duplicate": {
                    "success": "Campagne gedupliceerd"
                },
                "bulk_transfer": {
                    "success": "Kopieerverzoeken verwerkt",
                    "failed": "De volgende kopieerverzoeken konden niet worden verwerkt: :games",
                    "transfer_no_access": "De huidige organisatie heeft geen toegang om het kopieerverzoek te verwerken"
                },
                "bulk_transfer_request_delete": {
                    "success": "Kopieerverzoeken verwijderd",
                    "failed": "De volgende kopieerverzoeken konden niet worden verwijderd: :games",
                    "no_access": "De huidige organisatie heeft geen toegang om het kopieerverzoek te verwijderen"
                }
            },
            "validations": {
                "not_owned": "De campagne is niet van de huidige organisatie",
                "no_access": "De huidige organisatie heeft geen toegang tot de campagne",
                "no_longer_available": "De campagne of het onderdeel van de campagne is niet langer beschikbaar",
                "not_accessible": "Je hebt geen toegang tot deze campagne",
                "transfer_already_sent": "Kopieerverzoek is reeds verzonden",
                "transfer_no_access": "De huidige organisatie heeft geen toegang om het kopieerverzoek te verwerken",
                "no_access_to_microgames": "De organisatie heeft geen toegang tot \u00e9\u00e9n of meerdere microgames. Neem contact op met jouw account-manager voor toegang. De campagne kan nog steeds worden gekopieerd, maar de module(s) met de volgende microgame(s) worden overgeslagen:",
                "tournament_has_not_started": "Kom terug op :date om :time om te beginnen met spelen!",
                "tournament_has_not_started_dashboard": "Vanaf :date: game on!",
                "tournament_has_ended": "Het toernooi van deze campagne is afgelopen en kan niet meer worden gespeeld",
                "battle_outside_tournament": "Deze campagne heeft battles die volledig buiten het toernooi vallen. Verwijder deze voordat je de toernooimodus configureert.",
                "challenges_must_be_played_in_order": "De challenges van deze campagne moeten in volgorde worden gespeeld. Voltooi de voorgaande challenges om deze te ontgrendelen."
            },
            "tournament": {
                "warn_existing_battles": "Deze campagne heeft actieve of aankomende battles. Als een battle gedeeltelijk overlapt met het toernooi, worden de tijden aangepast."
            },
            "leagues": {
                "week": "Week",
                "week_number": "Week :number",
                "poules": ":count poules",
                "number_of_poules": "Aantal poules"
            }
        },
        "certificate": {
            "certificate": "Certificaat",
            "certificates": "Certificaten",
            "awarding": "Uitreiken",
            "new_games_default_certificate_awarding_description": "Nieuwe campagnes reiken standaard certificaten uit.",
            "award_default": "Standaard uitreiken",
            "for": "Voor",
            "awarded_on": "Uitgereikt op",
            "presented_to": "Het certificaat wordt met trots overhandigd aan",
            "demonstrated_expertise": "De hierboven genoemde speler heeft zijn expertise in :name aangetoond en is met succes geslaagd voor de campagne :name.",
            "date": "Datum",
            "signed_by": "Ondertekend door",
            "you_made_it": "Je hebt het gehaald!",
            "mail": {
                "subject": "Certificaat PDF voor :name",
                "body": "Je ontvangt het certificaat voor :name als bijlage bij deze e-mail."
            },
            "mail_sent": "Het certificaat is per e-mail verzonden.",
            "mail_sent_description": "Het certificaat wordt gegenereerd en wordt per e-mail naar je verzonden, dit kan even duren.",
            "well_done": "Goed gedaan!",
            "certificate_obtained": "Certificaat behaald",
            "not_found": "Certificaat niet gevonden"
        },
        "challenge": {
            "challenge": "Challenge",
            "challenges": "Challenges",
            "challenge_description": "Een challenge bestaat uit een verzameling modules en kan worden vergeleken met een hoofdstuk uit een boek.",
            "challenge_completed_at": "Challenge voltooid op",
            "challenge_play": "Speel de challenge om je score te verbeteren",
            "challenge_not_playable": "De challenge kan niet worden gespeeld",
            "challenge_not_playable_no_modules": "De challenge heeft 0 modules en kan daarom niet worden gespeeld. Neem contact op met je instructeur.",
            "challenge_completed": "Challenge voltooid",
            "challenge_completed_name": "Challenge :challenge voltooid",
            "challenge_completed_description": "Goed gedaan! Je hebt de challenge voltooid!",
            "challenge_not_completed": "Challenge niet voltooid",
            "challenge_not_completed_description": "Helaas is de challenge niet voltooid. Maar... geen probleem! Probeer het gewoon opnieuw!",
            "try_again": "Opnieuw spelen",
            "back_to_campaign": "Terug naar campagne",
            "back_to_overview": "Terug naar overzicht",
            "next_challenge": "Volgende challenge",
            "play_again": "Opnieuw",
            "improve_score": "Score verbeteren",
            "progress": "Voortgang",
            "start": "Begin",
            "summary": "Eindscherm",
            "summary_description": "Het eindscherm van de challenge. Hier kun je aparte teksten en afbeeldingen toevoegen voor gehaalde en gefaalde challenges.",
            "continue_program": "Ga verder met het programma",
            "properties": {
                "name": "Naam",
                "description": "Omschrijving",
                "image": "Afbeelding",
                "image_select": "Selecteer afbeelding",
                "summary_passed_text": "Tekst gehaalde challenge",
                "summary_passed_image": "Afbeelding gehaalde challenge",
                "summary_failed_text": "Tekst gefaalde challenge",
                "summary_failed_image": "Afbeelding gefaalde challenge"
            },
            "actions": {
                "create": {
                    "action": "Challenge toevoegen",
                    "success": "Challenge toegevoegd",
                    "failed": "Kan de challenge niet toevoegen"
                },
                "update": {
                    "action": "Challenge wijzigen",
                    "success": "Challenge gewijzigd",
                    "failed": "Kan de challenge niet wijzigen"
                },
                "delete": {
                    "action": "Challenge verwijderen",
                    "confirm": "De challenge zal worden verwijderd uit de campagne. Dit zorgt ervoor dat spelers de challenge niet meer kunnen spelen en bekijken. Weet je zeker dat je de challenge wilt verwijderen?",
                    "success": "Challenge verwijderd",
                    "failed": "Kan de challenge niet verwijderen"
                },
                "restore": {
                    "action": "Challenge herstellen",
                    "confirm": "Na het herstellen van een challenge is deze direct toegankelijk voor spelers. Weet je zeker dat je de challenge wilt verwijderen?",
                    "success": "Challenge hersteld",
                    "failed": "Kan de challenge niet herstellen"
                },
                "order": {
                    "success": "Volgorde van challenges is gewijzigd",
                    "error": "Kan de volgorde van challenges niet wijzigen"
                }
            },
            "validations": {
                "not_owned": "De challenge behoort niet tot jouw organisatie",
                "must_be_part_of_organisation": "De challenge moet voor de organisatie zijn",
                "no_modules": "De challenge heeft 0 modules en kan dus niet worden gespeeld."
            }
        },
        "challenge_session": {
            "actions": {
                "update": {
                    "failed": "Kan de module sessie niet wijzigen"
                }
            },
            "validations": {
                "must_be_part_of_organisation": "De challenge sessie moet tot een challenge behoren van de organisatie",
                "not_owned": "De challenge sessie is niet van jou. Start de challenge vanuit je eigen account",
                "too_old": "De challenge sessie is ouder dan 8 uur. Start de challenge opnieuw"
            }
        },
        "daily_challenge": {
            "daily_challenge": "Daily challenge",
            "daily_challenges": "Daily challenges",
            "improve_score": "Verbeter je score",
            "starts_soon": "Begint binnenkort",
            "start": "Start de Daily Challenge",
            "properties": {
                "name": "Naam",
                "description": "Omschrijving",
                "image": "Afbeelding",
                "image_select": "Selecteer afbeelding",
                "type": "Type",
                "available_at": "Beschikbaar vanaf"
            },
            "actions": {
                "create": {
                    "action": "Daily challenge toevoegen",
                    "success": "Daily challenge toegevoegd",
                    "failed": "Kan de daily challenge niet toevoegen"
                },
                "update": {
                    "action": "Daily challenge wijzigen",
                    "success": "Daily challenge gewijzigd",
                    "failed": "Kan de daily challenge niet wijzigen"
                },
                "delete": {
                    "action": "Daily challenge verwijderen",
                    "confirm": "Wanneer een daily challenge wordt verwijderd, is deze direct niet meer toegankelijk voor de spelers. Weet je zeker dat je deze daily challenge wilt verwijderen?",
                    "success": "Daily challenge verwijderd",
                    "failed": "Kan de daily challenge niet verwijderen"
                }
            },
            "validations": {
                "not_owned": "De daily challenge is niet van de huidige organisatie"
            }
        },
        "dashboard": {
            "switch_account": "Wissel van account",
            "current_program": "huidig programma",
            "personal-progress": "Persoonlijke vooruitgang",
            "to-receive-certificate": "Om certificaat te halen",
            "highscores": "Topscores",
            "retry_last_performance": "Laatste uitvoering herhalen",
            "no_last_performance": "U heeft aan geen enkele campagne deelgenomen",
            "battle_mode": "Gevechtsmodus",
            "programs": "Programma's",
            "exergames": "Exergames",
            "interactive_workouts": "Interactieve trainingen",
            "fitness_video": "Fitness video's",
            "leaderboard": "Scorebord",
            "community": "Community",
            "support": "Ondersteuning",
            "interactive_challenges": "Uitdagingen",
            "videos": "Video's",
            "privacy_policy": "Privacybeleid",
            "terms_and_conditions": "Algemene voorwaarden"
        },
        "dashboard_tile": {
            "dashboard": "Dashboard indeling",
            "dashboard_tile": "Dashboard tegel",
            "choose_type": "Kies een type",
            "choose_model": "Kies een :type",
            "properties": {
                "name": "Naam",
                "access": "Toegang",
                "status": "Status",
                "type": "Type"
            },
            "add_as_dashboard_tile": "Toevoegen als dashboard tegel",
            "status": {
                "available": "Beschikbaar",
                "scheduled": "Ingepland",
                "done": "Afgerond"
            },
            "actions": {
                "create": {
                    "action": "Dashboard tegel toevoegen",
                    "success": "Dashboard tegel toegevoegd",
                    "failed": "Kan de dashboard tegel niet toevoegen"
                },
                "update": {
                    "action": "Dashboard tegel wijzigen",
                    "success": "Dashboard tegel gewijzigd",
                    "failed": "Kan de dashboard tegel niet wijzigen"
                },
                "order": {
                    "success": "De volgorde van de dashboard tegels is aangepast",
                    "failed": "De volgorde van de dashboard tegels kon niet worden aangepast"
                },
                "delete": {
                    "action": "Dashboard tegel verwijderen",
                    "confirm": "Wanneer een dashboard tegel wordt verwijderd, is deze direct niet meer toegankelijk voor de spelers. Weet je zeker dat je deze dashboard tegel wilt verwijderen?",
                    "success": "Dashboard tegel verwijderd",
                    "failed": "Kan de dashboard tegel niet verwijderen"
                }
            }
        },
        "direct_play_micro_game": {
            "micro_game": "Direct-play micro game",
            "micro_games": "Direct-play micro games",
            "explanation": "De campagnes die hier worden weergegeven zijn alleen voor de context, omdat ze voor elke gebruiker kunnen verschillen, afhankelijk van de campagnes waartoe ze toegang hebben. De micro games worden altijd getoond op de positie in deze lijst.",
            "properties": {
                "name": "Naam",
                "description": "Omschrijving",
                "image": "Afbeelding",
                "image_select": "Selecteer afbeelding",
                "type": "Type",
                "hide_high_score": "High score verbergen"
            },
            "actions": {
                "create": {
                    "action": "Direct-play micro game toevoegen",
                    "success": "Direct-play micro game toegevoegd",
                    "failed": "Kan de direct-play micro game niet toevoegen"
                },
                "update": {
                    "action": "Direct-play micro game wijzigen",
                    "success": "Direct-play micro game gewijzigd",
                    "failed": "Kan de direct-play micro game niet wijzigen"
                },
                "order": {
                    "success": "Volgorde van direct-play micro games aangepast"
                },
                "delete": {
                    "action": "Direct-play micro game verwijderen",
                    "confirm": "Wanneer een direct-play micro game wordt verwijderd, is deze direct niet meer toegankelijk voor de spelers. Weet je zeker dat je deze direct-play micro game wilt verwijderen?",
                    "success": "Direct-play micro game verwijderd",
                    "failed": "Kan de direct-play micro game niet verwijderen"
                }
            },
            "validations": {
                "not_owned": "De direct-play micro game is niet van de huidige organisatie"
            }
        },
        "domains": {
            "domains": "Domeinen",
            "domain": "Domein",
            "no_domains": "Nog geen domeinen toegevoegd",
            "properties": {
                "domain": "Domein"
            },
            "actions": {
                "create": {
                    "action": "Domein toevoegen",
                    "success": "Domein gemaakt",
                    "failed": "Kan het domein niet aanmaken"
                },
                "update": {
                    "action": "Domein bewerken",
                    "success": "Domein bijgewerkt",
                    "failed": "Kan het domein niet bijwerken"
                },
                "delete": {
                    "action": "Domein verwijderen",
                    "confirm": "Weet u zeker dat u door wilt gaan?",
                    "success": "Domein verwijderd",
                    "failed": "Kan het domein niet verwijderen"
                }
            }
        },
        "exception": {
            "one_time_login_token_invalid": "Ongeldige eenmalige login token",
            "one_time_login_token_expired": "Eenmalige login token is verlopen",
            "one_time_login_token_not_yet_valid": "Eenmalige login token is nog niet geldig",
            "one_time_login_token_consumed": "Eenmalige login token is al gebruikt",
            "one_time_login_token_not_for_organisation": "Eenmalige login token is niet geldig voor deze organisatie",
            "route_not_found": "Geen route gevonden voor dit verzoek"
        },
        "gamified_video": {
            "gamified_video": "Gamified video",
            "gamified_videos": "Gamified video's",
            "overview_description": "Overzicht van alle ge\u00efmporteerde gamified video's.",
            "description": "Een gamified video is een interactieve video van HiHaHo. De beschikbare video's worden automatisch ingelezen uit HiHaHo.",
            "select_available_video": "Selecteer een beschikbare video",
            "preview": "voorbeeld",
            "properties": {
                "name": "Naam",
                "folder": "Map",
                "link": "Link",
                "external_id": "Externe ID",
                "embed_url": "Embed URL",
                "total": "Totaal",
                "created": "Aangemaakt",
                "existing": "Bestaand"
            },
            "actions": {
                "play": {
                    "action": "Speel de video hieronder en ga dan door."
                },
                "import": {
                    "action": "Importeer Gamified videos",
                    "description": "Deze actie zal alle beschikbare gamified video's ophalen uit HiHaHo. Dit kan even duren en dient alleen te worden gedaan wanneer gamified video's ontbreken. Weet je zeker dat je het proces wilt starten?",
                    "results": "Resultaten import"
                }
            },
            "play_first": "Speel de video eerst",
            "play_first_description": "Speel de video voordat je door kan gaan",
            "unable_to_retrieve_progress": "Kan de voortgang van de video niet opslaan. De developers zijn hierover ge\u00efnformeerd."
        },
        "gamified_video_folder": {
            "gamified_video_folders": "Gamified video mappen",
            "overview_description": "Overzicht van alle mappen van de Gamified video's",
            "select_placeholder": "Selecteer gamified videomap(pen)",
            "none_assigned": "Er zijn geen toegewezen gamified videomappen.",
            "properties": {
                "name": "Naam",
                "external_id": "Externe ID"
            },
            "actions": {
                "update": {
                    "success": "Toegang tot de gamified video mappen is gewijzigd"
                }
            },
            "filter": {
                "folder": "Mappen",
                "all_folders": "Alle mappen"
            }
        },
        "general": {
            "start": "Start",
            "start_workout": "Start workout",
            "play_now": "Nu spelen",
            "quit": "Afsluiten",
            "data": "Data",
            "data_tools": "Data & Tools",
            "dashboard": "Dashboard",
            "home": "Home",
            "welcome": "Welkom",
            "welcome_description": "Start met spelen door in te loggen",
            "required": "Verplicht",
            "toggle_navigation": "Navigatie openen\/sluiten",
            "insights": "Inzichten",
            "back_to_dashboard": "Terug naar dashboard",
            "back_to_campaigns": "Terug naar campagnes",
            "back_to_exergames": "Terug naar exergames",
            "back_to_interactive_workouts": "Terug naar interactieve workouts",
            "back_to_leaderboards": "Terug naar scorebord",
            "control_panel": "Control panel",
            "no_avatar": "Geen avatar",
            "search": "Zoeken",
            "search_placeholder": "Zoeken...",
            "status": "Status",
            "active": "Actief",
            "inactive": "Inactief",
            "archived": "Gearchiveerd",
            "clear_filter": "Filter wissen",
            "filter_results": "<strong>:start<\/strong> tot <strong>:end<\/strong> van de <strong>:total<\/strong> resultaten",
            "results": "resultaten",
            "access_denied": "Geen toegang",
            "access_denied_description": "Sorry, maar je hebt niet de juiste permissies voor deze functionaliteit.",
            "unable_to_store_file": "Kan het bestand niet opslaan",
            "unable_to_process_file": "Kan het bestand niet verwerken",
            "upload_error": "Er ging iets fout tijdens het uploaden",
            "invalid_file": "Ongeldig bestand aangeleverd",
            "file_too_large": "De bestandsgrootte van het aangeleverd bestand mag maximaal :size Mb zijn. Verklein het bestand om deze te gebruiken",
            "import": "Importeren",
            "add": "Toevoegen",
            "create": "Toevoegen",
            "edit": "Wijzigen",
            "filter": "Filter",
            "update": "Wijzigen",
            "manage": "Beheren",
            "delete": "Verwijderen",
            "restore": "Herstellen",
            "remove": "Verwijderen",
            "assign": "Toekennen",
            "revoke": "Intrekken",
            "failed": "Mislukt",
            "order": "Volgorde",
            "save": "Opslaan",
            "save_order": "Volgorde opslaan",
            "properties": "Eigenschappen",
            "export": "Exporteren",
            "oops": "Oeps...",
            "text": "Tekst",
            "header": "Kop",
            "confirm": "Bevestigen",
            "send": "Versturen",
            "cancel": "Annuleren",
            "day": "dag",
            "days": "dagen",
            "days_abbr": "d",
            "hour": "uur",
            "hours": "uren",
            "hours_abbr": "u",
            "minute": "minuut",
            "minutes": "minuten",
            "minutes_abbr": "m",
            "minutes_short": "mins",
            "back": "Terug",
            "finish": "Afronden",
            "next": "Volgende",
            "previous": "Vorige",
            "summary": "Samenvatting",
            "play_again": "Speel opnieuw",
            "qr_code": "QR code",
            "qr_code_description": "Gebruik deze QR code om spelers direct te laten spelen.",
            "qr_code_start": "Direct spelen.",
            "download": "Download",
            "download_svg": "Download SVG",
            "download_png": "Download PNG",
            "download_result": "Download resultaat",
            "or_go_to": "of ga naar",
            "logout": "Uitloggen",
            "profile": "Profiel",
            "add_field": "Veld toevoegen",
            "select_file": "Selecteer bestand",
            "choose_file_upload": "Selecteer bestand om te uploaden",
            "settings": "Instellingen",
            "no_results": "Geen resultaten gevonden",
            "loading": "Laden...",
            "close": "Sluiten",
            "optional": "Optioneel",
            "is": "is",
            "seconds": "seconden",
            "selected": "geselecteerd",
            "language_unavailable_in_organisation": "niet beschikbaar voor :organisation",
            "points": "Punten",
            "score": "Score",
            "read_more": "Meer lezen",
            "high_score": "High score",
            "everything": "Alles",
            "this_field": "Dit veld",
            "reset": "Reset",
            "tournament": "TOERNOOI",
            "score_not_set": "Score niet gezet",
            "image_cannot_be_loaded": "Afbeelding kan niet geladen worden",
            "not_applicable": "niet van toepassing",
            "publish": "Publiceren",
            "email_as_pdf": "E-mail als PDF",
            "pdf_will_be_send_to_your_email": "PDF wordt verstuurd naar je e-mail.",
            "pdf_cannot_be_downloaded": "PDF kan niet worden gedownload",
            "pdf_cannot_be_emailed": "PDF kan niet worden gemaild",
            "preview": "Voorbeeld",
            "set_as_default": "Stel in als standaard",
            "hello": "Hallo",
            "regards": "Groet",
            "copy_link": "Mocht je een probleem hebben met de knop, kopieer de volgende link in een browser :link",
            "show": "Bekijken",
            "accept": "Accepteren",
            "visible": "Zichtbaar",
            "hidden": "Verborgen",
            "app_update_required": {
                "title": "Update vereist",
                "description": "Update de app naar de nieuwste versie. We wensen je veel nieuwe inspiratie en leerplezier.",
                "your_version": "Jouw versie",
                "minimum_version": "Minimale versie"
            }
        },
        "handouts": {
            "handout": "Handout",
            "handouts": "Handouts",
            "handout_category": "Handout categorie",
            "handout_categories": "Handout categorie\u00ebn",
            "no_handouts_found": "Geen handouts gevonden.",
            "handouts_profile_section_disabled": "De \"handouts\" profiel sectie is uitgeschakeld voor deze organisatie. Pas nadat je deze hebt ingeschakeld, kunnen de gebruikers handouts op hun profiel bekijken.",
            "navigate_to_profile_settings": "Naar profiel instellingen",
            "properties": {
                "name": "Naam",
                "description": "Beschrijving",
                "is_visible": "Zichtbaar",
                "file": "Bestand",
                "file_description": "Toegestaan: pdf, doc, docx, xls, xlsx, ppt, pptx",
                "created_at": "Aangemaakt op"
            },
            "actions": {
                "create_category": {
                    "action": "Categorie toevoegen",
                    "success": "Categorie succesvol toegevoegd.",
                    "failed": "Kon de categorie niet toevoegen."
                },
                "update_category": {
                    "action": "Categorie bewerken",
                    "success": "Categorie succesvol bijgewerkt.",
                    "failed": "Kon de categorie niet bijwerken."
                },
                "delete_category": {
                    "action": "Categorie verwijderen",
                    "confirm": "Weet je zeker dat je deze categorie wilt verwijderen? De handouts in deze categorie worden ook verwijderd.",
                    "success": "Categorie succesvol verwijderd.",
                    "failed": "Kon de categorie niet verwijderen."
                },
                "order_categories": {
                    "failed": "Kon de volgorde niet wijzigen."
                },
                "create_handout": {
                    "action": "Handout toevoegen",
                    "success": "Handout succesvol toegevoegd.",
                    "failed": "Kon de handout niet toevoegen."
                },
                "update_handout": {
                    "action": "Handout bewerken",
                    "success": "Handout succesvol bijgewerkt.",
                    "failed": "Kon de handout niet bijwerken."
                },
                "delete_handout": {
                    "action": "Handout verwijderen",
                    "confirm": "Weet je zeker dat je deze handout wilt verwijderen?",
                    "success": "Handout succesvol verwijderd.",
                    "failed": "Kon de handout niet verwijderen."
                },
                "order_handouts": {
                    "failed": "Kon de volgorde niet wijzigen."
                }
            },
            "mail": {
                "subject": "Handout: :name",
                "body": "In de bijlage vind je de handout: :name",
                "sent": "De handout is verstuurd naar je e-mailadres."
            }
        },
        "integration": {
            "integrations": "Integraties",
            "no_integrations": "Nog geen integraties toegevoegd",
            "access_denied_to_portal": "Als gebruiker afkomstig uit een integratie heeft u geen toegang tot de volledige applicatie. Gelieve in te loggen als een gewone gebruiker.",
            "properties": {
                "name": "Administratieve naam",
                "type": "Type"
            },
            "sections": {
                "general": {
                    "title": "Algemeen"
                },
                "configuration": {
                    "title": "Configuratie"
                }
            },
            "providers": {
                "learnworlds": {
                    "type": "Learnworlds",
                    "properties": {
                        "client_id": "Client ID",
                        "client_secret": "Client secret",
                        "base_url": "Base URL"
                    }
                }
            },
            "actions": {
                "create": {
                    "action": "Integratie toevoegen",
                    "success": "Integratie gemaakt",
                    "failed": "Kan integratie niet aanmaken"
                },
                "update": {
                    "action": "Integratie bewerken",
                    "success": "Integratie bijgewerkt",
                    "failed": "Kan integratie niet bijwerken"
                },
                "delete": {
                    "action": "Integratie verwijderen",
                    "confirm": "Wanneer u een integratie verwijdert, kan deze niet meer gebruikt worden met onmiddellijke ingang. Weet u zeker dat u door wilt gaan?",
                    "success": "Integratie verwijderd",
                    "failed": "Kan integratie niet verwijderen"
                }
            }
        },
        "interactive_workouts": {
            "no_available_interactive_workouts_in_category": "Geen beschikbare workouts in deze categorie"
        },
        "knowledge_category": {
            "actions": {
                "create": {
                    "failed": "Kan de kenniscategorie niet maken"
                }
            }
        },
        "knowledge_category_activity": {
            "actions": {
                "create": {
                    "failed": "Kan de Kenniscategorie Activiteit niet aanmaken"
                }
            }
        },
        "leaderboard": {
            "leaderboard": "Leaderboard",
            "properties": {
                "rank": "Rang",
                "total": "Totaal",
                "player": "Speler",
                "players": "Spelers",
                "score": "Score",
                "bonus": "Bonus"
            },
            "league": {
                "admin": {
                    "title": "Waarom zie ik geen leaderboard?",
                    "description": "Je bent geen lid van deze organisatie en wordt dus niet automatisch toegevoegd aan de competities. De enige reden dat je deze pagina kunt bekijken, is omdat je beheerder bent."
                },
                "levels": {
                    "bronze": "Brons league",
                    "silver": "Zilver league",
                    "gold": "Goud league"
                },
                "poule": "Poule",
                "poule_settings": "Poule instellingen",
                "league_settings": "League instellingen",
                "advanced_settings": "Geavanceerde instellingen",
                "promotion_zone": "Promotiezone",
                "relegation_zone": "Degradatiezone",
                "user_promotion_zone": "Je zit in de promotiezone",
                "user_relegation_zone": "Je zit in de degradatiezone",
                "xp_ahead": ":value :xp voor om door te gaan naar de volgende league",
                "xp_to_maintain": ":value :xp nodig om te handhaven",
                "explanation": "Uitleg"
            }
        },
        "micro_game": {
            "micro_game": "Micro game",
            "micro_games": "Micro games",
            "your_latest_highscore": "Je laatste topscore",
            "play": {
                "message": "Wanneer de bijbehorende app is ge\u00efnstalleerd op je apparaat, zal deze automatisch openen. Wanneer je dit op een desktop computer speelt, speel deze challenge op het apparaat waar ook de app op staat."
            },
            "management": {
                "title": "Micro games",
                "description": "Beheer de beschikbare micro games.",
                "groups": {
                    "group": "Micro game groep",
                    "groups": "Micro game groepen",
                    "overview": "Beheer de beschikbare micro game groepen."
                }
            },
            "properties": {
                "name": "Naam",
                "identifier": "Identificatie",
                "description": "Omschrijving",
                "image": "Afbeelding",
                "image_select": "Selecteer afbeelding",
                "group": "Groep",
                "is_global": "Globale Micro Game",
                "is_global_description": "Een globale micro game kan gebruikt worden door alle organisaties.",
                "organisations": "Organisaties",
                "points": "Punten",
                "stars": "Sterren",
                "stars_threshold": "Sterren waarde",
                "build": "Build",
                "webgl_location": "WebGL locatie",
                "custom_data": "Custom data",
                "key": "Naam",
                "value": "Waarde"
            },
            "actions": {
                "bulk": {
                    "update": {
                        "success": "Micro games gewijzigd",
                        "failed": "Kan de micro games niet wijzigen"
                    }
                },
                "create": {
                    "action": "Micro game toevoegen",
                    "success": "Micro game toegevoegd",
                    "failed": "Kan de micro game niet toevoegen"
                },
                "update": {
                    "action": "Micro game wijzigen",
                    "success": "Micro game gewijzigd",
                    "failed": "Kan de micro game niet wijzigen"
                },
                "delete": {
                    "action": "Micro game verwijderen",
                    "confirm": "Door het verwijderen van de micro game, kunnen spelers deze niet meer spelen. Weet je zeker dat je door wilt gaan?",
                    "success": "Micro game verwijderd",
                    "failed": "Kan de micro game niet verwijderen"
                },
                "sync": {
                    "action": "Wijzig organisaties",
                    "success": "Organisaties van de micro game gewijzigd",
                    "is_global": "Organisaties van een globale micro game kunnen niet worden gewijzigd"
                }
            },
            "filter": {
                "all_groups": "Alle groepen",
                "select_micro_game": "Selecteer micro game",
                "select_micro_game_of_group": "Selecteer :group",
                "select_micro_game_group": "Selecteer groep"
            },
            "validations": {
                "organisation_must_have_access": "The organisation does not have access to this micro game."
            },
            "done_with_playing": "Klaar met spelen"
        },
        "micro_game_group": {
            "group": "Micro game groep",
            "groups": "Micro game groepen",
            "management": {
                "title": "Micro game groepen",
                "description": "Beheer de beschikbare micro game groepen."
            },
            "properties": {
                "name": "Naam",
                "identifier": "Identificatie",
                "image": "Afbeelding",
                "image_select": "Selecteer afbeelding",
                "build": "Build",
                "custom_data": "Custom data",
                "webgl_location": "WebGL locatie",
                "type": "Type",
                "categories": "Categorie\u00ebn"
            },
            "types": {
                "micro_game": "Micro game"
            },
            "filter": {
                "all_types": "Alle types",
                "select_type": "Selecteer type",
                "select_category": "selecteer categorie"
            },
            "actions": {
                "create": {
                    "action": "Micro game groep toevoegen",
                    "success": "Micro game groep toegevoegd",
                    "failed": "Kan de micro game groep niet toevoegen"
                },
                "update": {
                    "action": "Micro game groep wijzigen",
                    "success": "Micro game groep gewijzigd",
                    "failed": "Kan de micro game groep niet wijzigen"
                },
                "delete": {
                    "action": "Micro game groep verwijderen",
                    "confirm": "Weet je zeker dat je door wilt gaan?",
                    "success": "Micro game groep verwijderd",
                    "failed": "Kan de micro game groep niet verwijderen",
                    "prohibited": "Het is niet mogelijk een micro game groep te verwijderen waaraan micro games zijn toegekend"
                }
            }
        },
        "module": {
            "module": "Module",
            "module_type": "Type",
            "module_skills": "Vaardigheden",
            "modules": "Modules",
            "modules_completed": "Modules voltooid",
            "parts_completed": "Onderdelen voltooid",
            "module_completed_at": "Module voltooid op",
            "module_play": "Speel de module en behaal de hoogste score",
            "proceed_with_challenge": "Klik op volgende om door te gaan met de challenge.",
            "next": "Volgende",
            "properties": {
                "name": "Naam",
                "description": "Omschrijving",
                "threshold": "Drempel",
                "threshold_description": "De drempel bepaald of de speler de module succesvol heeft voltooid.",
                "threshold_description_value": "De drempel is een percentage van het aantal goed beantwoorde vragen. Bijv. de drempel is 75 en er zijn 4 vragen, de speler moet dan minimaal 3 vragen goed beantwoorden.",
                "reading_time": "Leestijd",
                "viewed_video": "Ik heb de video bekeken of al eerder gezien.",
                "factor": "Factor",
                "factor_description": "De factor bepaald hoeveel punten er verkregen kunnen worden. Standaard kan de speler :default_score punten halen wanneer een module is voltooid. Door de factor aan te passen kan je het verkregen aantal punten verlagen of verhogen.",
                "image": "Afbeelding",
                "image_select": "Selecteer afbeelding",
                "content": "Content",
                "video": "Video",
                "video_url": "Video URL",
                "video_description": "Gebruik de link naar de video (vanuit de adresbalk van je browser). Dat hoeft geen speciale link te vinden, de applicatie handelt dat af.",
                "text": "Tekst",
                "text_description": "Een tekst module bevat een korte toelichting of introductie en een afbeelding die bij de tekst hoort wanneer je de module speelt.",
                "question_time": "Tijd per vraag",
                "question_time_description": "De maximale tijd die per vraag beschikbaar is.",
                "total_questions_used": "Aantal te tonen vragen",
                "total_questions_used_description": "Het aantal vragen dat aan de spelers wordt getoond (leeg = alle vragen). Random selectie indien meer vragen dan aantal te tonen.",
                "next_button_label": "\"Volgende\" knop label",
                "is_replayable": "Herspeelbaar"
            },
            "actions": {
                "create": {
                    "title": "Nieuwe :type module",
                    "success": "Module toegevoegd",
                    "failed": "Kan de module niet toevoegen"
                },
                "update": {
                    "title": ":type module bewerken",
                    "success": "Module gewijzigd",
                    "failed": "Kan de module niet wijzigen"
                },
                "delete": {
                    "action": "Module verwijderen",
                    "confirm": "Het verwijderen van de module uit de challenge resulteert er in dat geen enkele speler deze module meer ziet of kan spelen. Weet je zeker dat je deze module wilt verwijderen?",
                    "success": "Module verwijderd",
                    "failed": "Kan de module niet verwijderen",
                    "failed_battle": "Kan de module niet verwijderen omdat er een battle is waarbij willekeurig een microgame uit deze campagne wordt gekozen, en dit is de laatste microgame in deze campagne."
                },
                "restore": {
                    "action": "Module herstellen",
                    "confirm": "Het herstellen van de module in de challenge resulteert er in dat spelers direct deze module weer zien en kunnen spelen. Weet je zeker dat je deze module wilt herstellen?",
                    "success": "Module hersteld",
                    "failed": "Kan de module niet herstellen"
                },
                "order": {
                    "success": "Volgorde van de modules is gewijzigd",
                    "failed": "Kan de volgorde van de modules niet wijzigen"
                }
            },
            "filter": {
                "all_types": "Alle types"
            },
            "validations": {
                "must_be_part_of_organisation": "De module moet voor de organisatie zijn",
                "invalid_properties": "Deze module type vereist een configuratie die ontbreekt, bijv. wanneer een gerelateerd object is verwijderd. Pas deze module aan of verwijder deze."
            },
            "already_played": "Je hebt deze module al voltooid. Klik op 'Volgende' om door te gaan met de challenge.",
            "not_replayable": "Deze module is al voltooid. Klik op 'Volgende' om verder te gaan."
        },
        "module_session": {
            "actions": {
                "create": {
                    "failed": "Kan de module sessie niet starten"
                },
                "update": {
                    "failed": "Kan de module sessie niet wijzigen"
                }
            },
            "validations": {
                "must_be_part_of_organisation": "De module sessie moet tot een module behoren van de organisatie",
                "not_owned": "Je kan alleen je eigen module sessies wijzigen"
            }
        },
        "onboarding": {
            "onboarding": "Onboarding",
            "answer": "Antwoord",
            "assigned_tag": "Toegewezen label",
            "select_tag": "Selecteer label",
            "not_answered": "Niet beantwoord",
            "intro_title": "Welkom",
            "intro_description": "Beantwoord de volgende vragen om de applicatie voor jou te personaliseren.",
            "question": "Vraag",
            "choose_answer": "Kies antwoord",
            "actions": {
                "create": {
                    "action": "Vraag toevoegen",
                    "success": "Vraag toegevoegd",
                    "failed": "Kan de vraag niet toevoegen"
                },
                "update": {
                    "action": "Vraag wijzigen",
                    "success": "Vraag gewijzigd",
                    "failed": "Kan de vraag niet wijzigen"
                },
                "delete": {
                    "action": "Vraag verwijderen",
                    "confirm": "Wanneer een vraag wordt verwijderd, worden ook de automatisch toegewezen labels losgekoppeld. Weet je zeker dat je deze vraag wilt verwijderen?",
                    "success": "Vraag verwijderd",
                    "failed": "Kan de vraag niet verwijderen"
                },
                "order": {
                    "action": "Sorteer vragen",
                    "success": "Volgorde van vragen aangepast",
                    "error": "Kan de volgorde van de vragen niet bijwerken"
                }
            }
        },
        "organisation": {
            "organisation": "Organisatie",
            "organisations": "Organisaties",
            "organisation_description": "Door wijzigingen aan het subdomein worden alle URL's bijgewerkt.",
            "crud_description": "Een subdomein moet uniek zijn en bestaan uit letters (a-z), getallen (0-9) en\/of een streepje (-)",
            "subdomain_description": "Een subdomein kan niet gewijzigd worden.",
            "logo": "Logo",
            "select_placeholder": "Selecteer organisatie(s)",
            "current": "Huidige organisatie",
            "validations": {
                "not_found": "Organisatie niet gevonden",
                "not_a_member": "Geen toegang tot de organisatie"
            },
            "state": {
                "removed": "Organisatie is verwijderd"
            },
            "properties": {
                "customer": "Klant",
                "name": "Naam",
                "subdomain": "Subdomein",
                "url": "Url",
                "view_organisation": "Bekijk organisatie",
                "languages": "Taalinstellingen",
                "default": "Standaard",
                "default_language": "Standaard taal",
                "default_language_description": "Kies de standaard taal voor jouw organisatie.",
                "available_languages": "Beschikbare talen",
                "alternate_languages": "Alternatieve talen",
                "alternate_languages_description": "Kies de talen die je voor jouw organisatie wilt ondersteunen.",
                "available_languages_warning": "Wanneer je een taal weghaalt, gaat er data voor die taal verloren bij het bewerken van een item.",
                "manage_translations": "Aangepaste vertalingen beheren",
                "reseller": "Reseller",
                "gamified_video_folders": "Gamified videomappen",
                "gamified_video_folders_description": "Selecteer de gamified videomappen die door de organisatie kunnen worden gebruikt.",
                "social": "Sociaal",
                "meta_details": "Meta gegevens",
                "social_description": "Voeg een <a href=\"https:\/\/www.freecodecamp.org\/news\/what-is-open-graph-and-how-can-i-use-it-for-my-website\" target=\"_blank\">open graph<\/a> afbeelding en beschrijving toe.",
                "customization": "Aanpassen",
                "customization_description": "De applicatie kan worden aangepast voor de organisatie qua look and feel.",
                "logo": "Logo",
                "logo_requirements": "Max 4Mb",
                "logo_select": "Selecteer logo",
                "open_graph_image": "Open graph afbeelding",
                "open_graph_image_requirements": "Minimaal 640\u00d7320px, max 4Mb",
                "open_graph_image_select": "Selecteer afbeelding",
                "open_graph_description": "Open graph beschrijving",
                "brand_colors": "Merk kleuren",
                "brand_colors_description": "Selecteer je organisatie kleuren om het uiterlijk van het platform aan te passen.",
                "display": "Weergave",
                "display_description": "Selecteer het display waarop je de applicatie wilt tonen.",
                "display_select": "Selecteer weergave",
                "theme_colors": "Thema kleuren",
                "theme_setup": "Thema configuratie",
                "theme_look_and_feel": "Look and feel",
                "theme_select": "Selecteer thema",
                "manage_theme": "Beheer eigen thema",
                "background": "Achtergrond",
                "background_mobile": "Mobiel",
                "background_laptop": "Laptop",
                "background_tablet": "Tablet",
                "background_desktop": "Desktop",
                "background_requirements": "Max 4Mb",
                "background_select": "Selecteer achtergrond",
                "primary_color": "Primaire kleur",
                "secondary_color": "Secondaire kleur",
                "accent_color": "Accent kleur",
                "background_color": "Achtergrondkleur",
                "card_background_color": "Kaart achtergrondkleur",
                "module_shadow_color": "Module shaduwkleur",
                "daily_tile_background_color": "Daily-tegel achtergrondkleur",
                "text": "Text",
                "font_headings": "Koppen",
                "font_headings_color": "Kleur koppen",
                "font_body": "Paragrafen",
                "font_body_color": "Kleur paragrafen",
                "primary_font_color": "Primaire lettertype kleur",
                "secondary_font_color": "Secondaire lettertype kleur",
                "primary_font_family": "Primaire lettertype",
                "font_family_select": "Selecteer lettertype...",
                "primary_font_family_select": "Selecteer primaire lettertype...",
                "secondary_font_family": "Secondaire lettertype",
                "secondary_font_family_select": "Selecteer secondaire lettertype...",
                "preview_fonts": "Lettertypes kunnen hier worden bekeken :url",
                "card_border_radius": "Kaartrandradius",
                "card_settings": "Kaart instellingen",
                "introduction_title": "Titel",
                "introduction_text": "Introductietekst",
                "welcome_text": "Welkom tekst",
                "welcome_text_description": "Definieert de tekst die wordt weergegeven op het inlogscherm.",
                "configuration": "Configuratie",
                "configuration_description": "Bepaal welke features voor deze organisatie beschikbaar zijn",
                "registration_allowed": "Registreren toegestaan",
                "registration_allowed_header": "Registreren toegestaan",
                "registration_description": "Spelers kunnen zich registreren zonder uitnodiging",
                "demo_user_allowed": "Spelen als demo gebruiker toegestaan",
                "demo_user_allowed_header": "Demo gebruikers toegestaan",
                "demo_user_description": "Spelers kunnen spelen zonder account. Let op, er wordt dan <strong>geen voortgang<\/strong> bijgehouden",
                "allow_upgrade_to_registered_user": "Upgrade naar geregistreerde gebruiker toestaan",
                "allow_upgrade_to_registered_user_description": "Laat demo-gebruikers upgraden naar een geregistreerde gebruiker door hun e-mailadres toe te voegen en te bevestigen.",
                "reseller_allowed": "Organisatie is reseller",
                "reseller_allowed_header": "Organisatie reseller",
                "reseller_description": "Een reseller mag extra organisaties toevoegen voor hun klanten",
                "webhook": "Webhook",
                "webhook_url": "Webhook URL",
                "webhook_url_description": "Er is de mogelijkheid om de Gamification Player bij bepaalde evenementen een <a href=\":url\" target=\"_blank\">webhook<\/a> te laten aanroepen. De gamification-speler zal verschillende gebeurtenissen aanroepen met een <code>POST<\/code> request naar de webhook.",
                "webhook_secret": "Webhook geheim",
                "webhook_secret_description": "Omdat de gamification-speler op een cluster wordt gehost, is er geen vast IP-adres beschikbaar. Je moet naast de webhook-URL een <a href=\":url\" target=\"_blank\">geheim\/token<\/a> opgeven om de veiligheid ervan te garanderen. Het geheim\/token kan alles zijn wat je wil en wordt geleverd in de <code>X-Webhook-Token<\/code> header.",
                "webhook_events": "Webhook events",
                "webhook_events_description": "Selecteer alle webhook events die je wilt ontvangen om onnodige webhook events te voorkomen.",
                "webhook_events_select": "Alle events ontvangen",
                "register_apps": "Registreer app",
                "ios_example_url": "https:\/\/apps.apple.com\/nl\/app\/example\/id123456789",
                "android_example_url": "https:\/\/play.google.com\/store\/apps\/details?id=com.example",
                "branch_example_url": "https:\/\/example.app.link",
                "ios_app_store": "App store (iOS)",
                "android_play_store": "Play store (Android)",
                "branchio_link": "Branch.io link",
                "ios_app_url": "iOS app URL",
                "android_app_url": "Android app URL",
                "branchio_url": "Branch.io URL",
                "branchio_url_in_mail": "Gebruik branch.io URL in e-mails",
                "sso_configurations": ":count configuratie|:count configuraties",
                "domains": ":count domein|:count domeinen",
                "organisation_settings": "Organisatie instellingen",
                "advanced_settings": "Geavanceerde instellingen",
                "permissions": "Rechten",
                "timezone": "Tijdzone",
                "introduction": "Introductie",
                "default_avatar": "Standaard profielfoto",
                "default_avatar_select": "Selecteer standaard profielfoto",
                "default_avatar_requirements": "Max 4Mb",
                "achievements_description": "Selecteer alle achievements die je voor gebruikers wilt inschakelen.",
                "hide_score_elements": "Score elementen verbergen",
                "hide_score_elements_description": "Alle score elementen verbergen",
                "profile_settings": "Profiel instellingen",
                "profile_sections": "Profiel onderdelen",
                "profile_section_name": "Naam",
                "profile_section_description": "Omschrijving",
                "enforce_integration_only": "Integratie only afdwingen",
                "enforce_integration_only_description": "Met deze optie actief wordt het login formulier niet getoond. Gebruikers kunnen alleen inloggen via de integratie.",
                "take_away_sections": "Take away onderdelen",
                "take_away_section_name": "Naam",
                "take_away_section_description": "Omschrijving",
                "dashboard_tiles": "Dashboard tegels",
                "dashboard_tiles_description": "Automatisch dashboard tegels toevoegen bij het maken van nieuwe games.",
                "add_tile_new_game_description": "Automatisch nieuwe campagnes toevoegen aan het dashboard.",
                "add_tile_new_battle_description": "Automatisch nieuwe gevechten toevoegen aan het dashboard.",
                "add_tile_new_direct_play_micro_game_description": "Automatisch nieuwe direct-play microgames toevoegen aan het dashboard."
            },
            "actions": {
                "create": {
                    "success": "Organisatie toegevoegd",
                    "failed": "Kan de organisatie niet toevoegen"
                },
                "update": {
                    "action": "Organisatie wijzigen",
                    "success": "Organisatie gewijzigd",
                    "failed": "Kan de organisatie niet wijzigen"
                },
                "delete": {
                    "action": "Organisatie verwijderen",
                    "confirm": "Bij het verwijderen van een organisatie verliest deze direct alle toegang. Weet je zeker dat je deze organisatie wilt verwijderen?",
                    "success": "Organisatie verwijderd",
                    "failed": "Kan de organisatie niet verwijderen"
                },
                "restore": {
                    "action": "Organisatie herstellen",
                    "confirm": "Bij het herstellen van een organisatie heeft deze direct weer toegang. Weet je zeker dat je deze organisatie wilt herstellen?",
                    "success": "Organisatie hersteld",
                    "failed": "Kan de organisatie niet herstellen"
                }
            },
            "customer_of": "Klant van :organisation",
            "embed_code": "Embed code",
            "embed_width": "Breedte",
            "embed_height": "Hoogte",
            "embed_portal": "Portal insluiten",
            "profile_sections_title": "Zichtbaarheid profiel",
            "profile_sections_description": "Selecteer de profiel onderdelen die voor de organisatie beschikbaar zijn.",
            "add_profile_section": "Voeg profiel onderdeel toe",
            "edit_profile_section": "Wijzig profiel onderdeel",
            "profile_sections": {
                "settings": "Instellingen",
                "take_aways": "Take-aways",
                "profile": "Profiel",
                "certificates": "Certificaten",
                "handouts": "Handouts"
            },
            "all_organisations": "Alle organisaties",
            "all_profile_sections_selected": "Je hebt momenteel alle profiel onderdelen toegevoegd",
            "take_away_sections_title": "Take away onderdelen",
            "take_away_sections_description": "Selecteer de take away onderdelen die voor de organisatie beschikbaar zijn.",
            "add_take_away_section": "Voeg take away onderdeel toe",
            "edit_take_away_section": "Wijzig take away onderdeel",
            "all_take_away_sections_selected": "Je hebt momenteel alle take way onderdelen toegevoegd",
            "take_away_sections": {
                "take_aways": "Take-aways",
                "questionnaires": "Questionnaires",
                "surveys": "Surveys"
            }
        },
        "pagination": {
            "next": "Volgende &raquo;",
            "previous": "&laquo; Vorige"
        },
        "passwords": {
            "reset": "Het wachtwoord van uw account is gewijzigd.",
            "sent": "We hebben een e-mail verstuurd met instructies om een nieuw wachtwoord in te stellen.",
            "throttled": "Gelieve even te wachten en het dan opnieuw te proberen.",
            "token": "Dit wachtwoordhersteltoken is niet geldig.",
            "user": "Geen gebruiker bekend met het e-mailadres."
        },
        "profile": {
            "profile": "Profiel",
            "your_profile": "Mijn profiel",
            "back_to_dashboard": "Terug naar dashboard",
            "update_profile": "Profiel wijzigen",
            "edit_profile": "Profiel bewerken",
            "delete_profile": "Profiel verwijderen",
            "properties": {
                "name": "Naam",
                "email": "E-mailadres",
                "password": "Wachtwoord",
                "password_confirmation": "Bevestig wachtwoord",
                "password_requirements": "Geef een nieuw wachtwoord op. Het nieuwe wachtwoord moet voldoen aan:",
                "password_minimal_characters": "Minimaal 8 karakters",
                "password_minimal_uppercase": "Minimaal 1 hoofdletter",
                "password_minimal_lowercase": "Minimaal 1 kleine letter",
                "password_minimal_number": "Minimaal 1 cijfer",
                "password_weak": "Zwak wachtwoord",
                "password_not_bad": "Niet slecht",
                "password_almost": "Je bent er bijna",
                "username": "Gebruikersnaam",
                "no_username": "Geen gebruikersnaam",
                "country": "Land",
                "avatar": "Avatar",
                "choose_avatar": "Kies avatar",
                "upload_own_avatar": "Upload eigen avatar",
                "edit_profile_photo": "Profielfoto bewerken",
                "photo": "Foto",
                "choose_photo": "Kies foto",
                "upload_photo": "Upload foto",
                "choose_language": "Kies taal",
                "change_language": "Taal bewerken",
                "change_password": "Wachtwoord wijzigen"
            },
            "demo": {
                "not_allowed": "Als demo-gebruiker mag je je profiel niet wijzigen."
            },
            "actions": {
                "update": {
                    "action": "Profiel opslaan",
                    "success": "Profiel opgeslagen",
                    "failed": "Kan het profiel niet wijzigen"
                },
                "update_password": {
                    "action": "Wachtwoord wijzigen"
                }
            },
            "filter": {
                "select_country": "Selecteer land",
                "select_avatar": "Selecteer avatar"
            },
            "stats": {
                "my_certificates": "Mijn certificaten",
                "no_certificates": "Op dit moment heb je nog geen certificaten. Je kunt certificaten verdienen door deel te nemen aan campagnes of microgames."
            }
        },
        "question": {
            "question": "Vraag",
            "questions": "Vragen",
            "question_description": "De speler krijgt deze vraag tijdens het spelen.",
            "no_answers": "Geen antwoorden",
            "template": "Template",
            "type": {
                "single": "Enkele keuze",
                "multiple": "Meerkeuze"
            },
            "properties": {
                "type": "Type",
                "feedback_correct": "Feedback goed",
                "feedback_wrong": "Feedback foutief",
                "feedback_correct_answer": "Feedback goed beantwoord",
                "feedback_wrong_answer": "Feedback foutief beantwoord",
                "content": "Content",
                "image": "Afbeelding",
                "image_select": "Selecteer afbeelding",
                "feedback": "Feedback",
                "feedback_edit": "Feedback bewerken",
                "feedback_description": "Na het beantwoorden van de vraag, kan de speler waardevolle feedback worden gegeven. Afhankelijk van het goed of fout beantwoorden van de vraag, kan verschillende feedback worden gegeven. Feedback is niet verplicht, maar kan het leertraject aanzienlijk verbeteren.",
                "excel_file": "Excel bestand",
                "file_select": "Selecteer bestand",
                "file": "Bestand"
            },
            "actions": {
                "create": {
                    "import": "Vragen importeren",
                    "action": "Vraag toevoegen",
                    "success": "Vraag toegevoegd",
                    "failed": "Kan de vraag niet toevoegen"
                },
                "update": {
                    "action": "Vraag wijzigen",
                    "success": "Vraag gewijzigd",
                    "failed": "Kan de vraag niet wijzigen"
                },
                "delete": {
                    "action": "Vraag verwijderen",
                    "confirm": "Het verwijderen van de vraag resulteert er direct in dat deze vraag niet meer wordt gesteld. Weet je zeker dat je deze vraag wilt verwijderen?",
                    "success": "Vraag verwijderd",
                    "failed": "Kan de vraag niet verwijderen"
                },
                "restore": {
                    "action": "Vraag herstellen",
                    "confirm": "Het herstellen van de vraag resulteert er in dat deze vraag direct weer zal worden gesteld aan de spelers. Weet je zeker dat je deze vraag wilt herstellen?",
                    "success": "Vraag hersteld",
                    "failed": "Kan de vraag niet herstellen"
                },
                "order": {
                    "success": "Volgorde van de vragen is gewijzigd"
                },
                "template": {
                    "download": "Template downloaden"
                },
                "import": {
                    "success": "Vragen toegevoegd",
                    "warning": "Let op! bestaande vragen worden niet aangepast en er wordt ook niet gekeken naar dubbelen vragen"
                },
                "export": {
                    "excel": "Export naar Excel"
                }
            },
            "validations": {
                "check_answer_first": "Controleer de antwoorden voordat je naar de volgende vraag gaat",
                "unable_check_answer": "Kan de antwoorden niet controleren",
                "provide_at_least_one_answer": "Geef minimaal 1 antwoord",
                "no_correct_answers": "Geen goed antwoord of alle antwoorden zijn goed"
            }
        },
        "questionnaire": {
            "questionnaire": "Questionnaire",
            "questionnaires": "Questionnaires",
            "create": "Nieuwe questionnaire",
            "edit": "Bewerk questionnaire",
            "select_type": "Type of questionnaire",
            "select_type_description": "Kies de questionnaire die van toepassing is.",
            "type": {
                "hypothesis": "Hypothesis",
                "multiple_choice": "Meerkeuze",
                "bat": "BAT-test",
                "coping": "Copingstijl test",
                "zeven_domeinen": "Zeven domeinen",
                "stress_test": "Stress test"
            },
            "properties": {
                "type": "Type",
                "type_description": "TODO: description",
                "title": "Titel",
                "description": "Omschrijving",
                "image": "Afbeelding",
                "cover_image": "Omslagfoto",
                "category": "Categorie",
                "category_title": "Titel",
                "category_image": "Afbeelding",
                "category_content": "Content",
                "question": "Vraag",
                "question_image": "Afbeelding",
                "answers": "Antwoorden",
                "answer": "Antwoord",
                "start_screen_title": "Titel",
                "start_screen_description": "Inhoud",
                "results_title": "Titel"
            },
            "steps": {
                "general_information": "Algemene informatie",
                "create_categories": "Categorie\u00ebn aanmaken",
                "create_questions": "Vragen aanmaken"
            },
            "override_existing_answers": "Overschrijf bestaande antwoorden bij opnieuw invullen",
            "create_categories": "Categorie\u00ebn aanmaken",
            "add_category": "Categorie toevoegen",
            "choose_category": "Kies categorie",
            "remove_category": "Categorie verwijderen",
            "create_questions": "Vragen aanmaken",
            "add_question": "Vraag toevoegen",
            "remove_question": "Vraag verwijderen",
            "define_score": "Score defini\u00ebren",
            "add_answer": "Antwoord toevoegen",
            "delete_question": "Vraag verwijderen",
            "confirm_delete_question": "Weet je zeker dat je deze vraag wilt verwijderen?",
            "delete_category": "Categorie verwijderen",
            "confirm_delete_category": "Weet je zeker dat je deze categorie wilt verwijderen?",
            "unknown_category_title": "Onbenoemde categorie",
            "back_to_campaign": "Terug naar campagne",
            "email_result": "Resultaat mailen",
            "email_sent": "De PDF wordt verstuurd naar jouw e-mailadres.",
            "email_sending_error": "Er is een fout opgetreden bij het versturen van de e-mail.",
            "download_results": "Download resultaat",
            "show_all_results": "Toon alle resultaten",
            "results": "Resultaten",
            "your_score": "Jouw score",
            "loading_questions": "Vragen inladen",
            "loading_results": "Resultaten inladen",
            "what_does_this_say_about_you": "Wat zegt dit over jou?",
            "start": "Start",
            "start_screen": "Beginscherm",
            "start_screen_description": "Als je deze leeg laat, vallen ze terug op de titel en omschrijving van de questionnaire.",
            "end_screen": "Eindscherm",
            "replay": "Opnieuw invullen",
            "advanced_settings": "Geavanceerde instellingen",
            "pdf": {
                "completed_on": "Voltooid op",
                "at": "om",
                "completed_on_date": "Voltooid op :date om :time",
                "results": "Jouw resultaat",
                "your_score": "Jouw resultaat"
            },
            "pdf_mail": {
                "subject": "Vragenlijst :name ingevuld",
                "intro": "Vragenlijst ingevuld",
                "text": "Je hebt de vragenlijst :name ingevuld. Bekijk in de bijlage jouw persoonlijk resultaat."
            },
            "unused_categories_answers": "De volgende categorie\u00ebn zijn niet gebruikt: :categories",
            "unused_categories_questions": "De volgende categorie\u00ebn zijn niet gebruikt: :categories",
            "categories_without_questions": "De volgende categorie\u00ebn hebben geen toegewezen vragen:",
            "categories_without_answers": "De volgende categorie\u00ebn hebben geen toegewezen antwoorden:",
            "validations": {
                "name": "titel",
                "description": "omschrijving",
                "category_id": "categorie",
                "points": "punten",
                "image": "afbeelding",
                "question": "vraag",
                "answer": "antwoord",
                "points_threshold": "drempelwaarde",
                "category_name": "titel",
                "category_content": "content",
                "start_screen_title": "beginscherm titel",
                "start_screen_description": "beginscherm inhoud",
                "selected": "geselecteerd",
                "divisor": "deler",
                "results_title": "titel van resultaten"
            },
            "bat": {
                "configuration": "Configuratie",
                "divisor": "Deler",
                "divisor_description": "Standaard: aantal geselecteerde vragen",
                "selected": "Deze vraag telt mee in de score berekening"
            },
            "coping": {
                "divisor": "Deler"
            },
            "actions": {
                "previous": "Vorige vraag",
                "next": "Volgende vraag"
            }
        },
        "quiz": {
            "quiz": "Quiz",
            "properties": {
                "title": "Titel",
                "description": "Omschrijving",
                "image": "Afbeelding",
                "question_image": "Afbeelding bij de vraag",
                "minimum_score": "Minimale score",
                "minimum_score_description": "Vul het minimale slagingspercentage in dat nodig is om de quiz succesvol te halen. Bijv. 75 betekent dat de speler minimaal 75% van de vragen goed moet beantwoorden.",
                "start_screen_title": "Titel",
                "start_screen_description": "Inhoud"
            },
            "steps": {
                "settings": "Instellingen",
                "questions": "Vragen"
            },
            "done": "De quiz is volledig beantwoord in deze sessie. Speel de sessie opnieuw om de quiz nogmaals te spelen.",
            "check_answer": "Controleer",
            "next_question": "Volgende vraag",
            "time_left": "Tijd over",
            "could_not_be_loaded": "De quiz kon niet geladen worden. Probeer het later opnieuw.",
            "start_quiz": "Start quiz",
            "max_answers_reached": "Maximum aantal antwoorden bereikt.",
            "create": "Nieuwe quiz",
            "edit": "Bewerk quiz",
            "add_question": "Vraag toevoegen",
            "add_answer": "Antwoord toevoegen",
            "add_answers": "Antwoorden toevoegen",
            "edit_question": "Vraag bewerken",
            "delete_question": "Vraag verwijderen",
            "confirm_delete_question": "Weet je zeker dat je deze vraag wilt verwijderen?",
            "delete_answer": "Antwoord verwijderen",
            "confirm_delete_answer": "Weet je zeker dat je dit antwoord wilt verwijderen?",
            "answers": "Antwoorden",
            "settings": "Instellingen",
            "advanced_settings": "Geavanceerde instellingen",
            "introduction": "Introductie",
            "start_screen": "Beginscherm",
            "start_screen_description": "Als je deze leeg laat, vallen ze terug op de titel en omschrijving van de quiz.",
            "passed": {
                "title": "Gefeliciteerd",
                "description": "Je hebt de quiz succesvol voltooid!"
            },
            "failed": {
                "title": "Helaas!",
                "description": "Je hebt minimaal :percentage% nodig om deze quiz te halen."
            },
            "validations": {
                "name": "naam",
                "description": "omschrijving",
                "image": "afbeelding",
                "question": "vraag",
                "questions": "vragen",
                "answer": "antwoord",
                "min_answers": "Minimaal 2 antwoorden zijn vereist.",
                "start_screen_title": "beginscherm titel",
                "start_screen_description": "beginscherm inhoud",
                "questions_required": "Je moet minimaal 1 vraag toevoegen.",
                "missing_questions": "Deze quiz heeft geen vragen. Voeg minimaal \u00e9\u00e9n vraag toe."
            }
        },
        "reseller": {
            "customer": "Klant",
            "customers": "Klanten",
            "actions": {
                "create": {
                    "action": "Klant toevoegen",
                    "success": "Klant toegevoegd",
                    "failed": "Kan de klant niet toevoegen"
                },
                "update": {
                    "action": "Klant wijzigen",
                    "success": "Klant gewijzigd",
                    "failed": "Kan de klant niet wijzigen"
                },
                "delete": {
                    "action": "Klant verwijderen",
                    "confirm": "Na het verwijderen van de klant verliest deze direct de toegang. Weet je zeker dat je deze klant wilt verwijderen?",
                    "success": "Klant verwijderd",
                    "failed": "Kan de klant niet verwijderen"
                },
                "restore": {
                    "action": "Klant herstellen",
                    "confirm": "Na het herstellen van de klant heeft deze direct weer toegang. Weet je zeker dat je deze klant wilt herstellen?",
                    "success": "Klant hersteld",
                    "failed": "Kan de klant niet herstellen"
                }
            },
            "validations": {
                "no_access": "Jouw organisatie is niet de reseller van deze klant"
            }
        },
        "skill": {
            "skill": "Vaardigheid",
            "skills": "Vaardigheden",
            "select_placeholder": "Selecteer vaardigheden",
            "management": {
                "description": "Een vaardigheid kan worden toegevoegd aan een module."
            },
            "properties": {
                "name": "Naam",
                "description": "Beschrijving",
                "show_on_graph": "Op grafiek laten zien"
            },
            "actions": {
                "create": {
                    "action": "Vaardigheid toevoegen",
                    "success": "Vaardigheid toegevoegd",
                    "failed": "Kan de vaardigheid niet toevoegen"
                },
                "update": {
                    "action": "Vaardigheid wijzigen",
                    "success": "Vaardigheid gewijzigd",
                    "failed": "Kan de vaardigheid niet wijzigen"
                },
                "delete": {
                    "action": "Vaardigheid verwijderen",
                    "confirm": "De vaardigheid zal worden verwijderd uit de campagne. Dit zorgt ervoor dat spelers de vaardigheid niet meer kunnen spelen en bekijken. Weet je zeker dat je de vaardigheid wilt verwijderen?",
                    "success": "Vaardigheid verwijderd",
                    "failed": "Kan de vaardigheid niet verwijderen"
                },
                "restore": {
                    "action": "Vaardigheid herstellen",
                    "confirm": "Na het herstellen van een vaardigheid is deze direct toegankelijk voor spelers. Weet je zeker dat je de vaardigheid wilt verwijderen?",
                    "success": "Vaardigheid hersteld",
                    "failed": "Kan de vaardigheid niet herstellen"
                }
            },
            "user_distribution": "Gebruikersverdeling",
            "validations": {
                "not_owned": "De vaardigheid is niet van de huidige organisatie",
                "unique": "De vaardigheid moet uniek zijn."
            }
        },
        "sso": {
            "sso": "Single Sign On",
            "no_sso": "Nog geen eenmalig inloggen ingesteld",
            "one_time_login": "Eenmalig inloggen",
            "authentication": "Authenticatie",
            "properties": {
                "name": "Knoptekst",
                "provider": "Provider",
                "login_url": "Login URL"
            },
            "sections": {
                "appearance": {
                    "title": "Verschijning",
                    "description": "Configureer hoe deze Single Sign On optie wordt getoond aan uw gebruikers op de loginpagina."
                },
                "configuration": {
                    "title": "Configuratie"
                }
            },
            "providers": {
                "google": {
                    "driver": "Google Workspace",
                    "properties": {
                        "client_id": "App ID",
                        "client_secret": "Client secret",
                        "domain": "Google Workspace domein"
                    },
                    "placeholders": {
                        "client_id": "*****.apps.googleusercontent.com",
                        "client_secret": "********"
                    }
                },
                "azure": {
                    "driver": "Azure AD",
                    "properties": {
                        "client_id": "Application (client) ID",
                        "client_secret": "Application secret",
                        "tenant": "Directory (tenant) ID"
                    },
                    "placeholders": {
                        "client_id": "00000000-0000-0000-0000-000000000000",
                        "client_secret": "********"
                    }
                },
                "oidc": {
                    "driver": "Generieke OIDC",
                    "description": "De <strong>:authorization_endpoint<\/strong>, <strong>:token_endpoint<\/strong> en <strong>:userinfo_endpoint<\/strong> zijn vereist indien <strong>:discovery_endpoint<\/strong> leeg is. Indien beide worden verstrekt, hebben de expliciet gedefinieerde eindpunten voorrang.",
                    "properties": {
                        "client_id": "App ID",
                        "client_secret": "Client secret",
                        "discovery_endpoint": "URL voor configuratiedetectie",
                        "authorization_endpoint": "Autorisatie endpoint",
                        "token_endpoint": "Token endpoint",
                        "userinfo_endpoint": "Gebruikersinformatie endpoint",
                        "id_key": "Uniek identifier attribuut op het user object"
                    },
                    "placeholders": {
                        "client_id": "",
                        "client_secret": ""
                    }
                },
                "adfs": {
                    "driver": "Active Directory Federation Services",
                    "description": "De <strong>:authorization_endpoint<\/strong>, <strong>:token_endpoint<\/strong> en <strong>:jwks_uri<\/strong> zijn vereist indien <strong>:discovery_endpoint<\/strong> leeg is. Indien beide worden verstrekt, hebben de expliciet gedefinieerde eindpunten voorrang.",
                    "properties": {
                        "client_id": "App ID",
                        "client_secret": "Gedeelde sleutel",
                        "discovery_endpoint": "URL voor configuratiedetectie",
                        "authorization_endpoint": "Autorisatie endpoint",
                        "token_endpoint": "Token endpoint",
                        "jwks_uri": "URL voor JSON Web Key Sets (JWKS)"
                    },
                    "placeholders": {
                        "client_id": "",
                        "client_secret": ""
                    }
                }
            },
            "actions": {
                "create": {
                    "action": "Eenmalig inloggen toevoegen",
                    "success": "SSO-configuratie gemaakt",
                    "failed": "Kan eenmalig inloggen niet aanmaken"
                },
                "update": {
                    "action": "Eenmalig inloggen bewerken",
                    "success": "Eenmalig inloggen bijgewerkt",
                    "failed": "Kan eenmalig inloggen niet bijwerken"
                },
                "delete": {
                    "action": "Eenmalig inloggen verwijderen",
                    "confirm": "Wanneer u eenmalig inloggen verwijdert, kan deze niet meer gebruikt worden om in te loggen met onmiddellijke ingang. Weet u zeker dat u door wilt gaan?",
                    "success": "Eenmalig inloggen verwijderd",
                    "failed": "Kan eenmalig inloggen niet verwijderen"
                }
            }
        },
        "stats": {
            "status": "Status",
            "playing": "Spelen",
            "completed": "Voltooid",
            "you": "Jij",
            "average_player": "Gemiddelde speler",
            "hours_play_time": "Speeltijd in uren",
            "modules_played": "Modules gespeeld",
            "experience": "Ervaring",
            "xp": "XP",
            "rewards": "Beloningen",
            "achievements": "Prestaties",
            "badges": "Insignes",
            "certificates": "Certificaten",
            "campaign_stats": "Campagne statistieken",
            "personal_stats": "Persoonlijke statistieken",
            "overal_stats": "Algemene statistieken",
            "average_score": "Gemiddelde score",
            "not_enough_data": "niet genoeg data",
            "xp_per_month": ":xp per maand",
            "xp_per_week": ":xp per week"
        },
        "survey": {
            "survey": "Survey",
            "surveys": "Surveys",
            "view_survey": "Survey bekijken",
            "insight_description": "Hier kan je de antwoorden per survey onderdeel bekijken. Daarnaast staat het aantal keer dat het antwoord is gegeven. De data kan worden ge\u00ebxporteerd via de knop bovenin.",
            "part_of_challenge": "Onderdeel van challenge",
            "part_of_campaign": "Onderdeel van campagne",
            "sessions": "Sessies",
            "type_descriptive": "Vraag\/Opdracht\/Statement",
            "options": "Opties",
            "provide_answer": "Geef je antwoord of reactie hieronder",
            "order": "Volgorde",
            "type": "Type",
            "question": "Vraag",
            "provided_answer": "Gegeven antwoord",
            "provided_at": "Geantwoord op",
            "provided_amount": "Aantal keer gegeven",
            "no_data": "Voor deze survey konden geen gegevens worden gevonden.",
            "start_screen": "Beginscherm",
            "start_screen_description": "Als je deze leeg laat, vallen ze terug op de titel en omschrijving van de survey.",
            "end_screen": "Eindscherm",
            "end_screen_description": "Als je deze leeg laat, wordt op het eindscherm \"Bedankt voor het invullen van de survey\" getoond.",
            "end_screen_title_fallback": "Bedankt voor het invullen van de survey",
            "properties": {
                "reaction": "Reactie",
                "reactions": "Reacties",
                "totally_disagree": "Totaal oneens",
                "disagree": "Oneens",
                "agree": "Eens",
                "totally_agree": "Totaal eens",
                "pdf_text": "PDF tekst",
                "pdf_text_description": "Deze tekst wordt gebruikt in de PDF die wordt gegenereerd van de survey resultaten.",
                "start_screen_title": "Titel beginscherm",
                "start_screen_description": "Beschrijving beginscherm",
                "end_screen_title": "Titel eindscherm",
                "end_screen_description": "Beschrijving eindscherm"
            },
            "validations": {
                "ensure_single_choice": "Minimaal 1 optie is verplicht",
                "ensure_multiple_choice": "Er zijn minimaal 2 opties verplicht"
            },
            "pdf_mail": {
                "subject": "Survey :survey_name ingevuld",
                "intro": "Survey ingevuld",
                "text": "Je hebt de survey \":survey_name\" ingevuld. Zie de bijlage om deze na te lezen."
            },
            "export_summary": "Samenvatting exporteren",
            "export_answers": "Responses exporteren"
        },
        "survey_entry": {
            "survey_entry": "Survey onderdeel",
            "survey_entries": "Survey onderdelen",
            "survey_entry_description": "De speler krijgt dit onderdeel te zien tijdens de survey.",
            "statement": "Stelling",
            "question_or_assignment": "Vraag\/Opdracht",
            "reaction_or_answer": "Reactie\/Antwoord",
            "specification": "Specificatie",
            "single_choice_description": "De speler kan een enkele reactie of antwoord geven op de vraag\/opdracht. Er moet minimaal 1 optie zijn.",
            "multiple_choice_description": "De speler kan meerdere reacties of antwoorden geven op de vraag\/opdracht. Er moeten minimaal 2 opties zijn.",
            "slider_description": "Bij een slider is er een minimale en maximale waardering. De slider heeft altijd een nauwkeurigheid van 1. Hoe groter het verschil, hoe meer nauwkeurig de speler antwoord kan geven.",
            "statement_description": "Een speler kan reageren op een statement. De minimale waardering zegt dat de speler het er absoluut oneens mee is, de maximale waardering dat deze het er absoluut mee eens is. Hoe groter het verschil, hoe meer nauwkeurig de speler antwoord kan geven.",
            "optional_description": "Als de vraag als optioneel is gemarkeerd kan de speler het antwoord leeg laten.",
            "properties": {
                "minimal_valuation": "Minimale waardering",
                "maximal_valuation": "Maximale waardering",
                "min_text": "Min tekst",
                "max_text": "Max tekst",
                "image": "Afbeelding",
                "image_select": "Selecteer een afbeelding"
            },
            "actions": {
                "create": {
                    "action": "Survey onderdeel toevoegen",
                    "success": "Survey onderdeel toegevoegd",
                    "failed": "Kan het survey onderdeel niet toevoegen"
                },
                "update": {
                    "action": "Survey onderdeel wijzigen",
                    "success": "Survey onderdeel gewijzigd",
                    "failed": "Kan het survey onderdeel niet wijzigen"
                },
                "delete": {
                    "action": "Survey onderdeel verwijderen",
                    "confirm": "Na het verwijderen van dit survey onderdeel wordt deze direct niet meer aangeboden aan de spelers. Weet je zeker dat je dit survey onderdeel wilt verwijderen?",
                    "success": "Survey onderdeel verwijderd",
                    "failed": "Kan het survey onderdeel niet verwijderen"
                },
                "restore": {
                    "action": "Survey onderdeel herstellen",
                    "confirm": "Na het herstellen van dit survey onderdeel wordt deze direct weer aangeboden aan de spelers. Weet je zeker dat je dit survey onderdeel wilt herstellen?",
                    "success": "Survey onderdeel hersteld",
                    "failed": "Kan het survey onderdeel niet herstellen"
                },
                "order": {
                    "success": "De volgorde van de survey onderdelen is gewijzigd",
                    "failed": "Kan de volgorde van de survey onderdelen niet wijzigen"
                }
            }
        },
        "tag": {
            "tag": "Label",
            "tags": "Labels",
            "edit_tags": "Labels bewerken",
            "select_placeholder": "Selecteer label",
            "select_all": "Alle labels",
            "assigned_users": "Toegekende gebruikers",
            "management": {
                "description": "Een label kan worden toegevoegd aan een gebruiker."
            },
            "properties": {
                "name": "Naam",
                "identifier": "Identifier",
                "description": "Beschrijving"
            },
            "actions": {
                "create": {
                    "action": "Label toevoegen",
                    "success": "Label toegevoegd",
                    "failed": "Kan de label niet toevoegen"
                },
                "update": {
                    "action": "Label wijzigen",
                    "success": "Label gewijzigd",
                    "failed": "Kan de label niet wijzigen"
                },
                "delete": {
                    "action": "Label verwijderen",
                    "confirm": "De label zal worden verwijderd uit de campagne en bij de gebruikers. Weet je zeker dat je de label wilt verwijderen?",
                    "success": "Label verwijderd",
                    "failed": "Kan de label niet verwijderen",
                    "failed_in_use_by_onboarding": "De tag kan niet worden verwijderd omdat deze nog in gebruik is door een onboarding antwoord."
                },
                "restore": {
                    "action": "Label herstellen",
                    "confirm": "Na het herstellen van een label is deze direct toegankelijk voor spelers. Weet je zeker dat je de label wilt verwijderen?",
                    "success": "Label hersteld",
                    "failed": "Kan de label niet herstellen"
                },
                "bulk": {
                    "action": "Bulk labels",
                    "success_assign": "Label toegekend aan gebruikers",
                    "success_revoke": "Label verwijderd van gebruikers"
                }
            },
            "validations": {
                "not_owned": "Het label is niet van de huidige organisatie",
                "user_missing_tag": "Het label kan niet worden verwijderd aangezien deze niet is toegekend aan gebruikers",
                "user_missing_organisation": "Het label kan niet worden toegevoegd aan een gebruiker die niet aan dezelfde organisatie is gekoppeld"
            },
            "onboarding": {
                "title": "Labels vanuit onboarding",
                "description": "Deze labels zijn automatisch toegewezen aan de gebruiker op basis van hun onboarding antwoorden. Deze labels kunnen niet ingetrokken worden tenzij de gebruiker diens antwoord aanpast.",
                "description_secondary": "Indien je een label toewijst dat al is toegewezen vanuit de onboarding, zal deze worden omgezet naar een handmatig toegewezen label. Dit label wordt niet meer automatisch ingetrokken als de gebruiker diens antwoord aanpast."
            }
        },
        "take_away": {
            "take_away": "Take away",
            "take_aways": "Take aways",
            "policy": {
                "denied": "Je bent niet gemachtigd om deze Take away te beheren"
            },
            "actions": {
                "create": {
                    "failed": "Kan de Take away niet maken"
                },
                "update": {
                    "failed": "Kan de Take away niet bijwerken"
                }
            }
        },
        "take_away_session": {
            "policy": {
                "denied": "Je bent niet gemachtigd om deze Take away sessie te beheren"
            },
            "actions": {
                "create": {
                    "failed": "Kan de Take away sessie niet maken"
                },
                "update": {
                    "failed": "Kan de Take away sessie niet bijwerken"
                },
                "results": {
                    "failed": "Kan de resultaten van de Take away niet genereren"
                }
            },
            "pdf_mail": {
                "subject": "Take away :name",
                "intro": "Take away",
                "text": "Je hebt de take away :name ingevuld. Bekijk in de bijlage jouw persoonlijk resultaat."
            }
        },
        "theme": {
            "theme": "Thema",
            "themes": "Thema's",
            "manage": "Beheren",
            "manage_organisation_theme": "Beheer organisatie thema",
            "fonts": "Lettertypes",
            "font_description": "Dit zorgt ervoor dat het thema de klant zijn lettertype gebruikt.",
            "primary_font": "Primaire lettertype",
            "secondary_font": "Secondaire lettertype",
            "colors": "Kleuren",
            "color_description": "Dit zorgt ervoor dat het thema de klant zijn kleuren gebruikt.",
            "primary_color": "Primaire kleur",
            "secondary_color": "Secondaire kleur",
            "accent_color": "Accent kleur",
            "card_style": "Kaart stijl",
            "card_style_description": "Dit zorgt ervoor dat het thema past bij de huisstijl van de klant.",
            "border_radius": "Rand ronding",
            "edit_save_button": "Wijzigingen opslaan"
        },
        "tournament": {
            "status": {
                "currently_busy": "Nu bezig",
                "done": "Afgelopen"
            }
        },
        "translation": {
            "translations": "Vertalingen",
            "translation": "Vertaling",
            "properties": {
                "key": "Systeemsleutel",
                "message": "Tekst"
            },
            "filter": {
                "all_locales": "Alle talen",
                "locale": "Taal"
            },
            "actions": {
                "update": {
                    "success": "Vertaling bijgewerkt",
                    "failed": "Kan de vertaling niet bijwerken"
                }
            }
        },
        "user": {
            "user": "Gebruiker",
            "users": "Gebruikers",
            "user_count": ":count gebruiker|:count gebruikers",
            "demo_user": "Gast-gebruiker",
            "demo_user_not_allowed": "Spelen als demo-gebruiker is niet ingeschakeld",
            "demo_user_not_possible": "Spelen als demo-gebruiker is momenteel niet mogelijk",
            "demo_user_notice": "Je speelt als gast-gebruiker. Let op: je score wordt niet opgeslagen. Vraag aan je leidinggevende om een account dat je progressie en score kan bijhouden.",
            "demo_user_notice_no_upgrade": "Je speelt als gast-gebruiker. Let op: je score wordt niet opgeslagen. Vraag aan je leidinggevende om een account dat je progressie en score kan bijhouden.",
            "administrator": "Administrator",
            "administrator_description": "Een administrator mag de gehele applicatie beheren. Ken deze rol alleen toe als je het zeker weet!",
            "manager": "Manager",
            "manager_description": "Een manager mag de gebruikers en campagnes van de organisatie beheren.",
            "name": "Naam",
            "email": "E-mail adres",
            "password": "Wachtwoord",
            "password_create": "Laat het wachtwoord leeg om automatisch een wachtwoord te genereren.",
            "password_edit": "Laat het wachtwoord leeg om deze niet te wijzigen.",
            "password_confirm": "Bevestig wachtwoord",
            "expires_at": "Verloopt op",
            "language": "Voorkeurstalen",
            "language_description": "Voeg je talen toe en sorteer ze op voorkeur. Mocht een organisatie waar jij lid van bent geen van deze talen ondersteunen, dan wordt de site weergegeven in de standaardtaal van de organisatie.",
            "add_preferred_language": "Voorkeurstaal toevoegen",
            "tags": "Labels",
            "permissions": "Permissies",
            "edit_user_roles": "Rollen bewerken",
            "select_placeholder": "Selecteer gebruikers",
            "is_manager": "Is manager",
            "is_administrator": "Is administrator",
            "is_anonymous": "Is demo-gebruiker",
            "added_at": "Toegevoegd op",
            "user_added": "Gebruiker toegevoegd",
            "modified_at": "Gewijzigd op",
            "last_modified": "Laatst gewijzigd",
            "unable_to_create": "Kan de gebruiker niet toevoegen",
            "unable_to_create_is_integration": "Kan de gebruiker niet maken omdat deze al bestaat als integratiegebruiker",
            "unable_to_create_membership": "Kan de gebruiker niet toevoegen aan de organisatie",
            "invite_sent": "Uitnodiging verstuurd",
            "unable_to_sent_invite": "Kan de uitnodiging niet versturen",
            "invite_sent_again": "Uitnodiging opnieuw verstuurd",
            "invite_accepted": "Uitnodiging geaccepteerd! Welkom bij :app",
            "invite_removed": "Uitnodiging verwijderd",
            "unable_to_remove_invite": "Kan de uitnodiging niet verwijderen",
            "create": "Gebruiker toevoegen",
            "created": "Gebruiker toegevoegd",
            "created_without_rights": "Gebruiker toegevoegd maar kan de rechten niet opslaan",
            "created_without_membership": "Gebruiker toegevoegd maar kan de gebruiker niet toevoegen aan de organisatie",
            "created_with_password": "Gebruiker toegevoegd met het wachtwoord <code>:password<\/code>",
            "updated": "Gebruiker gewijzigd",
            "updated_without_rights": "Gebruiker gewijzigd maar kan de rechten niet opslaan",
            "unable_to_update": "Kan de gebruiker niet wijzigen",
            "remove": "Gebruiker verwijderen",
            "remove_confirmation": "De gebruiker wordt verwijderd uit de organisatie en verliest direct de toegang. Weet je zeker dat je de gebruiker wilt verwijderen?",
            "removed": "Gebruiker verwijderd",
            "unable_to_remove": "Kan de gebruiker niet verwijderen",
            "invalid_email_address": "Ongeldig e-mail adres",
            "invalid_password": "Wachtwoord voldoet niet aan de gestelde voorwaarden",
            "invalid_language": "Taal is ongeldig",
            "tag_does_not_exist": "De tag \":tag\" kan niet worden toegevoegd omdat deze niet bestaat",
            "email_or_name_required": "Een e-mail adres of naam is verplicht",
            "invites": "Uitnodigingen",
            "invite": "Uitnodigen",
            "accept_invite": "Accepteer uitnodiging",
            "accept_invite_description": "Om je registratie te voltooien, hebben we nog wat informatie nodig.",
            "invalid_invite": "Ongeldige uitnodiging",
            "invalid_invite_description": "Sorry, maar de token is ongeldig of de uitnodiging is verlopen. Vraag je instructeur om een nieuwe uitnodiging.",
            "revoke_invite": "Uitnodiging intrekken",
            "revoke_invite_description": "Na het intrekken van de uitnodiging is de ontvanger niet meer in staat om de uitnodiging te accepteren. Weet je zeker dat je de uitnodiging wilt intrekken?",
            "send_invite": "Verstuur uitnodiging",
            "invite_description": "Het opgegeven e-mail adres zal een uitnodiging voor deze organisatie ontvangen per e-mail.",
            "invite_email_exists": "Het opgegeven e-mail adres mag nog geen account hebben.",
            "import": "Importeren",
            "import_file": "Bronbestand",
            "import_file_select": "Selecteer bronbestand",
            "import_file_description": "Het bestand moet een CSV of Excel bestand zijn en hoeft niet te voldoen aan een bepaalde structuur. In de volgende stap kan je bepalen welke informatie in welke kolommen staat.",
            "import_file_description_existing_user": "Wanneer een gebruiker al een account heeft voor de :app, zal het account worden toegevoegd aan deze organisatie.",
            "import_users": "Importeer gebruikers",
            "imported_users": "Gebruikers ge\u00efmporteerd",
            "import_determine_columns": "Bepaal kolommen",
            "import_results": "Resultaten",
            "import_select_file": "Selecteer bestaand",
            "import_existing_user": "Bestaande gebruiker",
            "import_message": "Bericht",
            "import_column": "Kolom",
            "import_ignore_column": "Negeer kolom",
            "import_skip_first_row": "Sla eerste regel over",
            "import_skip_first_row_description": "Handig voor wanneer de eerste regel een header bevat.",
            "import_preview_stats": "Er zijn <code>:rows<\/code> regels gevonden en er worden <code>:preview<\/code> regels weergegeven in het voorbeeld.",
            "user_profile": "Gebruikersprofiel",
            "add_user": "Gebruiker toevoegen",
            "edit_user": "Gebruiker bewerken",
            "user_role": "Gebruikersrol",
            "user_roles": "Gebruikersrollen",
            "account_settings": "Account instellingen",
            "personal_details": "Pesoonlijke details",
            "import_user_not_imported": "Gebruiker niet ge\u00efmporteerd",
            "import_user_imported_with_warnings": "Gebruiker ge\u00efmporteerd met waarschuwingen",
            "import_user_imported": "Gebruiker ge\u00efmporteerd",
            "import_only_existing_tags": "Alleen <a href=\":manage_labels\">labels<\/a> die bestaan worden toegevoegd aan gebruikers. Zorg ervoor dat alle labels die u wilt importeren bestaan voordat u importeert.",
            "validations": {
                "must_be_part_of_organisation": "De gebruiker moet onderdeel zijn van de organisatie",
                "must_not_be_part_of_organisation": "De gebruiker mag geen onderdeel zijn van de organisatie"
            },
            "invitation": {
                "subject": "Uitnodiging voor :app",
                "intro": "Uitnodiging :app",
                "text": "Hierbij een uitnodiging voor :app namens :organisation. Accepteer de uitnodiging via onderstaande link om een account te maken en te starten met spelen.",
                "valid_until": "Deze uitnodiging is geldig tot :expires_at.",
                "enjoy": "Veel plezier!",
                "accept": "Uitnodiging accepteren"
            },
            "actions": {
                "delete": {
                    "action": "Verwijder profiel",
                    "confirm": "Als je je profiel verwijdert, kun je niet meer spelen. Als je bent ingelogd met je bedrijfsaccount, heb je de volgende keer dat je inlogt geen voortgang meer. Weet je zeker dat je door wilt gaan?",
                    "success": "Profiel verwijderd",
                    "failed": "Kan je profiel niet verwijderen",
                    "warning": "Het verwijderen van je profiel is definitief"
                }
            },
            "roles": {
                "reseller": {
                    "name": "Reseller",
                    "description": "Gamemasters van partners"
                },
                "manager": {
                    "name": "Manager",
                    "description": "Manager voor organisatie"
                },
                "user": {
                    "name": "Gebruiker",
                    "description": "Client\/werknemer\/gebruiker"
                },
                "administrator": {
                    "name": "Administrator",
                    "description": "Administrator"
                }
            },
            "not_visible_by_demo_user": "Niet zichtbaar voor demo gebruikers",
            "cannot_be_admin_because_sso": "Deze gebruiker heeft gekoppelde SSO identiteiten en mag dus geen administrator zijn uit veiligheidsoverwegingen.",
            "sso_user": "SSO gebruiker",
            "password_change_not_possible": "Het is niet mogelijk om het wachtwoord van deze gebruiker aan te passen.",
            "roles_change_not_possible": "Het is niet mogelijk om de rollen van deze gebruiker aan te passen.",
            "integration_user": "Integratie-gebruiker",
            "user_status": "Gebruikersstatus",
            "anonymous_users": "Anonieme gebruikers",
            "non_anonymous_users": "Niet-anonieme gebruikers"
        },
        "validation": {
            "accepted": ":Attribute moet worden geaccepteerd.",
            "accepted_if": ":Attribute moet worden geaccepteerd als :other :value is.",
            "active_url": ":Attribute is geen geldige URL.",
            "after": ":Attribute moet een datum na :date zijn.",
            "after_or_equal": ":Attribute moet een datum na of gelijk aan :date zijn.",
            "alpha": ":Attribute mag alleen letters bevatten.",
            "alpha_dash": ":Attribute mag alleen letters, nummers, underscores (_) en streepjes (-) bevatten.",
            "alpha_num": ":Attribute mag alleen letters en nummers bevatten.",
            "array": ":Attribute moet geselecteerde elementen bevatten.",
            "ascii": "De :attribute mag alleen alfanumerieke tekens en symbolen van \u00e9\u00e9n byte bevatten.",
            "attached": "Dit :attribute is al gekoppeld.",
            "before": ":Attribute moet een datum v\u00f3\u00f3r :date zijn.",
            "before_or_equal": ":Attribute moet een datum v\u00f3\u00f3r of gelijk aan :date zijn.",
            "between": {
                "array": ":Attribute moet tussen :min en :max waardes bevatten.",
                "file": ":Attribute moet tussen :min en :max kilobytes zijn.",
                "numeric": ":Attribute moet tussen :min en :max zijn.",
                "string": ":Attribute moet tussen :min en :max karakters zijn."
            },
            "boolean": ":Attribute moet ja of nee zijn.",
            "can": "Het veld :attribute bevat een niet-geautoriseerde waarde.",
            "confirmed": "Bevestiging van :attribute komt niet overeen.",
            "contains": ":Attribute mist een verplichte waarde.",
            "current_password": "Huidig wachtwoord is onjuist.",
            "date": ":Attribute moet een datum bevatten.",
            "date_equals": ":Attribute moet een datum gelijk aan :date zijn.",
            "date_format": ":Attribute voldoet niet aan het formaat :format.",
            "decimal": "De :attribute moet :decimal decimalen hebben.",
            "declined": ":Attribute moet afgewezen worden.",
            "declined_if": ":Attribute moet afgewezen worden wanneer :other gelijk is aan :value.",
            "different": ":Attribute en :other moeten verschillend zijn.",
            "digits": ":Attribute moet bestaan uit :digits cijfers.",
            "digits_between": ":Attribute moet bestaan uit minimaal :min en maximaal :max cijfers.",
            "dimensions": ":Attribute heeft geen geldige afmetingen voor afbeeldingen.",
            "distinct": ":Attribute heeft een dubbele waarde.",
            "doesnt_end_with": ":Attribute mag niet eindigen met \u00e9\u00e9n van de volgende waarden: :values.",
            "doesnt_start_with": ":Attribute mag niet beginnen met \u00e9\u00e9n van de volgende waarden: :values.",
            "email": ":Attribute is geen geldig e-mailadres.",
            "ends_with": ":Attribute moet met \u00e9\u00e9n van de volgende waarden eindigen: :values.",
            "enum": "Gekozen :attribute is ongeldig.",
            "exists": ":Attribute bestaat niet.",
            "extensions": ":Attribute moet een bestandstype hebben van: :values.",
            "file": ":Attribute moet een bestand zijn.",
            "filled": ":Attribute is verplicht.",
            "gt": {
                "array": ":Attribute moet meer dan :value waardes bevatten.",
                "file": ":Attribute moet groter zijn dan :value kilobytes.",
                "numeric": ":Attribute moet groter zijn dan :value.",
                "string": ":Attribute moet meer dan :value tekens bevatten."
            },
            "gte": {
                "array": ":Attribute moet :value of meer waardes bevatten.",
                "file": ":Attribute moet groter of gelijk zijn aan :value kilobytes.",
                "numeric": ":Attribute moet groter of gelijk zijn aan :value.",
                "string": ":Attribute moet minimaal :value tekens bevatten."
            },
            "hex_color": ":Attribute moet een geldige hexadecimale kleur zijn.",
            "image": ":Attribute moet een afbeelding zijn.",
            "in": ":Attribute is ongeldig.",
            "in_array": ":Attribute bestaat niet in :other.",
            "integer": ":Attribute moet een getal zijn.",
            "ip": ":Attribute moet een geldig IP-adres zijn.",
            "ipv4": ":Attribute moet een geldig IPv4-adres zijn.",
            "ipv6": ":Attribute moet een geldig IPv6-adres zijn.",
            "json": ":Attribute moet een geldige JSON-string zijn.",
            "list": ":Attribute moet een lijst zijn.",
            "lowercase": ":Attribute mag alleen kleine letters bevatten.",
            "lt": {
                "array": ":Attribute moet minder dan :value waardes bevatten.",
                "file": ":Attribute moet kleiner zijn dan :value kilobytes.",
                "numeric": ":Attribute moet kleiner zijn dan :value.",
                "string": ":Attribute moet minder dan :value tekens bevatten."
            },
            "lte": {
                "array": ":Attribute moet :value of minder waardes bevatten.",
                "file": ":Attribute moet kleiner of gelijk zijn aan :value kilobytes.",
                "numeric": ":Attribute moet kleiner of gelijk zijn aan :value.",
                "string": ":Attribute moet maximaal :value tekens bevatten."
            },
            "mac_address": ":Attribute moet een geldig MAC-adres zijn.",
            "max": {
                "array": ":Attribute mag niet meer dan :max waardes bevatten.",
                "file": ":Attribute mag niet meer dan :max kilobytes zijn.",
                "numeric": ":Attribute mag niet hoger dan :max zijn.",
                "string": ":Attribute mag niet uit meer dan :max tekens bestaan."
            },
            "max_digits": ":Attribute mag niet uit meer dan :max cijfers bestaan.",
            "mimes": ":Attribute moet een bestand zijn van het bestandstype :values.",
            "mimetypes": ":Attribute moet een bestand zijn van het bestandstype :values.",
            "min": {
                "array": ":Attribute moet minimaal :min waardes bevatten.",
                "file": ":Attribute moet minimaal :min kilobytes zijn.",
                "numeric": ":Attribute moet minimaal :min zijn.",
                "string": ":Attribute moet minimaal :min tekens zijn."
            },
            "min_digits": ":Attribute moet minimaal uit :min cijfers bestaan.",
            "missing": "Het veld :attribute moet ontbreken.",
            "missing_if": "Het veld :attribute moet ontbreken als :other :value is.",
            "missing_unless": "Het veld :attribute moet ontbreken, tenzij :other :value is",
            "missing_with": "Het veld :attribute moet ontbreken wanneer :values aanwezig is.",
            "missing_with_all": "Het veld :attribute moet ontbreken wanneer er :values aanwezig zijn.",
            "multiple_of": ":Attribute moet een veelvoud van :value zijn.",
            "not_in": ":Attribute is ongeldig.",
            "not_regex": "Het formaat van :attribute is ongeldig.",
            "numeric": ":Attribute moet een getal zijn.",
            "password": {
                "letters": ":Attribute moet minimaal \u00e9\u00e9n letter bevatten.",
                "mixed": ":Attribute moet minimaal \u00e9\u00e9n kleine letter en \u00e9\u00e9n hoofdletter bevatten.",
                "numbers": ":Attribute moet minimaal \u00e9\u00e9n cijfer bevatten.",
                "symbols": ":Attribute moet minimaal \u00e9\u00e9n vreemd teken bevatten.",
                "uncompromised": "Het opgegeven :attribute komt voor in een datalek. Kies een ander :attribute."
            },
            "present": ":Attribute moet aanwezig zijn.",
            "present_if": ":Attribute moet aanwezig zijn als :other :value is.",
            "present_unless": ":Attribute moet aanwezig zijn tenzij :other :values is.",
            "present_with": ":Attribute moet aanwezig zijn als :values aanwezig is.",
            "present_with_all": ":Attribute moet aanwezig zijn als :values aanwezig zijn.",
            "prohibited": ":Attribute is niet toegestaan.",
            "prohibited_if": ":Attribute is niet toegestaan indien :other gelijk is aan :value.",
            "prohibited_unless": ":Attribute is niet toegestaan tenzij :other gelijk is aan :values.",
            "prohibits": ":Attribute is niet toegestaan in combinatie met :other.",
            "relatable": ":Attribute is niet gerelateerd aan deze bron.",
            "regex": "Het formaat van :attribute is ongeldig.",
            "required": ":Attribute is verplicht.",
            "required_array_keys": ":Attribute moet waardes bevatten voor :values.",
            "required_field": "Dit veld is verplicht.",
            "required_if": ":Attribute is verplicht indien :other gelijk is aan :value.",
            "required_if_accepted": ":Attribute is verplicht indien :other is geaccepteerd.",
            "required_if_declined": ":Attribute is verplicht indien :other is afgewezen.",
            "required_unless": ":Attribute is verplicht tenzij :other gelijk is aan :values.",
            "required_with": ":Attribute is verplicht in combinatie met :values.",
            "required_with_all": ":Attribute is verplicht in combinatie met :values.",
            "required_without": ":Attribute is verplicht als :values niet ingevuld is.",
            "required_without_all": ":Attribute is verplicht als :values niet ingevuld zijn.",
            "rgba_color": "Het veld :attribute moet een geldige Rgba kleur bevatten",
            "rgba_color_white": "Het veld :attribute mag niet wit zijn",
            "same": ":Attribute en :other moeten overeenkomen.",
            "scalar": ":Attribute moet een getal, tekst of boolean waarde zijn.",
            "size": {
                "array": ":Attribute moet :size waardes bevatten.",
                "file": ":Attribute moet :size kilobytes groot zijn.",
                "numeric": ":Attribute moet :size zijn.",
                "string": ":Attribute moet :size tekens zijn."
            },
            "starts_with": ":Attribute moet beginnen met een van de volgende: :values.",
            "string": ":Attribute moet een tekst zijn.",
            "timezone": ":Attribute moet een geldige tijdzone zijn.",
            "ulid": "De :attribute moet een geldige ULID zijn.",
            "unique": ":Attribute is al in gebruik.",
            "unique_archived": ":Attribute bestaat al in een gearchiveerde :model",
            "uploaded": "Het uploaden van :attribute is mislukt.",
            "uppercase": ":Attribute mag alleen hoofdletters bevatten.",
            "url": ":Attribute moet een geldige URL zijn.",
            "uuid": ":Attribute moet een geldige UUID zijn.",
            "not_valid_in_values": ":Attribute is geen geldige waarde. Gebruik een van de volgende waarden :values",
            "youtube_video_url": ":Attribute moet een geldige YouTube video URL bevatten.",
            "vimeo_video_url": ":Attribute moet een geldige Vimeo video URL bevatten.",
            "custom_field_key_required": "De naam is verplicht wanneer de waarde is ingevuld.",
            "custom_field_key_string": "De waarde moet een tekst zijn.",
            "custom_field_value_required": "De waarde is verplicht wanneer de naam is ingevuld.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "primary_color": "Primaire kleur",
                "secondary_color": "Secondaire kleur",
                "primary_font_color": "Primaire lettertype kleur",
                "secondary_font_color": "Secondaire lettertype kleur",
                "primary_font_family": "Primaire lettertype",
                "secondary_font_family": "Secondaire lettertype",
                "available_languages": "Beschikbare talen",
                "is_global": "Globale Micro Game",
                "organisations": "Organisaties",
                "start_date": "Startdatum",
                "end_date": "Einddatum",
                "confirm": "Bevestiging",
                "total_questions_used": "Aantal te tonen vragen",
                "file": "Bestand",
                "size": "Grootte"
            }
        },
        "webhook": {
            "webhook": "Webhook",
            "webhooks": "Webhooks",
            "trigger": "Trigger webhook",
            "description": "Overzicht van gefaalde webhooks.",
            "events": "Events",
            "response": "Response",
            "select": {
                "organisation": "Selecteer een organisatie",
                "event": "Selecteer een event"
            },
            "properties": {
                "start_date": "Startdatum",
                "end_date": "Einddatum",
                "url": "URL",
                "event": "Event",
                "status": "Status code",
                "status_message": "Status bericht",
                "created_at": "Datum",
                "payload": "Payload"
            },
            "events_sent_successfully": "Webhook events die verstuurd zijn tussen :startDate en :endDate zijn opnieuw verstuurd",
            "amount_of_calls": "Aantal webhook calls"
        }
    }
};